
export const SRIDEVI = {


 "12/26/2022 to 01/01/2023": [
    [245, 16, 169],
    [460, "03", 256],
    [338, 41, 236],
    [880, 69, 225],
    [147, 20, 145],
    [248, 44, 356],
    [125, 87, 188]
  ],
  "01/02/2023 to 01/08/2023": [
    [480, 27, 124],
    [677, "09", 577],
    [120, 36, 448],
    [180, 92, 345],
    [125, 87, 188],
    [338, 41, 236],
    [368, 74, 167]
  ],
  "01/09/2023 to 01/15/2023": [
    [559, 98, 260],
    [880, 69, 225],
    [489, 12, 200],
    [290, 17, 188],
    [249, 51, 128],
    [460, "03", 256],
    [369, 88, 378]
  ],
  "01/16/2023 to 01/22/2023": [
    [679, 24, 149],
    [345, 28, 233],
    [380, 13, 689],
    [248, 44, 356],
    [127, "05", 140],
    [568, 90, 578],
    [579, 13, 670]
  ],
  "01/23/2023 to 01/29/2023": [
    [470, 11, 344],
    [347, 45, 690],
    [380, 13, 689],
    [268, 65, 456],
    [147, 20, 145],
    [170, 88, 459],
    [115, 72, 129]
  ],
  "01/30/2023 to 02/05/2023": [
    [479, "05", 159],
    [189, 84, 220],
    [123, 62, 390],
    [190, "05", 447],
    [670, 32, 138],
    [347, 45, 690],
    [156, 24, 789]
  ],

 "02/06/2023 to 02/12/2023": [
    [267, 59, 360],
    [249, 54, 356],
    [156, 26, 457],
    [146, 12, 237],
    [288, 80, 668],
    [349, 63, 157],
    [139, 35, 230]
  ],
  "02/13/2023 to 02/19/2023": [
    [257, 49, 289],
    [778, 29, 135],
    [288, 85, 780],
    [389, "08", 134],
    [125, 86, 600],
    [148, 38, 279],
    [137, 19, 478]
  ],
  "02/20/2023 to 02/26/2023": [
    [466, 67, 278],
    [457, 65, 177],
    [348, 52, 679],
    [467, 72, 147],
    [235, "07", 368],
    [577, 94, 167],
    [359, 71, 146]
  ],
  "02/27/2023 to 03/05/2023": [
    [590, 49, 379],
    [358, 68, 468],
    [357, 55, 780],
    [579, 11, 245],
    [570, 20, 460],
    [225, 90, 389],
    [778, 28, 369]
  ],
  "03/06/2023 to 03/12/2023": [
    [348, 52, 679],
    [357, 55, 780],
    [459, 87, 269],
    [390, 20, 479],
    [278, 76, 169],
    [178, 66, 268],
    [350, 89, 180]
  ],
  "03/13/2023 to 03/19/2023": [
    [145, 0, 280],
    [337, 39, 234],
    [235, "05", 168],
    [459, 87, 269],
    [345, 28, 125],
    [456, 52, 237],
    [789, 48, 567]
  ],
"03/20/2023 to 03/26/2023": [
  [370, 0, 370],
  [158, 46, 790],
  [347, 40, 226],
  [470, 18, 279],
  [138, 23, 580],
  [370, "03", 247],
  [160, 79, 289]
],
"03/27/2023 to 04/02/2023": [
  [589, 27, 359],
  [137, 13, 247],
  [489, 15, 348],
  [260, 89, 270],
  [158, 42, 147],
  [600, 63, 120],
  [248, 42, 589]
],
"04/03/2023 to 04/09/2023": [
  [569, "01", 678],
  [370, "01", 399],
  [477, 87, 467],
  [234, 97, 467],
  [366, 55, 230],
  [389, "05", 258],
  [789, 49, 667]
],
"04/10/2023 to 04/16/2023": [
  [157, 39, 469],
  [134, 80, 280],
  [567, 80, 460],
  [180, 93, 788],
  [126, 97, 458],
  [360, 97, 359],
  [145, "07", 269]
],
"04/17/2023 to 04/23/2023": [
  [357, 51, 579],
  [680, 45, 348],
  [345, 24, 590],
  [678, 11, 146],
  [167, 40, 190],
  [556, 66, 240],
  [449, 71, 344]
],
"04/24/2023 to 04/30/2023": [
  [799, 53, 355],
  [477, 88, 116],
  [137, 17, 269],
  [170, 81, 290],
  [578, "07", 377],
  [568, 97, 890],
  [468, 85, 456]
],
"05/01/2023 to 05/07/2023": [
  [256, 39, 135],
  [260, 88, 378],
  [679, 21, 245],
  [569, "01", 236],
  [239, 40, 389],
  [178, 69, 478],
  [158, 41, 137]
],
"05/08/2023 to 05/14/2023": [
  [233, 88, 189],
  [159, 51, 128],
  [228, 22, 480],
  [459, 85, 177],
  [700, 72, 129],
  [246, 28, 134],
  [189, 86, 349]
],
"05/15/2023 to 05/21/2023": [
  [339, 58, 279],
  [356, 40, 136],
  [789, 45, 140],
  [369, 85, 267],
  [448, 66, 259],
  [890, 72, 480],
  [679, 29, 126]
],
"05/22/2023 to 05/28/2023": [
  [246, 29, 360],
  [460, "03", 689],
  [458, 78, 350],
  [190, "09", 568],
  [128, 18, 468],
  [123, 60, 136],
  [245, 13, 238]
],

"05/29/2023 to 06/04/2023": [
  [330, 67, 566],
  [256, 30, 145],
  [156, 24, 699],
  [260, 85, 168],
  [680, 42, 129],
  [800, 89, 379],
  [125, 81, 489]
],
"06/05/2023 to 06/11/2023": [
  [578, "06", 114],
  [239, 47, 278],
  [190, "01", 146],
  [233, 81, 678],
  [890, 75, 140],
  [229, 33, 157],
  [899, 65, 159]
],
"06/12/2023 to 06/18/2023": [
  [349, 69, 289],
  [234, 98, 260],
  [467, 75, 249],
  [347, 41, 236],
  [377, 78, 369],
  [138, 29, 469],
  [237, 26, 268]
],
"06/19/2023 to 06/25/2023": [
  [789, 48, 134],
  [357, 55, 267],
  [159, 55, 267],
  [160, 75, 348],
  [178, 67, 278],
  [560, 17, 124],
  [126, 96, 114]
],
"06/26/2023 to 07/02/2023": [
  [459, 83, 120],
  [479, "08", 125],
  [350, 84, 257],
  [156, 24, 680],
  [147, 23, 346],
  [390, 25, 348],
  [360, 95, 690]
],
"07/03/2023 to 07/09/2023": [
  [349, 61, 470],
  [667, 94, 239],
  [268, 61, 588],
  [118, "04", 455],
  [779, 32, 110],
  [449, 72, 237],
  [689, 39, 144]
],
"07/10/2023 to 07/16/2023": [
  [267, 54, 400],
  [379, 94, 149],
  [180, 96, 358],
  [489, 16, 367],
  [469, 96, 457],
  [670, 37, 368],
  [348, 58, 170]
],
"07/17/2023 to 07/23/2023": [
  [260, 89, 234],
  [599, 33, 148],
  [770, 44, 455],
  [568, 97, 250],
  [678, 19, 126],
  [460, "06", 178],
  [339, 51, 128]
],
"07/24/2023 to 07/30/2023": [
  [460, "02", 246],
  [677, "07", 160],
  [890, 76, 790],
  [450, 95, 366],
  [247, 38, 134],
  [378, 82, 589],
  [369, 82, 138]
],
"07/31/2023 to 08/06/2023": [
  [167, 40, 578],
  [269, 79, 135],
  [180, 96, 259],
  [568, 90, 127],
  [258, 55, 690],
  [478, 99, 289],
  [139, 35, 348]
],

 "08/07/2023 to 08/13/2023": [
  [669, 17, 368],
  [124, 70, 280],
  [467, 71, 290],
  [588, 17, 133],
  [234, 93, 157],
  [168, 59, 270],
  [278, 79, 199]
],
"08/14/2023 to 08/20/2023": [
  [389, "05", 456],
  [340, 73, 490],
  [467, 71, 290],
  [459, 86, 178],
  [260, 86, 150],
  [479, "08", 189],
  [136, "01", 380]
],
"08/21/2023 to 08/27/2023": [
  [579, 13, 238],
  [778, 29, 360],
  [235, "06", 466],
  [124, 79, 450],
  [579, 12, 237],
  [390, 29, 379],
  [158, 45, 267]
],
"08/28/2023 to 09/03/2023": [
  [789, 41, 290],
  [189, 83, 346],
  [359, 70, 280],
  [120, 35, 690],
  [258, 58, 125],
  [257, 46, 268],
  [679, 27, 223]
],
"09/04/2023 to 09/10/2023": [
  [123, 60, 244],
  [458, 72, 679],
  [266, 41, 137],
  [235, "08", 567],
  [190, "01", 669],
  [370, "08", 350],
  [459, 87, 458]
],
"09/11/2023 to 09/17/2023": [
  [469, 99, 270],
  [478, 92, 138],
  [189, 82, 129],
  [488, "04", 356],
  [124, 71, 128],
  [345, 22, 480],
  [245, 18, 468]
],
"09/18/2023 to 09/24/2023": [
  [368, 70, 479],
  [111, 30, 488],
  [236, 16, 169],
  [178, 64, 149],
  [478, 98, 800],
  [335, 13, 346],
  [259, 66, 178]
],
"09/25/2023 to 10/01/2023": [
  [226, "08", 369],
  [249, 50, 280],
  [147, 29, 234],
  [234, 95, 230],
  [569, "09", 180],
  [157, 38, 125],
  [379, 95, 348]
],

"10/02/2023 to 10/08/2023": [
  [568, 98, 468],
  [389, "09", 469],
  [447, 58, 378],
  [349, 64, 257],
  [169, 62, 589],
  [367, 62, 156],
  [688, 23, 247]
],
"10/09/2023 to 10/15/2023": [
  [144, 90, 479],
  [190, "04", 347],
  [167, 49, 126],
  [148, 33, 157],
  [559, 90, 280],
  [158, 42, 570],
  [568, 90, 118]
],
"10/16/2023 to 10/22/2023": [
  [479, "02", 156],
  [350, 86, 259],
  [140, 57, 179],
  [689, 32, 129],
  [356, 49, 135],
  [169, 63, 247],
  [356, 40, 136]
],
"10/23/2023 to 10/29/2023": [
  [468, 82, 237],
  [467, 77, 458],
  [127, "03", 120],
  [578, "06", 259],
  [268, 61, 470],
  [340, 71, 236],
  [467, 74, 239]
],
"10/30/2023 to 11/05/2023": [
  [128, 16, 150],
  [479, "07", 368],
  [690, 54, 699],
  [180, 98, 260],
  [125, 84, 789],
  [459, 84, 590],
  [569, "07", 179]
],

"11/06/2023 to 11/12/2023": [
  [579, 12, 156],
  [890, 77, 340],
  [179, 71, 489],
  [990, 84, 112],
  [146, 19, 135],
  [357, 58, 567],
  [490, 34, 266]
],
"11/13/2023 to 11/19/2023": [
  [245, 14, 338],
  [170, 85, 366],
  [170, 80, 226],
  [679, 25, 140],
  [289, 97, 124],
  [689, 30, 145],
  [346, 34, 590]
],
"11/20/2023 to 11/26/2023": [
  [334, "02", 688],
  [138, 21, 399],
  [479, "06", 899],
  [689, 32, 138],
  [379, 90, 488],
  [147, 29, 126],
  [289, 96, 349]
],
"11/27/2023 to 12/03/2023": [
  [224, 88, 350],
  [370, "09", 135],
  [127, "06", 367],
  [280, "04", 158],
  [170, 81, 470],
  [347, 45, 348],
  [358, 69, 270]
],

 "12/04/2023 to 12/10/2023": [
  [458, 77, 278],
  [288, 85, 159],
  [246, 23, 779],
  [229, 37, 188],
  [579, 17, 124],
  [299, "05", 267],
  [600, 67, 890]
],
"12/11/2023 to 12/17/2023": [
  [569, "09", 379],
  [234, 93, 346],
  [136, "05", 447],
  [367, 66, 349],
  [456, 58, 260],
  [137, 17, 368],
  [230, 52, 345]
],
"12/18/2023 to 12/24/2023": [
  [147, 24, 347],
  [368, 71, 290],
  [180, 93, 157],
  [459, 86, 367],
  [457, 64, 789],
  [280, "04", 167],
  [259, 62, 570]
],
"12/25/2023 to 12/31/2023": [
  [145, "01", 579],
  [169, 67, 467],
  [158, 44, 130],
  [578, "03", 337],
  [118, "02", 390],
  [220, 41, 588],
  [235, "08", 459]
],

 "01/01/2024 to 01/07/2024": [
  [367, 69, 568],
  [123, 61, 137],
  [336, 27, 124],
  [389, "06", 349],
  [145, "02", 246],
  [358, 61, 128],
  [134, 83, 779]
],
"01/08/2024 to 01/14/2024": [
  [578, "06", 367],
  [336, 25, 258],
  [690, 57, 377],
  [370, "03", 689],
  [369, 87, 278],
  [357, 59, 568],
  [178, 66, 556]
],
"01/15/2024 to 01/21/2024": [
  [123, 64, 130],
  [115, 72, 390],
  [258, 57, 124],
  [377, 75, 230],
  [247, 38, 378],
  [260, 80, 677],
  [477, 82, 679]
],
"01/22/2024 to 01/28/2024": [
  [123, 69, 478],
  [228, 21, 560],
  [350, 83, 247],
  [669, 13, 148],
  [357, 59, 568],  // Note: duplicate date 01/13/2024 in original data
  [566, 73, 445],
  [470, 13, 256]
],
"01/29/2024 to 02/04/2024": [
  [223, 74, 167],
  [136, 0, 389],
  [260, 89, 144],
  [188, 79, 135],
  [146, 17, 359],
  [236, 14, 130],
  [168, 58, 800]
],

"02/05/2024 to 02/11/2024": [
  [589, 22, 499],
  [578, 0, 235],
  [568, 95, 456],
  [190, "04", 356],
  [467, 73, 139],
  [250, 74, 590],
  [359, 71, 678]
],
"02/12/2024 to 02/18/2024": [
  [290, 32, 467],
  [159, 63, 478],
  [269, 74, 380],
  [578, 83, 465],
  [145, "06", 158],
  [338, "09", 299],
  [570, 17, 333]
],
"02/19/2024 to 02/25/2024": [
  [135, "05", 588],
  [568, 92, 189],
  [369, "05", 274],
  [455, 56, 136],
  [245, 99, 187],
  [199, 46, 399],
  [345, 15, 276]
],
"02/26/2024 to 03/03/2024": [
  [178, "08", 477],
  [368, 25, 330],
  [379, 21, 689],
  [558, 11, 229],
  [235, 62, 235],
  [479, 38, 179],
  [368, 55, 300]
],

 "03/04/2024 to 03/10/2024": [
  [127, 86, 370],
  [150, 20, 556],
  [224, 15, 117],
  [570, 62, 222],
  [368, 43, 138],
  [369, 72, 145],
  [146, 53, 800]
],
"03/11/2024 to 03/17/2024": [
  [350, 72, 347],
  [259, 96, 699],
  [259, 18, 188],
  [567, 44, 369],
  [139, "05", 199],
  [568, 61, 380],
  [268, 83, 356]
],
"03/18/2024 to 03/24/2024": [
  [379, 42, 135],
  [456, 76, 289],
  [347, 95, 279],
  [199, 37, 578],
  [348, 68, 359],
  [357, 17, 126],
  [568, 35, 279]
],
"03/25/2024 to 03/31/2024": [
  [458, 99, 144],
  [370, 56, 249],
  [259, 72, 186],
  [589, "02", 168],
  [368, 56, 699],
  [270, 91, 230],
  [479, 67, 145]
],

 "04/01/2024 to 04/07/2024": [
  [368, 73, 788],
  [133, 72, 147],
  [255, 23, 788],
  [237, 26, 899],
  [899, 63, 247],
  [160, 70, 127],
  [260, 81, 579]
],
"04/08/2024 to 04/14/2024": [
  [289, 98, 134],
  [369, 81, 146],
  [150, 61, 245],
  [790, 67, 458],
  [569, 0, 370],
  [168, 52, 570],
  [249, 56, 790]
],
"04/15/2024 to 04/21/2024": [
  [357, 52, 156],
  [569, "04", 248],
  [178, 63, 670],
  [468, 87, 250],
  [130, 42, 237],
  [124, 76, 268],
  [233, 89, 270]
],
"04/22/2024 to 04/28/2024": [
  [668, 0, 127],
  [370, "08", 134],
  [556, 62, 589],
  [358, 60, 389],
  [600, 68, 567],
  [469, 98, 116],
  [389, "09", 270]
],
"04/29/2024 to 05/05/2024": [
  [456, 59, 144],
  [339, 57, 449],
  [158, 48, 477],
  [167, 48, 558],
  [678, 18, 224],
  [479, "03", 689],
  [559, 92, 110]
],
"05/06/2024 to 05/12/2024": [
  [169, 65, 780],
  [220, 42, 660],
  [239, 46, 600],
  [366, 57, 458],
  [489, 17, 377],
  [357, 53, 166],
  [360, 95, 159]
],
"05/13/2024 to 05/19/2024": [
  [880, 64, 112],
  [570, 29, 577],
  [478, 95, 267],
  [557, 70, 578],
  [346, 37, 467],
  [470, 19, 135],
  [179, 78, 567]
],
"05/20/2024 to 05/26/2024": [
  [190, "05", 159],
  [457, 68, 125],
  [245, 13, 580],
  [267, 53, 256],
  [370, "05", 230],
  [236, 13, 599],
  [890, 72, 156]
],
"05/27/2024 to 06/02/2024": [
  [147, 23, 346],
  [778, 25, 159],
  [140, 59, 180],
  [669, 16, 448],
  [588, 10, 127],
  [336, 28, 279],
  [179, 76, 259]
],

"06/03/2024 to 06/09/2024": [
  [246, 29, 450],
  [678, 16, 367],
  [359, 73, 256],
  [678, 15, 258],
  [690, 51, 290],
  [579, 19, 234],
  [670, 32, 345]
],
"06/24/2024 to 06/30/2024": [
  [128, 12, 147],
  [137, 18, 224],
  [147, 28, 350],
  [234, 97, 250],
  [368, 73, 490],
  [250, 76, 178],
  [279, 84, 356]
],
"07/01/2024 to 07/07/2024": [
  [780, 51, 560],
  [357, 50, 136],
  [690, 54, 590],
  [147, 21, 155],
  [158, 49, 270],
  [467, 76, 790],
  [140, 57, 269]
],
"07/08/2024 to 07/14/2024": [
  [890, 77, 223],
  [800, 88, 468],
  [566, 73, 247],
  [134, 88, 170],
  [360, 91, 579],
  [790, 60, 569],
  [168, 53, 148]
],
"07/15/2024 to 07/21/2024": [
  [450, 97, 890],
  [334, 10, 190],
  [459, 81, 669],
  [123, 69, 379],
  [360, 97, 359],
  [168, 57, 269],
  [467, 71, 470]
],
"07/22/2024 to 07/28/2024": [
  [168, 51, 579],
  [447, 53, 166],
  [136, "09", 126],
  [170, 83, 157],
  [370, "08", 170],
  [468, 82, 480],
  [356, "48", 369]
],

 "12/30/2024 to 01/05/2025": [
  [569, "04", 248],
  [348, 57, 557],
  [690, 57, 340],
  [240, 64, 167],
  [478, 96, 457],
  [270, 93, 148],
  [135, 96, 367]
],
"01/06/2025 to 01/12/2025": [
  [458, 70, 127],
  [378, 89, 450],
  [468, 81, 579],
  [679, 29, 469],
  [456, 54, 167],
  [480, 26, 240],
  [470, 17, 250]
],
"01/13/2025 to 01/19/2025": [
  [448, 65, 799],
  [199, 97, 377],
  [270, 98, 125],
  [477, 81, 678],
  [568, 97, 179],
  [990, 87, 359],
  [256, 35, 348]
],
"01/20/2025 to 01/26/2025": [
  [135, 93, 346],
  [579, 18, 125],
  [259, 63, 256],
  [780, 56, 150],
  [166, 30, 370],
  [120, 34, 770],
  [378, 80, 136]  // Note: This was for 02/02/2025, included at the end to keep length same
],
"01/27/2025 to 02/02/2025": [
  [366, 59, 388],
  [336, 29, 379],
  [156, 23, 355],
  [237, 29, 270],
  [233, 87, 557],
  [248, 49, 126],
  [378, 80, 136]
],

 "02/03/2025 to 02/09/2025": [
    [180, 97, 124],
    [469, 96, 114],
    [245, 16, 349],
    [349, 61, 146],
    [489, 12, 246],
    [367, 61, 236],
    [390, 28, "170"]
  ],
  "02/10/2025 to 02/16/2025": [
    [360, 94, 789],
    [778, 22, 138],
    [359, 70, 235],
    [679, 23, 445],
    [269, 76, 358],
    [159, 57, 124],
    [299, "01", 335]
  ],
  "02/17/2025 to 02/23/2025": [
    [259, 61, 489],
    [367, 63, 689],
    [690, 53, 157],
    [190, "04", 239],
    [124, 72, 679],
    [267, 55, 780],
    [478, 97, 368]
  ],
  "02/24/2025 to 03/02/2025": [
    [378, 80, 145],
    [467, 78, 468],
    [599, 34, 400],
    [157, 39, 478],
    [147, 21, 146],
    [467, 70, 136],
    [689, 34, 257]
  ]
};

export const TIMEBAZAR = {
"01/02/2023 to 01/08/2023": [
  [120, 30, 578],
  [166, 33, 355],
  [390, 25, 447],
  [177, 56, 367],
  [146, 16, 457],
  [120, 31, 290]
],
"01/09/2023 to 01/15/2023": [
  [450, 98, 350],
  [568, 90, 136],
  [258, 53, 139],
  [457, 66, 358],
  [235, "08", 288],
  [390, 29, 568]
],
"01/16/2023 to 01/22/2023": [
  [478, 91, 155],
  [589, 25, 267],
  [156, 28, 279],
  [790, 60, 127],
  [456, 55, 249],
  [130, 43, 148]
],
"01/23/2023 to 01/29/2023": [
  [699, 41, 399],
  [388, 91, 236],
  [256, 33, 120],
  [790, 60, 127],
  [144, 96, 259],
  [123, 66, 240]
],
"01/30/2023 to 02/05/2023": [
  [258, 58, 378],
  [468, 89, 126],
  [189, 83, 157],
  [569, "07", 250],
  [236, 13, 238],
  [699, 48, 116]
],
"02/06/2023 to 02/12/2023": [
  [568, 98, 279],
  [134, 82, 237],
  [126, 94, 789],
  [455, 45, 267],
  [356, 44, 590],
  [140, 56, 600]
],
"02/13/2023 to 02/19/2023": [
  [278, 73, 148],
  [559, 91, 137],
  [169, 68, 189],
  [389, "01", 470],
  [160, 71, 146],
  [378, 87, 133]
],
"02/20/2023 to 02/26/2023": [
  [347, 46, 448],
  [380, 11, 560],
  [377, 72, 480],
  [147, 27, 133],
  [336, 26, 556],
  [130, 42, 480]
],
"02/27/2023 to 03/05/2023": [
  [117, 98, 369],
  [668, "06", 790],
  [246, 24, 158],
  [170, 83, 580],
  [267, 57, 115],
  [468, 87, 890]
],

"03/06/2023 to 03/12/2023": [
  [267, 57, 115],
  [369, 84, 239],
  [780, 50, 370],
  [789, 46, 259],
  [780, 53, 256],
  [126, 97, 160]
],
"03/13/2023 to 03/19/2023": [
  [336, 20, 370],
  [134, 80, 136],
  [668, "09", 289],
  [448, 65, 122],
  [590, 48, 279],
  [669, 10, 118]
],
"03/20/2023 to 03/26/2023": [
  [479, "04", 158],
  [678, 14, 248],
  [344, 19, 667],
  [390, 20, 118],
  [259, 67, 269],
  [456, 58, 125]
],
"03/27/2023 to 04/02/2023": [
  [589, 22, 129],
  [677, "05", 780],
  [378, 88, 279],
  [148, 32, 246],
  [280, "09", 577],
  [488, 0, 370]
],
"04/03/2023 to 04/09/2023": [
  [230, 58, 224],
  [458, 72, 200],
  [377, 73, 346],
  [460, "09", 180],
  [580, 37, 449],
  [457, 64, 789]
],
"04/10/2023 to 04/16/2023": [
  [146, 67, 240],
  [245, 93, 158],
  [367, 14, 356],
  [390, 70, 217],
  [214, 86, 468],
  [580, 47, 191]
],
"04/17/2023 to 04/23/2023": [
  [240, 30, 500],
  [569, 56, 246],
  [378, 80, 117],
  [667, "09", 150],
  [458, 83, 284],
  [500, 21, 270]
],
"04/24/2023 to 04/30/2023": [
  [470, 99, 221],
  [568, 60, 278],
  [354, 52, 220],
  [457, "07", 124],
  [132, 74, 388],
  [569, 81, 137]
],

"05/01/2023 to 05/07/2023": [
  [460, 19, 400],
  [122, 79, 250],
  [259, 10, 568],
  [500, 37, 482],
  [369, 88, 130],
  [578, 69, 274]
],
"05/08/2023 to 05/14/2023": [
  [380, 64, 190],
  [490, 59, 278],
  [590, 36, 156],
  [123, 77, 390],
  [468, 84, 230],
  [456, 69, 314]
],
"05/15/2023 to 05/21/2023": [
  [350, 82, 418],
  [486, 90, 320],
  [459, 72, 138],
  [572, 66, 214],
  [634, 49, 137],
  [468, 58, 244]
],
"05/22/2023 to 05/28/2023": [
  [246, 91, 279],
  [579, 62, 379],
  [360, 53, 350],
  [420, 89, 286],
  [470, 76, 448],
  [235, 40, 229]
],
"05/29/2023 to 06/04/2023": [
  [510, 55, 370],
  [250, 70, 310],
  [366, 83, 489],
  [549, 98, 226],
  [468, 69, 369],
  [578, 80, 247]
],
"06/05/2023 to 06/11/2023": [
  [200, 64, 498],
  [189, 80, 470],
  [370, 29, 379],
  [478, 89, 236],
  [580, 92, 149],
  [489, 74, 269]
],
"06/12/2023 to 06/18/2023": [
  [420, 84, 350],
  [250, 45, 309],
  [590, 92, 276],
  [144, 55, 280],
  [270, 68, 122],
  [567, 80, 140]
],
"06/19/2023 to 06/25/2023": [
  [368, 63, 280],
  [230, 79, 299],
  [480, 96, 317],
  [578, 65, 229],
  [340, 45, 489],
  [199, 62, 380]
],
"06/26/2023 to 07/02/2023": [
  [590, 80, 290],
  [128, 60, 480],
  [250, 94, 367],
  [580, 91, 237],
  [459, 56, 190],
  [498, 77, 258]
],

 "07/03/2023 to 07/09/2023": [
  [320, 99, 400],
  [380, 66, 278],
  [590, 83, 126],
  [590, 92, 170],
  [200, 81, 340],
  [166, 72, 156]
],
"07/10/2023 to 07/16/2023": [
  [458, 77, 365],
  [233, 95, 490],
  [369, 89, 225],
  [489, 96, 158],
  [350, 62, 319],
  [279, 90, 550]
],
"07/17/2023 to 07/23/2023": [
  [568, 94, 237],
  [279, 84, 401],
  [154, 72, 298],
  [489, 66, 340],
  [556, 82, 289],
  [366, 95, 252]
],
"07/24/2023 to 07/30/2023": [
  [278, 89, 490],
  [559, 56, 373],
  [278, 78, 415],
  [489, 69, 280],
  [190, 82, 240],
  [560, 99, 289]
],
"07/31/2023 to 08/06/2023": [
  [324, 67, 348],
  [490, 95, 268],
  [288, 85, 365],
  [245, 71, 401],
  [378, 56, 299],
  [289, 48, 360]
],
"08/07/2023 to 08/13/2023": [
  [589, 25, 690],
  [250, 77, 467],
  [399, 10, 235],
  [380, 10, 460],
  [279, 87, 467],
  [580, 32, 147]
],
"08/14/2023 to 08/20/2023": [
  [134, 86, 178],
  [380, 10, 460],
  [138, 28, 990],
  [590, 48, 125],
  [156, 25, 249],
  [116, 84, 680]
],
"08/21/2023 to 08/27/2023": [
  [248, 44, 789],
  [133, 79, 469],
  [229, 35, 456],
  [113, 59, 360],
  [470, 11, 146],
  [138, 28, 990]
],
"08/28/2023 to 09/03/2023": [
  [689, 35, 799],
  [378, 82, 246],
  [134, 87, 160],
  [690, 54, 130],
  [139, 31, 489],
  [139, 31, 236]
],


"09/04/2023 to 09/10/2023": [
  [250, 76, 178],
  [590, 40, 460],
  [489, 13, 256],
  [150, 62, 237],
  [247, 32, 480],
  [180, 97, 377]
],

"09/11/2023 to 09/17/2023": [
  [357, 59, 234],
  [158, 43, 247],
  [146, 11, 128],
  [279, 84, 167],
  [136, "03", 346],
  [458, 78, 369]
],

"09/18/2023 to 09/24/2023": [
  [690, 57, 278],
  [114, 64, 680],
  [137, 16, 600],
  [350, 80, 127],
  [116, 81, 128],
  [123, 64, 680]
],

"09/25/2023 to 10/01/2023": [
  [158, 46, 178],
  [489, 16, 790],
  [370, "08", 279],
  [119, 11, 335],
  [279, 85, 258],
  [150, 60, 460]
],

"10/02/2023 to 10/08/2023": [
  [170, 80, 299],
  [260, 85, 140],
  [799, 53, 346],
  [459, 84, 347],
  [130, 40, 235],
  [180, 94, 167]
],

"10/09/2023 to 10/15/2023": [
  [489, 16, 457],
  [469, 92, 390],
  [680, 45, 447],
  [118, "03", 355],
  [244, "06", 899],
  [224, 87, 377]
],

"10/16/2023 to 10/22/2023": [
  [677, "03", 355],
  [136, "02", 336],
  [137, 18, 134],
  [227, 13, 599],
  [467, 79, 117],
  [235, 0, 569]
],

"10/23/2023 to 10/29/2023": [
  [889, 56, 268],
  [390, 27, 467],
  [668, "01", 560],
  [157, 36, 259],
  [467, 77, 340],
  [478, 98, 170]
],

"10/30/2023 to 11/05/2023": [
  [167, 44, 789],
  [389, "01", 236],
  [235, "02", 345],
  [458, 78, 990],
  [700, 71, 470],
  [349, 67, 278]
],


 "11/06/2023 to 11/12/2023": [
  [680, 47, 179],
  [580, 38, 378],
  [228, 26, 349],
  [190, 0, 127],
  [447, 59, 667],
  [248, 42, 228]
],

"11/13/2023 to 11/19/2023": [
  [127, "03", 157],
  [447, 59, 667],
  [467, 77, 340],
  [114, 69, 126],
  [248, 41, 245],
  [389, "01", 236]
],

"11/20/2023 to 11/26/2023": [
  [269, 78, 125],
  [290, 17, 115],
  [340, 71, 245],
  [500, 50, 280],
  [447, 59, 667],
  [248, 42, 228]
],

"11/27/2023 to 12/03/2023": [
  [778, 21, 470],
  [356, 44, 220],
  [690, 59, 234],
  [127, "03", 157],
  [280, "03", 157],
  [139, 34, 220]
],

"12/04/2023 to 12/10/2023": [
  [448, 68, 477],
  [337, 35, 690],
  [290, 11, 489],
  [126, 99, 144],
  [259, 67, 377],
  [114, 69, 126]
],

"12/11/2023 to 12/17/2023": [
  [120, 33, 346],
  [378, 81, 245],
  [115, 72, 390],
  [460, "02", 129],
  [199, 99, 289],
  [348, 54, 789]
],

"12/18/2023 to 12/24/2023": [
  [780, 50, 569],
  [145, "09", 234],
  [280, "05", 339],
  [248, 41, 245],
  [800, 84, 257],
  [119, 18, 350]
],

"12/25/2023 to 12/31/2023": [
  [670, 37, 890],
  [234, 92, 156],
  [167, 40, 190],
  [156, 22, 390],
  [349, 65, 348],
  [156, 27, 359]
],


"01/01/2024 to 01/07/2024": [
  [146, 13, 166],
  [580, 36, 240],
  [670, 35, 348],
  [249, 59, 225],
  [128, 17, 269],
  [578, "04", 257]
],

"01/08/2024 to 01/14/2024": [
  [689, 35, 348],
  [280, "06", 240],
  [446, 47, 340],
  [556, 61, 146],
  [156, 23, 670],
  [158, 40, 280]
],

"01/15/2024 to 01/21/2024": [
  [369, 83, 670],
  [179, 76, 448],
  [370, 0, 578],
  [140, 56, 457],
  [290, 11, 560],
  [356, 44, 257]
],

"01/22/2024 to 01/28/2024": [
  [119, 17, 449],
  [558, 85, 177],
  [389, "08", 350],
  [569, "03", 229],
  [128, 17, 269],
  [166, 33, 148]
],

"01/29/2024 to 02/04/2024": [
  [470, 14, 446],
  [166, 32, 679],
  [167, 44, 347],
  [134, 86, 169],
  [238, 37, 467],
  [560, 13, 670]
],

"02/05/2024 to 02/11/2024": [
  [126, 97, 188],
  [700, 73, 157],
  [227, 16, 330],
  [223, 79, 180],
  [389, "05", 168],
  [578, "08", 134]
],

"02/12/2024 to 02/18/2024": [
  [190, "07", 458],
  [113, 54, 356],
  [790, 68, 224],
  [457, 67, 359],
  [149, 42, 570],
  [347, 46, 240]
],

"02/19/2024 to 02/25/2024": [
  [350, 80, 299],
  [557, 71, 344],
  [689, 34, 149],
  [270, 94, 888],
  [119, 16, 259],
  [169, 65, 889]
],

"02/26/2024 to 03/03/2024": [
  [349, 65, 159],
  [380, 10, 668],
  [347, 43, 148],
  [138, 24, 356],
  [170, 84, 149],
  [145, "03", 689]
],


  "03/04/2024 to 03/10/2024": [
  [379, 94, 167],
  [267, 59, 144],
  [179, 72, 200],
  [458, 71, 146],
  [369, 80, 370],
  [779, 30, 569]
],

"03/11/2024 to 03/17/2024": [
  [469, 96, 178],
  [249, 50, 280],
  [170, 89, 478],
  [250, 79, 234],
  [449, 71, 344],
  [124, 74, 130]
],

"03/18/2024 to 03/24/2024": [
  [189, 80, 145],
  [358, 61, 146],
  [149, 40, 118],
  [236, 12, 246],
  [569, "07", 124],
  [258, 59, 559]
],

"03/25/2024 to 03/31/2024": [
  [467, 71, 290],
  [160, 74, 257],
  [148, 37, 250],
  [148, 33, 148],
  [130, 49, 360],
  [258, 59, 559]
],

"04/01/2024 to 04/07/2024": [
  [480, 24, 239],
  [238, 34, 149],
  [140, 53, 670],
  [155, 12, 499],
  [138, 29, 577],
  [399, 17, 250]
],

"04/08/2024 to 04/14/2024": [
  [155, 15, 159],
  [247, 38, 279],
  [137, 19, 559],
  [390, 27, 467],
  [270, 95, 230],
  [359, 70, 127]
],

"04/15/2024 to 04/21/2024": [
  [347, 40, 127],
  [458, 77, 124],
  [234, 96, 169],
  [110, 24, 158],
  [278, 77, 179],
  [456, 55, 357]
],

"04/22/2024 to 04/28/2024": [
  [250, 70, 280],
  [779, 30, 334],
  [246, 28, 279],
  [489, 12, 200],
  [399, 13, 337],
  [448, 69, 126]
],

"04/29/2024 to 05/05/2024": [
  [157, 30, 677],
  [189, 85, 140],
  [125, 89, 568],
  [245, 12, 480],
  [268, 64, 347],
  [169, 63, 670]
],


"05/06/2024 to 05/12/2024": [
  [689, 30, 244],
  [135, 91, 290],
  [255, 25, 357],
  [380, 14, 356],
  [133, 72, 200],
  [389, "04", 347]
],

"05/13/2024 to 05/19/2024": [
  [469, 95, 339],
  [790, 64, 590],
  [279, 87, 133],
  [137, 17, 890],
  [359, 77, 124],
  [489, 17, 467]
],

"05/20/2024 to 05/26/2024": [
  [360, 99, 289],
  [500, 59, 135],
  [150, 68, 369],
  [558, 84, 347],
  [445, 31, 146],
  [380, 14, 699]
],

"05/27/2024 to 06/02/2024": [
  [599, 30, 677],
  [670, 35, 456],
  [118, "02", 147],
  [499, 22, 255],
  [169, 60, 460],
  [179, 73, 139]
],

"06/24/2024 to 06/30/2024": [
  [169, 69, 450],
  [470, 16, 244],
  [250, 78, 369],
  [356, 45, 140],
  [257, 49, 126],
  [247, 31, 777]
],

"07/01/2024 to 07/07/2024": [
  [278, 71, 489],
  [238, 31, 335],
  [466, 63, 247],
  [359, 78, 350],
  [590, 49, 117],
  [567, 82, 138]
],

"07/08/2024 to 07/14/2024": [
  [289, 91, 380],
  [129, 24, 248],
  [157, 30, 190],
  [456, 53, 788],
  [157, 36, 178],
  [245, 12, 660]
],

"07/15/2024 to 07/21/2024": [
  [679, 20, 190],
  [388, 92, 228],
  [556, 62, 237],
  [199, 95, 456],
  [159, 52, 237],
  [249, 56, 457]
],

"07/22/2024 to 07/28/2024": [
  [460, "06", 349],
  [400, 43, 788],
  [280, "05", 348],
  [333, 92, 589],
  [788, 34, 455],
  [477, 84, 400]
],


 "12/30/2024 to 01/05/2025": [
  [167, 41, 560],
  [129, 28, 233],
  [136, "08", 459],
  [240, 69, 450],
  [589, 25, 159],
  [690, 52, 390]
],

"01/06/2025 to 01/12/2025": [
  [289, 97, 467],
  [130, 44, 680],
  [356, 44, 167],
  [127, "04", 248],
  [349, 62, 237],
  [800, 88, 279]
],

"01/13/2025 to 01/19/2025": [
  [247, 33, 166],
  [230, 51, 119],
  [334, "05", 113],
  [390, 26, 457],
  [440, 83, 779],
  [277, 64, 356]
]

};

export const MADHURDAY = {
 "12/26/2022 to 01/01/2023": [
  [140, 51, 137],
  [788, 34, 455],
  [249, 56, 457],
  [245, 12, 660],
  ["170", "84", "590"],
  ["240", "65", "159"],
  [270, 92, 679]
],

"01/02/2023 to 01/08/2023": [
  [450, 90, 145],
  [146, 15, 690],
  [270, 98, 189],
  [289, 90, 370],
  [899, 67, 188],
  [140, 51, 137],
  [579, 14, 680]
],

"01/09/2023 to 01/15/2023": [
  [166, 32, 336],
  [700, 77, 359],
  [199, 93, 300],
  [134, 89, 117],
  [148, 38, 189],
  [337, 32, 246],
  [148, 37, 557]
],

"01/16/2023 to 01/22/2023": [
  [236, 19, 117],
  [228, 27, 368],
  [179, 79, 568],
  [255, 24, 220],
  [350, 82, 660],
  [668, "05", 258],
  [345, 28, 369]
],

"01/23/2023 to 01/29/2023": [
  [190, "03", 247],
  [460, "00", 370],
  [129, 23, 139],
  [556, 63, 779],
  [357, 56, 268],
  [269, 77, 179],
  [367, 66, 268]
],

"01/30/2023 to 02/05/2023": [
  [566, 78, 233],
  [890, 70, 136],
  [800, 88, 468],
  [134, 84, 347],
  [357, 56, 268],
  [225, 91, 489],
  [449, 74, 770]
],

  "02/06/2023 to 02/12/2023": [
   [268, 67, 700],
   [469, 95, 122],
   [380, 14, 400],
   [235, 0, 370],
   [459, 88, 170],
   [499, 20, 569],
   [790, 61, 560],
  ],

  "02/13/2023 to 02/19/2023": [
   [577, 91, 137],
   [370, 0, 578],
   [347, 45, 177],
   [367, 65, 168],
   [457, 65, 348],
   [579, 15, 456],
   [770, 42, 679],
  ],

  "02/20/2023 to 02/26/2023": [
   [233, 84, 770],
   [360, 97, 124],
   [368, 77, 223],
   [456, 59, 234],
   [357, 56, 448],
   [599, 36, 169],
   [359, 70, 370],
  ],

 "02/27/2023 to 03/05/2023": [
  [367, 69, 289],
  [567, 82, 390],
  [170, 89, 135],
  [137, 17, 188],
  [256, 30, 488],
  [267, 58, 125],
  [459, 84, 347]
],

"03/06/2023 to 03/12/2023": [
  [460, "02", 480],
  [114, 68, 233],
  [560, 13, 689],
  [267, 58, 125],
  [360, 99, 333],
  [449, 75, 159],
  [380, 17, 160]
],

"03/13/2023 to 03/19/2023": [
  [350, 80, 460],
  [159, 55, 177],
  [366, 52, 147],
  [110, 24, 789],
  [389, "09", 469],
  [146, 13, 139],
  [156, 24, 130]
],

"03/20/2023 to 03/26/2023": [
  [229, 35, 249],
  [679, 25, 366],
  [139, 32, 156],
  [789, 48, 369],
  [229, 37, 124],
  [349, 60, 578],
  [147, 29, 126]
],

"03/27/2023 to 04/02/2023": [
  [166, 35, 159],
  [368, 72, 200],
  [348, 53, 599],
  [259, 65, 267],
  [145, "04", 220],
  [569, "02", 336],
  [345, 27, 340]
],


 "04/03/2023 to 04/09/2023": [
  [479, "04", 455],
  [699, 40, 136],
  [789, 49, 568],
  [690, 52, 480],
  [280, "08", 189],
  [125, 80, 389],
  [138, 24, 239]
],

"04/10/2023 to 04/16/2023": [
  [279, 86, 169],
  [556, 61, 470],
  [227, 17, 124],
  [388, 95, 140],
  [169, 69, 360],
  [180, 93, 148],
  [450, 97, 458]
],

"04/17/2023 to 04/23/2023": [
  [359, 76, 457],
  [578, "03", 139],
  [670, 35, 780],
  [120, 34, 699],
  [569, "02", 255],
  [245, 19, 568],
  [234, 93, 689]
],

"04/24/2023 to 04/30/2023": [
  [200, 29, 199],
  [569, "03", 247],
  [335, 10, 136],
  [250, 71, 489],
  [480, 28, 468],
  [340, 77, 467],
  [349, 65, 249]
],

"05/01/2023 to 05/07/2023": [
  [367, 60, 190],
  [380, 13, 490],
  [229, 39, 388],
  [344, 17, 467],
  [588, 12, 156],
  [112, 42, 237],
  [158, 42, 660]
],

"05/08/2023 to 05/14/2023": [
  [238, 33, 157],
  [579, 12, 679],
  [689, 33, 247],
  [456, 53, 670],
  [226, "04", 590],
  [579, 16, 150],
  [356, 41, 399]
],

"05/15/2023 to 05/21/2023": [
  [148, 34, 130],
  [260, 86, 330],
  [148, 32, 246],
  [235, "08", 567],
  [239, 42, 570],
  [256, 30, 136],
  [889, 56, 790]
],

"05/22/2023 to 05/28/2023": [
  [136, "07", 377],
  [479, "02", 336],
  [670, 35, 168],
  [128, 19, 126],
  [224, 80, 370],
  [127, "09", 234],
  [579, 12, 778]
],

"05/29/2023 to 06/04/2023": [
  [117, 96, 169],
  [123, 64, 455],
  [233, 81, 560],
  [246, 24, 248],
  [390, 28, 468],
  [224, 80, 370],
  [780, 51, 777]
],


 "06/05/2023 to 06/11/2023": [
  [223, 70, 578],
  [160, 79, 559],
  [149, 42, 660],
  [469, 97, 133],
  [247, 39, 559],
  [166, 32, 480],
  [128, 15, 348]
],

"06/12/2023 to 06/18/2023": [
  [679, 27, 467],
  [679, 21, 128],
  [244, "07", 278],
  [337, 30, 226],
  [445, 31, 380],
  [379, 95, 500],
  [269, 73, 670]
],

"06/19/2023 to 06/25/2023": [
  [489, 15, 267],
  [157, 37, 160],
  [233, 89, 234],
  [356, 41, 236],
  [114, 63, 580],
  [148, 39, 117],
  [440, 86, 150]
],

"06/26/2023 to 07/02/2023": [
  [478, 91, 588],
  [135, 95, 113],
  [679, 22, 499],
  [259, 62, 129],
  [110, 22, 156],
  [458, 79, 135],
  [147, 28, 125]
],

"07/03/2023 to 07/09/2023": [
  [338, 46, 123],
  [689, 37, 890],
  [356, 44, 167],
  [450, 99, 568],
  [260, 80, 479],
  [990, 84, 789],
  [280, "08", 260]
],

"07/10/2023 to 07/16/2023": [
  [679, 29, 180],
  [470, 17, 133],
  [460, "03", 580],
  [240, 67, 160],
  [138, 25, 159],
  [158, 40, 578],
  [268, 61, 560]
],

"07/17/2023 to 07/23/2023": [
  [360, 98, 125],
  [790, 61, 470],
  [268, 68, 440],
  [224, 88, 125],
  [478, 99, 450],
  [600, 67, 124],
  [460, "09", 469]
],

"07/24/2023 to 07/30/2023": [
  [128, 19, 900],
  [456, 52, 499],
  [799, 52, 589],
  [567, 82, 679],
  [667, 97, 160],
  [130, 42, 147],
  [278, 78, 170]
],

"07/31/2023 to 08/06/2023": [
  [890, 79, 450],
  [169, 61, 137],
  [589, 23, 238],
  [778, 20, 244],
  [378, 88, 350],
  [690, 51, 489],
  [447, 51, 290]
],


 "08/07/2023 to 08/13/2023": [
  [278, 73, 346],
  [899, 66, 240],
  [489, 15, 555],
  [128, 10, 136],
  [290, 12, 147],
  [220, 43, 689],
  [367, 69, 126]
],

"08/14/2023 to 08/20/2023": [
  [336, 22, 345],
  [489, 10, 668],
  [880, 69, 577],
  [466, 67, 278],
  [156, 23, 148],
  [457, 67, 250],
  [367, 69, 126]
],

"08/21/2023 to 08/27/2023": [
  [180, 96, 466],
  [388, 94, 789],
  [790, 66, 123],
  [677, 0, 136],
  [478, 93, 238],
  [136, "02", 660],
  [140, 59, 469]
],

"08/28/2023 to 09/03/2023": [
  [688, 27, 133],
  [112, 40, 550],
  [459, 82, 246],
  [456, 54, 590],
  [239, 43, 148],
  [112, 46, 240],
  [688, 20, 226]
],

"09/04/2023 to 09/10/2023": [
  [559, 92, 589],
  [288, 89, 234],
  [236, 17, 890],
  [489, 17, 890],
  [440, 85, 780],
  [160, 79, 900],
  [350, 88, 369]
],

"09/11/2023 to 09/17/2023": [
  [670, 31, 137],
  [179, 77, 467],
  [159, 53, 148],
  [456, 58, 224],
  [900, 93, 346],
  [377, 71, 470],
  [578, "03", 120]
],

"09/18/2023 to 09/24/2023": [
  [370, "05", 348],
  [277, 60, 244],
  [258, 59, 126],
  [135, 92, 570],
  [144, 97, 458],
  [480, 22, 237],
  [255, 29, 234]
],

"09/25/2023 to 10/01/2023": [
  [569, "01", 100],
  [568, 93, 490],
  [235, "08", 125],
  [789, 42, 129],
  [137, 14, 239],
  [268, 67, 160],
  [267, 54, 356]
],

 "10/02/2023 to 10/08/2023": [
  [669, 15, 159],
  [678, 14, 220],
  [336, 21, 155],
  [170, 86, 349],
  [146, 13, 779],
  [780, 56, 268],
  [579, 13, 148]
],

"10/09/2023 to 10/15/2023": [
  [118, "06", 448],
  [239, 42, 228],
  [345, 28, 125],
  [249, 58, 125],
  [680, 48, 170],
  [114, 69, 135],
  [139, 34, 248]
],


 "10/16/2023 to 10/22/2023": [
  [145, "06", 448],
  [333, 93, 157],
  [168, 54, 356],
  [379, 91, 335],
  [357, 59, 667],
  [688, 24, 446],
  [679, 23, 355]
],

"10/23/2023 to 10/29/2023": [
  [389, "06", 169],
  [455, 42, 147],
  [149, 41, 128],
  [356, 48, 125],
  [235, "02", 156],
  [260, 80, 550],
  [347, 46, 259]
],

"10/30/2023 to 11/05/2023": [
  [190, "04", 680],
  [169, 64, 356],
  [178, 60, 280],
  [570, 26, 240],
  [166, 35, 500],
  [170, 85, 799],
  [458, 70, 460]
],

"11/06/2023 to 11/12/2023": [
  [699, 43, 779],
  [166, 35, 500],
  [123, 68, 567],
  [334, "07", 250],
  [570, 26, 240],
  [570, 26, 240],
  [166, 37, 179]
],

"11/13/2023 to 11/19/2023": [
  [778, 20, 244],
  [169, 61, 137],
  [589, 23, 238],
  [378, 88, 350],
  [890, 79, 450],
  [690, 51, 489],
  [447, 51, 290]
],

"11/20/2023 to 11/26/2023": [
  [359, 71, 245],
  [489, 11, 470],
  [679, 24, 789],
  [124, 74, 149],
  [125, 86, 358],
  [566, 78, 440],
  [360, 91, 470]
],

"11/27/2023 to 12/03/2023": [
  [688, 23, 670],
  [468, 88, 459],
  [370, "07", 269],
  [347, 49, 379],
  [257, 45, 267],
  [160, 70, 479],
  [577, 90, 127]
],

"12/04/2023 to 12/10/2023": [
  [455, 49, 225],
  [357, 56, 790],
  [138, 22, 255],
  [225, 91, 245],
  [279, 81, 146],
  [789, 44, 112],
  [390, 20, 370]
],

"12/11/2023 to 12/17/2023": [
  [237, 22, 147],
  [899, 67, 700],
  [457, 68, 116],
  [368, 72, 129],
  [468, 81, 669],
  [669, 12, 570],
  [260, 86, 367]
],

"12/18/2023 to 12/24/2023": [
  [478, 98, 224],
  [447, 50, 136],
  [225, 95, 456],
  [145, "08", 468],
  [145, "03", 238],
  [289, 95, 348],
  [126, 95, 258]
],

"12/25/2023 to 12/31/2023": [
  [489, 15, 230],
  [235, "05", 258],
  [167, 42, 156],
  [110, 21, 146],
  [138, 20, 668],
  [378, 82, 679],
  [227, 11, 137]
],


 "01/01/2024 to 01/07/2024": [
  [568, 93, 300],
  [233, 82, 480],
  [130, 44, 590],
  [790, 69, 667],
  [457, 60, 235],
  [129, 29, 450],
  [277, 64, 130]
],

"01/08/2024 to 01/14/2024": [
  [188, 75, 339],
  [188, 73, 148],
  [170, 88, 134],
  [289, 95, 168],
  [190, "01", 678],
  [778, 21, 137],
  [467, 76, 457]
],

"01/15/2024 to 01/21/2024": [
  [560, 12, 688],
  [288, 85, 889],
  [137, 16, 349],
  [156, 23, 166],
  [158, 42, 147],
  [280, "01", 146],
  [157, 38, 260]
],

"01/22/2024 to 01/28/2024": [
  ["000", "01", 245],
  [445, 30, 244],
  [450, 91, 155],
  [568, 97, 890],
  [156, 23, 166],
  [356, 48, 279],
  [590, 40, 145]
],

"01/29/2024 to 02/04/2024": [
  [669, 14, 149],
  [599, 32, 246],
  [137, 14, 356],
  [347, 47, 250],
  [349, 66, 790],
  [116, 83, 490],
  [155, 10, 136]
],

"02/05/2024 to 02/11/2024": [
  [350, 88, 990],
  [499, 27, 133],
  [589, 21, 470],
  [336, 24, 347],
  [456, 59, 289],
  [190, "09", 469],
  [336, 27, 278]
],

"02/12/2024 to 02/18/2024": [
  [377, 72, 480],
  [367, 63, 689],
  [579, 10, 190],
  [299, "08", 288],
  [345, 24, 257],
  [369, 81, 137],
  [157, 35, 780]
],

"02/19/2024 to 02/25/2024": [
  [148, 31, 470],
  [125, 80, 389],
  [489, 17, 223],
  [356, 49, 360],
  [239, 42, 147],
  [260, 88, 369],
  [350, 86, 259]
],

"02/26/2024 to 03/03/2024": [
  [247, 34, 239],
  [130, 44, 239],
  [346, 30, 479],
  [127, "05", 159],
  [350, 88, 279],
  [550, "02", 156],
  [367, 64, 248]
],


"03/04/2024 to 03/10/2024": [
  [139, 34, 455],
  [560, 10, 460],
  [349, 62, 156],
  [690, 59, 180],
  [245, 19, 360],
  [667, 98, 233],
  [349, 66, 880]
],

"03/11/2024 to 03/17/2024": [
  [369, 80, 370],
  [290, 16, 899],
  [457, 69, 234],
  [355, 32, 138],
  [126, 94, 158],
  [447, 56, 349],
  [112, 44, 356]
],

"03/18/2024 to 03/24/2024": [
  [470, 11, 137],
  [790, 65, 140],
  [477, 80, 127],
  [678, 16, 259],
  [146, 13, 238],
  [890, 73, 166],
  [249, 54, 167]
],

"03/25/2024 to 03/31/2024": [
  [479, "07", 179],
  [360, 91, 137],
  [455, 41, 146],
  [479, "03", 580],
  [299, "09", 135],
  [289, 93, 670],
  [156, 23, 166]
],

"04/01/2024 to 04/07/2024": [
  [267, 50, 190],
  [124, 71, 245],
  [160, 77, 223],
  [900, 94, 446],
  [990, 87, 269],
  [890, 77, 467],
  [134, 80, 235]
],

"04/08/2024 to 04/14/2024": [
  [380, 13, 238],
  [249, 52, 147],
  [158, 47, 467],
  [589, 23, 111],
  [256, 32, 345],
  [349, 68, 990],
  [790, 64, 248]
],

"04/15/2024 to 04/21/2024": [
  [289, 94, 167],
  [245, 19, 199],
  [588, 10, 145],
  [228, 23, 346],
  [180, 92, 499],
  [800, 86, 600],
  [120, 39, 135]
],

"04/22/2024 to 04/28/2024": [
  [299, "02", 679],
  [138, 25, 249],
  [349, 68, 800],
  [489, 16, 367],
  [479, 0, 677],
  [237, 24, 356],
  [359, 74, 347]
],

"04/29/2024 to 05/05/2024": [
  [577, 94, 770],
  [266, 45, 249],
  [139, 38, 800],
  [112, 42, 138],
  [567, 87, 458],
  [579, 19, 379],
  [339, 51, 290]
],


 "05/06/2024 to 05/12/2024": [
  [269, 71, 399],
  [688, 21, 560],
  [118, "08", 459],
  [450, 97, 269],
  [356, 46, 899],
  [112, 44, 239],
  [578, "08", 567]
],

"05/13/2024 to 05/19/2024": [
  [377, 72, 570],
  [356, 47, 124],
  [226, "09", 568],
  [558, 86, 240],
  [178, 67, 700],
  [790, 65, 500],
  [389, "07", 188]
],

"05/20/2024 to 05/26/2024": [
  [600, 65, 348],
  [188, 79, 117],
  [380, 12, 778],
  [156, 21, 678],
  [677, "06", 169],
  [133, 77, 359],
  [799, 51, 146]
],

"05/27/2024 to 06/02/2024": [
  [290, 11, 128],
  [148, 31, 489],
  [125, 82, 147],
  [468, 82, 156],
  [357, 51, 344],
  [356, 46, 367],
  [125, 85, 690]
],

"06/03/2024 to 06/09/2024": [
  [260, 87, 269],
  [350, 82, 570],
  [678, 12, 390],
  [490, 32, 480],
  [360, 91, 236],
  [239, 42, 679],
  [470, 14, 257]
],

"06/24/2024 to 06/30/2024": [
  [478, 90, 569],
  [250, 71, 334],
  [457, 69, 234],
  [118, "08", 558],
  [125, 82, 688],
  [134, 81, 119],
  [268, 68, 480]
],

"07/01/2024 to 07/07/2024": [
  ["688", "27", "566"],
  ["679", "23", "157"],
  ["130", "42", "480"],
  ["900", "99", "180"],
  ["367", "68", "468"],
  ["568", "97", "467"],
  ["250", "79", "289"]
],

"07/08/2024 to 07/14/2024": [
  ["578", "01", "334"],
  ["788", "36", "367"],
  ["129", "26", "556"],
  ["789", "48", "116"],
  ["389", "05", "357"],
  ["370", "08", "477"],
  ["499", "27", "278"]
],

"07/15/2024 to 07/21/2024": [
  ["680", "42", "138"],
  ["588", "10", "235"],
  ["500", "51", "470"],
  ["238", "30", "145"],
  ["466", "66", "244"],
  ["180", "93", "337"],
  ["237", "24", "149"]
],

"07/22/2024 to 07/28/2024": [
  ["249", "53", "670"],
  ["267", "58", "170"],
  ["190", "03", "580"],
  ["134", "81", "579"],
  ["800", "81", "588"],
  ["899", "63", "120"],
  ["459", "80", "226"]
],

  "12/30/2024 to 01/05/2025": [
     [790, 64, 248],
     [144, 93, 166],
     [148, 32, 147],
     [357, 57, 160],
     [126, 94, 248],
     [167, 41, 236],
     [466, 61, 678],
  ],
  "01/06/2025 to 01/12/2025": [
     [700, 76, 178],
     [578, "01", 290],
     [124, 76, 556],
     [230, 55, 113],
     [239, 44, 130],
     [360, 93, 580],
     [177, 55, 168],
  ],
  "01/13/2025 to 01/19/2025": [
   [480, 21, 227],
   [378, 83, 148],
   [689, 33, 445],
   [227, 14, 158],
   [550, "09", 117],
   [389, "00", 578],
   [490, 37, 269],
],
};
export const MADHURNIGHT = {
  "01/02/2023 to 01/08/2023": [
    ["355", "32", "255"],
    ["450", "93", "490"],
    ["147", "26", "358"],
    ["450", "98", "369"],
    ["115", "77", "269"],
    ["124", "73", "238"],
  ],
  "01/09/2023 to 01/15/2023": [
     ["335", "17", "467"],
     ["467", "76", "899"],
     ["234", "98", "567"],
     ["125", "88", "116"],
     ["190", "04", "239"],
     ["400", "47", "269"],
  ],
  "01/16/2023 to 01/22/2023": [
     ["368", "72", "147"],
     ["899", "69", "180"],
     ["256", "31", "290"],
     ["146", "15", "122"],
     ["570", "20", "389"],
     ["399", "16", "268"],
  ],
  "01/23/2023 to 01/29/2023": [
    ["570", "20", "389"],
     ["489", "12", "589"],
     ["389", "01", "137"],
     ["100", "10", "460"],
     ["490", "36", "330"],
     ["190", "03", "148"],
  ],
  "01/30/2023 to 02/05/2023": [
     ["236", "12", "138"],
     ["169", "61", "335"],
     ["770", "45", "267"],
     ["338", "40", "479"],
     ["689", "38", "440"],
     ["455", "44", "239"],
  ],
  "02/06/2023 to 02/12/2023": [
     ["457", "66", "790"],
     ["990", "88", "279"],
     ["356", "45", "447"],
     ["125", "86", "150"],
     ["299", "06", "556"],
     ["160", "71", "137"],
  ],
  "02/13/2023 to 02/19/2023": [
     ["230", "50", "389"],
     ["239", "49", "270"],
     ["800", "84", "239"],
     ["168", "52", "246"],
     ["340", "71", "470"],
     ["480", "24", "167"],
  ],
  "02/20/2023 to 02/26/2023": [
     ["237", "23", "580"],
     ["256", "31", "245"],
     ["488", "07", "890"],
     ["569", "05", "258"],
     ["346", "37", "124"],
     ["889", "50", "569"],
  ],
  "02/27/2023 to 03/05/2023": [
     ["146", "16", "123"],
     ["477", "82", "138"],
     ["669", "15", "447"],
     ["158", "42", "688"],
     ["367", "62", "138"],
     ["130", "49", "667"],
  ],
  "03/06/2023 to 03/12/2023": [
     ["146", "16", "123"],
     ["477", "82", "138"],
      ["570", "20", "389"], 
     ["238", "32", "129"],
     ["126", "90", "569"],
     ["458", "79", "180"],
  ],
  "03/13/2023 to 03/19/2023": [
     ["990", "83", "120"],
     ["458", "78", "369"],
     ["147", "25", "168"],
     ["377", "75", "799"],
     ["348", "59", "126"],
     ["350", "88", "459"],
  ],
  "03/20/2023 to 03/26/2023": [
     ["389", "01", "669"],
     ["570", "25", "799"],
     ["446", "43", "670"],
     ["690", "58", "170"],
     ["170", "84", "130"],
     ["679", "21", "470"],
  ],
  "03/27/2023 to 04/02/2023": [
     ["248", "40", "479"],
     ["258", "56", "259"],
     ["390", "20", "370"],
     ["130", "44", "356"],
     ["240", "62", "129"],
     ["356", "40", "677"],
  ],
  "04/03/2023 to 04/09/2023": [
     ["389", "07", "700"],
     ["248", "45", "357"],
     ["158", "40", "136"],
     ["389", "04", "130"],
     ["360", "97", "890"],
     ["477", "80", "460"],
  ],
  "04/10/2023 to 04/16/2023": [
     ["234", "95", "249"],
     ["559", "92", "679"],
     ["348", "51", "470"],
     ["115", "79", "379"],
     ["337", "31", "380"],
     ["249", "56", "349"],
  ],
  "04/17/2023 to 04/23/2023": [
     ["380", "15", "113"],
     ["166", "32", "589"],
     ["133", "78", "350"],
     ["129", "22", "336"],
     ["677", "09", "478"],
     ["579", "13", "238"],
  ],
  "04/24/2023 to 04/30/2023": [
     ["577", "97", "890"],
     ["225", "92", "660"],
     ["335", "16", "268"],
     ["357", "50", "578"],
     ["445", "33", "247"],
     ["780", "50", "226"],
  ],
  "05/01/2023 to 05/07/2023": [
     ["260", "85", "168"],
     ["169", "67", "377"],
     ["134", "83", "120"],
     ["357", "54", "112"],
     ["478", "91", "489"],
     ["246", "20", "389"],
  ],
  "05/08/2023 to 05/14/2023": [
     ["335", "18", "279"],
     ["368", "71", "155"],
     ["499", "22", "129"],
     ["690", "51", "155"],
     ["690", "55", "258"],
     ["458", "73", "670"],
  ],
  "05/15/2023 to 05/21/2023": [
     ["368", "77", "223"],
     ["230", "58", "468"],
     ["239", "42", "237"],
     ["149", "42", "147"],
     ["146", "15", "456"],
     ["468", "87", "890"],
  ],
  "05/22/2023 to 05/28/2023": [
     ["289", "91", "380"],
     ["115", "76", "240"],
     ["589", "20", "677"],
     ["460", "02", "778"],
     ["679", "23", "148"],
     ["168", "53", "148"],
  ],
  "05/29/2023 to 06/04/2023": [
     ["478", "99", "117"],
     ["480", "25", "267"],
     ["789", "44", "590"],
     ["479", "05", "140"],
     ["330", "67", "133"],
     ["458", "77", "124"],
  ],
  "06/05/2023 to 06/11/2023": [
     ["399", "12", "147"],
     ["669", "18", "170"],
     ["367", "63", "148"],
     ["279", "83", "300"],
     ["489", "17", "458"],
     ["224", "81", "470"],
  ],
  "06/12/2023 to 06/18/2023": [
     ["237", "22", "345"],
     ["557", "73", "247"],
     ["490", "37", "368"],
     ["779", "32", "255"],
     ["570", "27", "467"],
     ["348", "50", "127"],
  ],
  "06/19/2023 to 06/25/2023": [
     ["128", "10", "389"],
     ["160", "77", "467"],
     ["790", "63", "346"],
     ["567", "85", "780"],
     ["590", "44", "158"],
     ["580", "34", "149"],
  ],
  "06/26/2023 to 07/02/2023": [
     ["677", "08", "459"],
     ["290", "19", "360"],
     ["235", "00", "127"],
     ["680", "49", "234"],
     ["230", "55", "447"],
     ["120", "34", "680"],
  ],
  "07/03/2023 to 07/09/2023": [
     ["799", "56", "169"],
     ["235", "03", "788"],
     ["578", "07", "557"],
     ["388", "98", "260"],
     ["128", "19", "225"],
     ["457", "66", "240"],
  ],
  "07/10/2023 to 07/16/2023": [
     ["550", "03", "157"],
     ["390", "28", "125"],
     ["448", "64", "590"],
     ["150", "67", "160"],
     ["450", "91", "236"],
     ["234", "97", "124"],
  ],
  "07/17/2023 to 07/23/2023": [
     ["180", "99", "270"],
     ["690", "59", "568"],
     ["360", "93", "139"],
     ["360", "90", "488"],
     ["358", "68", "260"],
     ["479", "01", "245"],
  ],
  "07/24/2023 to 07/30/2023": [
     ["129", "22", "246"],
     ["233", "86", "556"],
     ["267", "51", "678"],
     ["440", "88", "459"],
     ["244", "06", "349"],
     ["239", "48", "558"],
  ],
  "07/31/2023 to 08/06/2023": [
     ["388", "90", "235"],
     ["134", "80", "145"],
     ["226", "09", "126"],
     ["348", "54", "167"],
     ["557", "76", "457"],
     ["468", "87", "160"],
  ],
  "08/07/2023 to 08/13/2023": [
     ["679", "22", "228"],
     ["700", "71", "669"],
     ["238", "32", "390"],
     ["780", "58", "224"],
     ["248", "43", "238"],
     ["146", "13", "139"],
  ],
  "08/14/2023 to 08/20/2023": [
     ["289", "97", "133"],
     ["780", "58", "224"],
     ["147", "21", "344"],
     ["146", "16", "150"],
     ["225", "95", "159"],
     ["350", "86", "600"],
  ],
  "08/21/2023 to 08/27/2023": [
     ["358", "61", "137"],
     ["456", "54", "248"],
     ["880", "62", "570"],
     ["136", "08", "288"],
     ["467", "77", "458"],
     ["569", "04", "257"],
  ],
  "08/28/2023 to 09/03/2023": [
     ["149", "46", "457"],
     ["138", "20", "550"],
     ["148", "33", "788"],
     ["160", "73", "139"],
     ["115", "77", "115"],
     ["125", "83", "689"],
  ],
  "09/04/2023 to 09/10/2023": [
     ["130", "45", "348"],
     ["123", "60", "578"],
     ["369", "86", "123"],
     ["270", "94", "400"],
     ["125", "88", "459"],
     ["449", "71", "678"],
  ],
  "09/11/2023 to 09/17/2023": [
     ["488", "06", "358"],
     ["380", "18", "134"],
     ["560", "18", "134"],
     ["690", "59", "450"],
     ["156", "20", "190"],
     ["188", "79", "135"],
  ],
  "09/18/2023 to 09/24/2023": [
     ["160", "77", "340"],
     ["689", "35", "348"],
     ["129", "25", "456"],
     ["688", "21", "380"],
     ["278", "73", "670"],
     ["367", "63", "148"],
  ],
  "09/25/2023 to 10/01/2023": [
     ["126", "93", "148"],
     ["136", "00", "299"],
     ["256", "38", "279"],
     ["237", "22", "228"],
     ["346", "33", "148"],
     ["560", "16", "358"],
  ],
  "10/02/2023 to 10/08/2023": [
     ["228", "27", "179"],
     ["600", "66", "277"],
     ["158", "46", "349"],
     ["300", "31", "236"],
     ["670", "35", "339"],
     ["167", "44", "167"],
  ],
  "10/09/2023 to 10/15/2023": [
     ["160", "78", "134"],
     ["568", "92", "138"],
     ["330", "66", "169"],
     ["457", "62", "345"],
     ["440", "87", "890"],
     ["135", "98", "260"],
  ],
  "10/16/2023 to 10/22/2023": [
     ["144", "91", "380"],
     ["445", "33", "256"],
     ["134", "82", "778"],
     ["389", "00", "488"],
     ["260", "83", "148"],
     ["346", "35", "140"],
  ],
  "10/23/2023 to 10/29/2023": [
     ["140", "53", "120"],
     ["129", "23", "256"],
     ["160", "74", "356"],
     ["378", "85", "267"],
     ["380", "15", "249"],
     ["370", "02", "679"],
  ],
  "10/30/2023 to 11/05/2023": [
     ["138", "23", "238"],
     ["358", "69", "900"],
     ["580", "33", "139"],
     ["350", "85", "140"],
     ["688", "26", "277"],
     ["350", "81", "678"],
  ],
  "11/06/2023 to 11/12/2023": [
     ["266", "42", "660"],
     ["235", "05", "249"],
     ["670", "32", "246"],
     ["238", "34", "130"],
      ["780", "58", "224"],
       ["266", "42", "660"],
  ],
  "11/20/2023 to 11/26/2023": [
     ["250", "71", "128"],
     ["366", "52", "129"],
     ["379", "94", "789"],
     ["799", "53", "670"],
     ["348", "57", "269"],
     ["578", "09", "360"],
  ],
  "11/27/2023 to 12/03/2023": [
     ["680", "41", "579"],
     ["400", "49", "469"],
     ["578", "07", "160"],
     ["130", "45", "159"],
     ["679", "24", "149"],
     ["568", "99", "234"],
  ],
  "12/04/2023 to 12/10/2023": [
     ["780", "52", "200"],
     ["117", "96", "277"],
     ["114", "66", "123"],
     ["180", "97", "368"],
     ["255", "20", "569"],
     ["278", "71", "489"],
  ],
  "12/11/2023 to 12/17/2023": [
     ["356", "44", "112"],
     ["468", "83", "490"],
     ["269", "74", "338"],
     ["157", "33", "166"],
     ["790", "65", "690"],
     ["237", "28", "468"],
  ],
  "12/18/2023 to 12/24/2023": [
     ["158", "46", "123"],
     ["348", "59", "388"],
     ["380", "17", "377"],
     ["249", "54", "149"],
     ["129", "29", "126"],
     ["244", "02", "570"],
  ],
  "12/25/2023 to 12/31/2023": [
     ["125", "82", "147"],
     ["100", "19", "450"],
     ["259", "63", "346"],
     ["270", "92", "156"],
     ["246", "21", "588"],
     ["114", "67", "890"],
  ],
  "01/01/2024 to 01/07/2024": [
     ["890", "75", "168"],
     ["159", "54", "699"],
     ["357", "50", "127"],
     ["349", "69", "126"],
     ["780", "56", "240"],
     ["880", "62", "480"],
  ],
  "01/08/2024 to 01/14/2024": [
     ["660", "23", "445"],
     ["560", "15", "249"],
     ["379", "98", "378"],
     ["345", "26", "114"],
     ["249", "55", "230"],
     ["569", "05", "456"],
  ],
  "01/15/2024 to 01/21/2024": [
     ["558", "89", "360"],
     ["457", "60", "578"],
     ["290", "12", "679"],
     ["346", "31", "579"],
     ["269", "74", "699"],
     ["346", "39", "234"],
  ],
  "01/22/2024 to 01/28/2024": [
     ["449", "76", "457"],
     ["236", "16", "259"],
     ["477", "80", "226"],
     ["234", "92", "138"],
 ["780", "58", "224"],
     ["120", "31", "560"],
  ],
  "01/29/2024 to 02/04/2024": [
     ["147", "23", "139"],
     ["480", "25", "258"],
     ["899", "67", "340"],
     ["116", "88", "233"],
     ["230", "58", "125"],
     ["580", "36", "150"],
  ],
  "02/05/2024 to 02/11/2024": [
     ["368", "72", "345"],
     ["589", "20", "460"],
     ["358", "61", "290"],
     ["128", "19", "450"],
     ["380", "13", "670"],
     ["116", "86", "259"],
  ],
  "02/12/2024 to 02/18/2024": [
     ["590", "46", "448"],
     ["337", "37", "700"],
     ["890", "72", "345"],
     ["280", "08", "378"],
     ["599", "37", "160"],
     ["670", "35", "456"],
  ],
  "02/19/2024 to 02/25/2024": [
     ["778", "20", "190"],
     ["123", "63", "148"],
     ["550", "01", "245"],
     ["190", "02", "138"],
     ["226", "06", "240"],
     ["348", "56", "123"],
  ],
  "02/26/2024 to 03/03/2024": [
     ["147", "27", "124"],
     ["667", "94", "257"],
     ["129", "21", "236"],
     ["350", "83", "337"],
     ["789", "44", "149"],
     ["480", "21", "399"],
  ],
  "03/04/2024 to 03/10/2024": [
     ["556", "60", "479"],
     ["359", "73", "346"],
     ["550", "09", "225"],
     ["467", "70", "235"],
     ["359", "75", "456"],
     ["689", "37", "188"],
  ],
  "03/11/2024 to 03/17/2024": [
     ["366", "59", "126"],
     ["468", "88", "350"],
     ["699", "45", "168"],
     ["189", "87", "133"],
     ["159", "59", "450"],
     ["570", "23", "157"],
  ],
  "03/18/2024 to 03/24/2024": [
     ["600", "65", "168"],
     ["125", "84", "347"],
     ["289", "94", "149"],
     ["357", "55", "348"],
     ["188", "71", "245"],
     ["890", "77", "340"],
  ],
  "03/25/2024 to 03/31/2024": [
     ["156", "27", "368"],
     ["278", "78", "279"],
     ["246", "28", "260"],
     ["556", "62", "345"],
     ["579", "10", "235"],
      ["266", "42", "660"],
  ],
  "04/01/2024 to 04/07/2024": [
     ["335", "14", "590"],
     ["467", "73", "256"],
     ["224", "86", "150"],
     ["190", "08", "279"],
     ["240", "69", "144"],
     ["260", "83", "247"],
  ],
  "04/08/2024 to 04/14/2024": [
     ["156", "28", "170"],
     ["788", "31", "128"],
     ["270", "96", "349"],
     ["128", "14", "257"],
     ["234", "90", "280"],
     ["690", "53", "346"],
  ],
  "04/15/2024 to 04/21/2024": [
     ["237", "20", "145"],
     ["148", "39", "478"],
     ["778", "24", "257"],
     ["188", "70", "578"],
     ["140", "55", "168"],
     ["114", "67", "124"],
  ],
  "04/22/2024 to 04/28/2024": [
     ["130", "45", "159"],
     ["590", "44", "789"],
     ["489", "12", "255"],
     ["249", "52", "147"],
     ["557", "73", "238"],
     ["380", "15", "456"],
  ],
  "04/29/2024 to 05/05/2024": [
     ["778", "26", "240"],
     ["880", "60", "389"],
     ["470", "10", "578"],
     ["360", "94", "400"],
     ["560", "12", "228"],
     ["589", "21", "128"],
  ],
  "05/06/2024 to 05/12/2024": [
     ["267", "53", "247"],
     ["700", "72", "147"],
     ["568", "93", "490"],
     ["449", "75", "447"],
     ["469", "90", "244"],
     ["378", "81", "236"],
  ],
  "05/13/2024 to 05/19/2024": [
     ["468", "81", "137"],
     ["700", "77", "223"],
     ["660", "29", "234"],
     ["246", "22", "570"],
     ["489", "11", "579"],
     ["117", "94", "257"],
  ],
  "05/20/2024 to 05/26/2024": [
     ["133", "71", "579"],
     ["235", "03", "490"],
     ["168", "50", "460"],
     ["267", "56", "268"],
     ["139", "31", "128"],
     ["335", "18", "990"],
  ],
  "05/27/2024 to 06/02/2024": [
     ["899", "63", "779"],
     ["235", "02", "390"],
     ["289", "91", "560"],
     ["690", "58", "170"],
     ["157", "30", "668"],
     ["278", "77", "449"],
  ],
  "06/03/2024 to 06/09/2024": [
     ["157", "36", "169"],
     ["477", "87", "449"],
     ["240", "63", "120"],
     ["190", "00", "145"],
     ["589", "25", "267"],
     ["599", "31", "119"],
  ],
  "06/10/2024 to 06/16/2024": [
     ["670", "38", "350"],
     ["380", "14", "338"],
     ["445", "36", "880"],
     ["290", "12", "390"],
     ["156", "28", "134"],
     ["469", "98", "800"],
  ],
  "06/17/2024 to 06/23/2024": [
     ["145", "08", "260"],
     ["488", "07", "179"],
     ["369", "82", "237"],
     ["110", "24", "167"],
     ["240", "61", "236"],
     ["249", "59", "469"],
  ],
  "06/24/2024 to 06/30/2024": [
     ["279", "88", "567"],
     ["113", "52", "660"],
     ["700", "75", "258"],
     ["127", "07", "368"],
     ["237", "28", "125"],
     ["230", "58", "260"],
  ],
  "07/01/2024 to 07/07/2024": [
     ["356", "43", "580"],
     ["558", "87", "359"],
     ["560", "10", "145"],
     ["150", "62", "589"],
     ["127", "01", "579"],
     ["244", "04", "248"],
  ],
  "07/08/2024 to 07/14/2024": [
     ["889", "59", "450"],
     ["589", "26", "259"],
     ["479", "07", "566"],
     ["457", "60", "370"],
     ["237", "27", "160"],
     ["469", "94", "590"],
  ],
};
export const RAJDHANIDAY = {
  "01/02/2023 to 01/08/2023": [
     ["469", "98", "170"],
     ["150", "60", "280"],
     ["556", "64", "789"],
     ["156", "23", "779"],
     ["130", "43", "157"],
     ["560", "11", "380"],
  ],
  "01/09/2023 to 01/15/2023": [
     ["278", "74", "167"],
     ["700", "78", "134"],
     ["360", "98", "440"],
     ["233", "86", "240"],
     ["145", "01", "146"],
     ["560", "13", "490"],
  ],
  "01/16/2023 to 01/22/2023": [
     ["589", "22", "390"],
     ["179", "78", "350"],
     ["260", "89", "234"],
     ["660", "22", "156"],
     ["244", "04", "680"],
     ["345", "27", "377"],
  ],
  "01/23/2023 to 01/29/2023": [
     ["890", "75", "140"],
     ["340", "73", "490"],
     ["236", "19", "379"],
     ["345", "27", "377"],
     ["900", "91", "588"],
     ["359", "78", "134"],
  ],
  "01/30/2023 to 02/05/2023": [
     ["347", "40", "668"],
     ["459", "86", "330"],
     ["579", "11", "470"],
     ["240", "69", "469"],
     ["350", "84", "257"],
     ["378", "89", "180"],
  ],
  "02/06/2023 to 02/12/2023": [
     ["670", "37", "359"],
     ["169", "69", "135"],
     ["669", "10", "334"],
     ["245", "15", "168"],
     ["339", "57", "269"],
     ["359", "72", "129"],
  ],
  "02/13/2023 to 02/19/2023": [
     ["440", "86", "556"],
     ["460", "02", "570"],
     ["690", "52", "390"],
     ["578", "05", "230"],
     ["236", "13", "256"],
     ["334", "01", "560"],
  ],
  "02/20/2023 to 02/26/2023": [
     ["789", "45", "159"],
     ["469", "95", "357"],
     ["112", "46", "240"],
     ["280", "00", "136"],
     ["129", "21", "588"],
     ["125", "89", "135"],
  ],
  "02/27/2023 to 03/05/2023": [
     ["450", "92", "138"],
     ["668", "09", "270"],
     ["123", "64", "158"],
     ["189", "87", "269"],
     ["489", "12", "237"],
     ["114", "60", "145"],
  ],
  "03/06/2023 to 03/12/2023": [
     ["146", "15", "780"],
     ["356", "41", "560"],
     ["189", "87", "269"],
     ["690", "53", "337"],
     ["137", "10", "668"],
     ["379", "96", "349"],
  ],
  "03/13/2023 to 03/19/2023": [
     ["689", "32", "138"],
     ["900", "99", "135"],
     ["159", "50", "244"],
     ["479", "05", "249"],
     ["688", "23", "490"],
     ["158", "45", "690"],
  ],
  "03/20/2023 to 03/26/2023": [
     ["344", "12", "570"],
     ["156", "26", "169"],
     ["456", "53", "120"],
     ["990", "87", "467"],
     ["157", "34", "149"],
     ["578", "03", "166"],
  ],
  "03/27/2023 to 04/02/2023": [
     ["570", "27", "458"],
     ["177", "50", "370"],
     ["135", "93", "599"],
     ["567", "84", "158"],
     ["378", "81", "137"],
     ["669", "14", "356"],
  ],
  "04/03/2023 to 04/09/2023": [
     ["256", "39", "568"],
     ["340", "75", "113"],
     ["299", "00", "190"],
     ["145", "05", "168"],
     ["356", "40", "569"],
     ["680", "47", "359"],
  ],
  "04/10/2023 to 04/16/2023": [
     ["558", "83", "490"],
     ["120", "37", "340"],
     ["239", "40", "127"],
     ["449", "71", "155"],
     ["236", "16", "358"],
     ["247", "33", "346"],
  ],
  "04/17/2023 to 04/23/2023": [
     ["169", "65", "249"],
     ["168", "50", "334"],
     ["335", "12", "679"],
     ["159", "52", "345"],
     ["677", "01", "588"],
     ["270", "99", "360"],
  ],
  "04/24/2023 to 04/30/2023": [
     ["130", "45", "780"],
     ["350", "89", "180"],
     ["248", "43", "157"],
     ["670", "34", "347"],
     ["135", "97", "269"],
     ["789", "48", "134"],
  ],
  "05/01/2023 to 05/07/2023": [
     ["224", "80", "460"],
     ["227", "13", "148"],
     ["256", "33", "157"],
     ["230", "58", "440"],
     ["128", "17", "160"],
     ["299", "00", "668"],
  ],
  "05/08/2023 to 05/14/2023": [
     ["157", "33", "490"],
     ["469", "94", "699"],
     ["147", "20", "127"],
     ["139", "34", "149"],
     ["136", "01", "245"],
     ["440", "80", "479"],
  ],
  "05/15/2023 to 05/21/2023": [
     ["450", "97", "133"],
     ["249", "55", "456"],
     ["359", "71", "335"],
     ["233", "80", "578"],
     ["156", "22", "345"],
     ["990", "83", "346"],
  ],
  "05/22/2023 to 05/28/2023": [
     ["239", "41", "579"],
     ["359", "71", "290"],
     ["345", "22", "480"],
     ["479", "08", "990"],
     ["128", "15", "230"],
     ["489", "18", "369"],
  ],
  "05/29/2023 to 06/04/2023": [
     ["166", "35", "159"],
     ["136", "07", "269"],
     ["570", "21", "380"],
     ["390", "28", "189"],
     ["280", "04", "356"],
     ["160", "70", "677"],
  ],
  "06/05/2023 to 06/11/2023": [
     ["234", "99", "667"],
     ["460", "03", "157"],
     ["135", "97", "340"],
     ["244", "04", "789"],
     ["257", "42", "129"],
     ["117", "96", "466"],
  ],
  "06/12/2023 to 06/18/2023": [
     ["290", "16", "150"],
     ["235", "06", "349"],
     ["577", "94", "590"],
     ["247", "37", "557"],
     ["190", "02", "390"],
     ["144", "99", "126"],
  ],
  "06/19/2023 to 06/25/2023": [
     ["167", "42", "147"],
     ["680", "49", "469"],
     ["899", "60", "145"],
     ["260", "88", "567"],
     ["349", "61", "669"],
     ["128", "16", "123"],
  ],
  "06/26/2023 to 07/02/2023": [
     ["560", "13", "120"],
     ["360", "97", "115"],
     ["130", "42", "679"],
     ["238", "31", "489"],
     ["166", "31", "588"],
     ["358", "67", "368"],
  ],
  "07/03/2023 to 07/09/2023": [
     ["488", "08", "378"],
     ["370", "07", "250"],
     ["150", "60", "145"],
     ["270", "97", "160"],
     ["119", "19", "469"],
     ["334", "08", "260"],
  ],
  "07/10/2023 to 07/16/2023": [
     ["469", "90", "479"],
     ["568", "98", "134"],
     ["266", "46", "114"],
     ["248", "48", "260"],
     ["480", "25", "258"],
     ["360", "92", "147"],
  ],
  "07/17/2023 to 07/23/2023": [
     ["157", "35", "690"],
     ["268", "60", "145"],
     ["122", "51", "678"],
     ["490", "35", "500"],
     ["267", "59", "270"],
     ["380", "15", "230"],
  ],
  "07/24/2023 to 07/30/2023": [
     ["459", "87", "269"],
     ["134", "89", "360"],
     ["245", "16", "268"],
     ["124", "78", "125"],
     ["556", "63", "139"],
     ["229", "31", "236"],
  ],
  "07/31/2023 to 08/06/2023": [
     ["390", "28", "567"],
     ["580", "36", "259"],
     ["233", "89", "478"],
     ["456", "59", "289"],
     ["360", "94", "130"],
     ["370", "00", "370"],
  ],
  "08/07/2023 to 08/13/2023": [
     ["239", "48", "800"],
     ["268", "62", "246"],
     ["567", "87", "340"],
     ["233", "86", "178"],
     ["115", "73", "670"],
     ["990", "84", "789"],
  ],
  "08/14/2023 to 08/20/2023": [
     ["578", "02", "138"],
     ["115", "73", "670"],
     ["670", "30", "677"],
     ["550", "09", "126"],
     ["248", "49", "135"],
     ["690", "55", "780"],
  ],
  "08/21/2023 to 08/27/2023": [
     ["269", "72", "138"],
     ["447", "50", "136"],
     ["330", "64", "248"],
     ["469", "94", "130"],
     ["260", "81", "245"],
     ["446", "45", "230"],
  ],
  "08/28/2023 to 09/03/2023": [
     ["490", "34", "112"],
     ["460", "03", "256"],
     ["580", "32", "129"],
     ["990", "82", "228"],
     ["159", "57", "458"],
     ["110", "22", "390"],
  ],
  "09/04/2023 to 09/10/2023": [
     ["130", "41", "380"],
     ["133", "77", "250"],
     ["158", "49", "180"],
     ["689", "35", "168"],
     ["228", "23", "148"],
     ["234", "93", "580"],
  ],
  "09/11/2023 to 09/17/2023": [
     ["136", "07", "467"],
     ["167", "49", "199"],
     ["450", "99", "388"],
     ["467", "70", "479"],
     ["155", "15", "690"],
     ["246", "29", "234"],
  ],
  "09/18/2023 to 09/24/2023": [
     ["668", "07", "160"],
     ["140", "55", "339"],
     ["267", "51", "470"],
     ["400", "40", "190"],
     ["137", "17", "359"],
     ["550", "01", "579"],
  ],
  "09/25/2023 to 10/01/2023": [
     ["180", "97", "467"],
     ["244", "08", "288"],
     ["235", "05", "159"],
     ["238", "34", "112"],
     ["168", "50", "190"],
     ["146", "14", "248"],
  ],
  "10/02/2023 to 10/08/2023": [
     ["340", "79", "450"],
     ["118", "05", "168"],
     ["189", "84", "220"],
     ["120", "36", "169"],
     ["470", "17", "160"],
     ["133", "72", "156"],
  ],
  "10/09/2023 to 10/15/2023": [
     ["490", "36", "268"],
     ["479", "07", "179"],
     ["558", "82", "237"],
     ["267", "59", "568"],
     ["360", "90", "280"],
     ["234", "91", "560"],
  ],
  "10/16/2023 to 10/22/2023": [
     ["122", "54", "239"],
     ["890", "75", "113"],
     ["260", "86", "114"],
     ["479", "07", "359"],
     ["678", "18", "378"],
     ["137", "10", "127"],
  ],
  "10/23/2023 to 10/29/2023": [
     ["389", "04", "356"],
     ["360", "98", "116"],
     ["139", "35", "348"],
     ["238", "31", "137"],
     ["589", "23", "157"],
     ["110", "24", "257"],
  ],
  "10/30/2023 to 11/05/2023": [
     ["370", "07", "368"],
     ["128", "15", "140"],
     ["266", "41", "236"],
     ["239", "46", "150"],
     ["129", "22", "237"],
     ["136", "01", "344"],
  ],
  "11/06/2023 to 11/12/2023": [
     ["579", "12", "589"],
     ["600", "68", "378"],
     ["460", "08", "440"],
     ["790", "64", "338"],
     ["136", "01", "344"],
     ["266", "41", "236"],
  ],
  "11/13/2023 to 11/19/2023": [
     ["266", "41", "236"],
     ["460", "08", "440"],
     ["370", "07", "368"],
     ["239", "46", "150"],
     ["268", "66", "790"],
     ["235", "09", "379"],
  ],
  "11/20/2023 to 11/26/2023": [
     ["226", "06", "349"],
     ["123", "63", "148"],
     ["290", "11", "579"],
     ["459", "86", "240"],
     ["257", "41", "344"],
     ["167", "40", "677"],
  ],
  "11/27/2023 to 12/03/2023": [
     ["235", "09", "379"],
     ["234", "94", "347"],
     ["268", "66", "790"],
     ["138", "24", "158"],
     ["478", "97", "467"],
     ["189", "80", "226"],
  ],
  "12/04/2023 to 12/10/2023": [
     ["346", "33", "689"],
     ["178", "64", "149"],
     ["344", "16", "367"],
     ["245", "15", "456"],
     ["379", "91", "128"],
     ["177", "59", "180"],
  ],
  "12/11/2023 to 12/17/2023": [
     ["257", "46", "178"],
     ["169", "63", "337"],
     ["599", "39", "450"],
     ["569", "07", "124"],
     ["167", "48", "350"],
     ["250", "79", "568"],
  ],
  "12/18/2023 to 12/24/2023": [
     ["379", "97", "160"],
     ["127", "02", "778"],
     ["126", "94", "149"],
     ["358", "66", "150"],
     ["390", "27", "179"],
     ["118", "03", "256"],
  ],
  "12/25/2023 to 12/31/2023": [
     ["137", "14", "239"],
     ["189", "87", "115"],
     ["780", "59", "180"],
     ["900", "92", "390"],
     ["124", "75", "366"],
     ["137", "11", "335"],
  ],
  "01/01/2024 to 01/07/2024": [
     ["129", "23", "148"],
     ["135", "99", "126"],
     ["179", "70", "479"],
     ["389", "05", "339"],
     ["246", "21", "678"],
     ["135", "99", "900"],
  ],
  "01/08/2024 to 01/14/2024": [
     ["255", "26", "123"],
     ["790", "64", "347"],
     ["118", "08", "350"],
     ["258", "50", "479"],
     ["180", "99", "577"],
     ["447", "50", "280"],
  ],
  "01/15/2024 to 01/21/2024": [
     ["678", "16", "790"],
     ["489", "17", "188"],
     ["179", "70", "460"],
     ["134", "83", "580"],
     ["770", "40", "389"],
     ["360", "91", "380"],
  ],
  "01/22/2024 to 01/28/2024": [
     ["790", "63", "355"],
     ["680", "45", "140"],
     ["150", "62", "147"],
     ["900", "95", "168"],
     ["770", "40", "389"],
     ["570", "21", "344"],
  ],
  "01/29/2024 to 02/04/2024": [
     ["247", "33", "148"],
     ["680", "46", "268"],
     ["158", "44", "130"],
     ["457", "60", "479"],
     ["677", "02", "480"],
     ["268", "62", "246"],
  ],
  "02/05/2024 to 02/11/2024": [
     ["126", "96", "358"],
     ["448", "67", "890"],
     ["125", "88", "477"],
     ["369", "81", "380"],
     ["127", "02", "345"],
     ["355", "31", "128"],
  ],
  "02/12/2024 to 02/18/2024": [
     ["149", "44", "356"],
     ["679", "23", "148"],
     ["446", "47", "359"],
     ["457", "64", "455"],
     ["580", "31", "236"],
     ["368", "70", "668"],
  ],
  "02/19/2024 to 02/25/2024": [
     ["479", "08", "459"],
     ["259", "66", "240"],
     ["278", "78", "558"],
     ["145", "03", "599"],
     ["577", "93", "580"],
     ["127", "00", "569"],
  ],
  "02/26/2024 to 03/03/2024": [
     ["289", "93", "120"],
     ["500", "57", "368"],
     ["380", "19", "568"],
     ["588", "13", "256"],
     ["360", "96", "178"],
     ["570", "28", "224"],
  ],
  "03/04/2024 to 03/10/2024": [
     ["300", "34", "220"],
     ["269", "73", "247"],
     ["499", "23", "689"],
     ["246", "28", "369"],
     ["257", "41", "678"],
     ["369", "84", "239"],
  ],
  "03/11/2024 to 03/17/2024": [
     ["133", "71", "236"],
     ["340", "77", "557"],
     ["200", "28", "189"],
     ["149", "42", "679"],
     ["359", "76", "349"],
     ["800", "89", "450"],
  ],
  "03/18/2024 to 03/24/2024": [
     ["289", "95", "168"],
     ["123", "66", "114"],
     ["880", "61", "128"],
     ["260", "80", "190"],
     ["145", "05", "456"],
     ["116", "83", "256"],
  ],
  "03/25/2024 to 03/31/2024": [
     ["590", "45", "140"],
     ["122", "58", "260"],
     ["669", "13", "166"],
     ["236", "10", "479"],
     ["190", "07", "890"],
     ["260", "80", "190"],
  ],
  "04/01/2024 to 04/07/2024": [
     ["149", "41", "245"],
     ["689", "33", "300"],
     ["136", "09", "270"],
     ["680", "41", "146"],
     ["136", "03", "139"],
     ["166", "38", "288"],
  ],
  "04/08/2024 to 04/14/2024": [
     ["289", "99", "568"],
     ["460", "08", "189"],
     ["445", "37", "269"],
     ["349", "68", "369"],
     ["170", "81", "669"],
     ["146", "11", "227"],
  ],
  "04/15/2024 to 04/21/2024": [
     ["240", "63", "689"],
     ["300", "37", "179"],
     ["279", "82", "589"],
     ["127", "06", "457"],
     ["380", "15", "690"],
     ["155", "16", "169"],
  ],
  "04/22/2024 to 04/28/2024": [
     ["467", "75", "113"],
     ["449", "72", "570"],
     ["357", "53", "490"],
     ["125", "84", "680"],
     ["226", "05", "230"],
     ["229", "33", "670"],
  ],
  "04/29/2024 to 05/05/2024": [
     ["267", "56", "457"],
     ["136", "02", "679"],
     ["116", "88", "170"],
     ["357", "59", "126"],
     ["660", "22", "138"],
     ["336", "24", "347"],
  ],
  "05/06/2024 to 05/12/2024": [
     ["128", "12", "138"],
     ["389", "05", "140"],
     ["470", "14", "239"],
     ["448", "61", "146"],
     ["125", "80", "299"],
     ["189", "80", "578"],
  ],
  "05/13/2024 to 05/19/2024": [
     ["579", "19", "379"],
     ["330", "65", "348"],
     ["149", "40", "334"],
     ["489", "14", "167"],
     ["790", "67", "269"],
     ["477", "80", "389"],
  ],
  "05/20/2024 to 05/26/2024": [
     ["128", "16", "178"],
     ["189", "83", "238"],
     ["115", "71", "579"],
     ["340", "74", "590"],
     ["468", "84", "220"],
     ["110", "22", "156"],
  ],
  "05/27/2024 to 06/02/2024": [
     ["236", "15", "230"],
     ["790", "63", "670"],
     ["559", "97", "340"],
     ["580", "33", "247"],
     ["180", "95", "177"],
     ["122", "54", "347"],
  ],
  "06/03/2024 to 06/09/2024": [
     ["490", "31", "560"],
     ["579", "18", "440"],
     ["570", "22", "480"],
     ["246", "28", "260"],
     ["279", "87", "223"],
     ["700", "76", "150"],
  ],
  "06/24/2024 to 06/30/2024": [
     ["580", "33", "256"],
     ["158", "46", "448"],
     ["123", "64", "590"],
     ["240", "63", "247"],
     ["668", "08", "990"],
     ["480", "29", "270"],
  ],
  "07/01/2024 to 07/07/2024": [
     ["489", "19", "469"],
     ["236", "13", "139"],
     ["156", "29", "199"],
     ["780", "56", "123"],
     ["179", "75", "159"],
     ["557", "79", "478"],
  ],
  "07/08/2024 to 07/14/2024": [
     ["259", "68", "468"],
     ["113", "53", "238"],
     ["159", "57", "133"],
     ["588", "14", "248"],
     ["468", "81", "290"],
     ["480", "26", "457"],
  ],
  "07/15/2024 to 07/21/2024": [
     ["580", "30", "550"],
     ["579", "14", "590"],
     ["339", "54", "149"],
     ["489", "12", "156"],
     ["356", "40", "479"],
     ["233", "82", "570"],
  ],
  "07/22/2024 to 07/28/2024": [
     ["458", "70", "370"],
     ["348", "54", "590"],
     ["288", "85", "258"],
     ["158", "41", "678"],
     ["340", "74", "446"],
     ["570", "29", "469"],
  ],
  "12/30/2024 to 01/05/2025": [
     [678, 11, 236],
     [770, 40, 569],
     [357, 52, 147],
     [490, 39, 559],
     [146, 10, 136],
     [220, 45, 456],
  ],
  "01/06/2025 to 01/12/2025": [
     [357, 59, 360],
     [136, "05", 168],
     [470, 14, 590],
     [257, 41, 588],
     [229, 35, 456],
     [457, 66, 358],
  ],
  "01/13/2025 to 01/19/2025": [
     [137, 19, 117],
     [139, 38, 369],
     [110, 29, 469],
     [248, 42, 390],
     [160, 78, 279],
     [569, "05", 799],
  ],
};

export const MILANDAY = {
  "01/02/2023 to 01/08/2023": [
     ["260", "86", "330"],
     ["477", "85", "357"],
     ["235", "02", "688"],
     ["460", "05", "168"],
     ["177", "52", "480"],
     ["123", "61", "290"],
  ],
  "01/09/2023 to 01/15/2023": [
     ["388", "95", "249"],
     ["339", "53", "120"],
     ["380", "18", "800"],
     ["127", "09", "379"],
     ["168", "53", "300"],
     ["299", "06", "268"],
  ],
  "01/16/2023 to 01/22/2023": [
     ["138", "26", "600"],
     ["137", "12", "156"],
     ["340", "70", "299"],
     ["669", "12", "336"],
     ["269", "73", "599"],
     ["590", "48", "224"],
  ],
  "01/23/2023 to 01/29/2023": [
     ["359", "77", "359"],
     ["770", "44", "130"],
     ["145", "09", "289"],
     ["590", "48", "224"],
     ["127", "09", "478"],
     ["460", "03", "779"],
  ],
  "01/30/2023 to 02/05/2023": [
     ["459", "88", "125"],
     ["239", "48", "567"],
     ["590", "49", "469"],
     ["789", "44", "257"],
     ["668", "07", "449"],
     ["248", "49", "117"],
  ],
  "02/06/2023 to 02/12/2023": [
     ["133", "74", "248"],
     ["570", "26", "240"],
     ["478", "96", "349"],
     ["230", "57", "115"],
     ["225", "97", "449"],
     ["123", "62", "499"],
  ],
  "02/13/2023 to 02/19/2023": [
     ["259", "62", "156"],
     ["150", "68", "567"],
     ["223", "77", "278"],
     ["123", "64", "789"],
     ["470", "14", "680"],
     ["234", "94", "130"],
  ],
  "02/20/2023 to 02/26/2023": [
     ["890", "72", "345"],
     ["589", "23", "580"],
     ["380", "16", "790"],
     ["158", "49", "360"],
     ["128", "15", "799"],
     ["115", "77", "377"],
  ],
  "02/27/2023 to 03/05/2023": [
     ["488", "00", "460"],
     ["336", "22", "589"],
     ["779", "34", "130"],
     ["147", "27", "890"],
     ["169", "66", "457"],
     ["129", "29", "568"],
  ],
  "03/06/2023 to 03/12/2023": [
     ["249", "53", "346"],
     ["248", "45", "258"],
     ["129", "29", "568"],
     ["499", "21", "470"],
     ["367", "63", "300"],
     ["670", "35", "348"],
  ],
  "03/13/2023 to 03/19/2023": [
     ["679", "27", "700"],
     ["148", "30", "479"],
     ["460", "00", "460"],
     ["249", "57", "458"],
     ["258", "51", "489"],
     ["247", "33", "166"],
  ],
  "03/20/2023 to 03/26/2023": [
     ["266", "40", "389"],
     ["123", "60", "370"],
     ["127", "01", "146"],
     ["124", "75", "267"],
     ["239", "44", "149"],
     ["347", "42", "679"],
  ],
  "03/27/2023 to 04/02/2023": [
     ["257", "42", "480"],
     ["568", "96", "240"],
     ["589", "24", "699"],
     ["240", "63", "139"],
     ["124", "76", "123"],
     ["130", "41", "290"],
  ],
  "04/03/2023 to 04/09/2023": [
     ["112", "41", "470"],
     ["677", "09", "388"],
     ["225", "93", "157"],
     ["478", "96", "169"],
     ["679", "20", "569"],
     ["456", "59", "289"],
  ],
  "04/10/2023 to 04/16/2023": [
     ["588", "11", "100"],
     ["300", "31", "560"],
     ["355", "36", "277"],
     ["269", "79", "289"],
     ["479", "07", "179"],
     ["149", "41", "146"],
  ],
  "04/17/2023 to 04/23/2023": [
     ["588", "10", "235"],
     ["780", "52", "480"],
     ["890", "76", "899"],
     ["146", "15", "159"],
     ["133", "74", "239"],
     ["477", "83", "670"],
  ],
  "04/24/2023 to 04/30/2023": [
     ["137", "10", "136"],
     ["499", "21", "245"],
     ["670", "34", "680"],
     ["169", "64", "167"],
     ["370", "07", "269"],
     ["234", "90", "370"],
  ],
  "05/01/2023 to 05/07/2023": [
     ["179", "72", "688"],
     ["448", "68", "116"],
     ["679", "29", "577"],
     ["480", "28", "378"],
     ["139", "31", "335"],
     ["117", "93", "355"],
  ],
  "05/08/2023 to 05/14/2023": [
     ["560", "19", "478"],
     ["347", "47", "449"],
     ["278", "73", "120"],
     ["600", "65", "500"],
     ["990", "83", "670"],
     ["450", "98", "116"],
  ],
  "05/15/2023 to 05/21/2023": [
     ["770", "41", "344"],
     ["150", "67", "250"],
     ["122", "58", "800"],
     ["220", "41", "146"],
     ["129", "23", "788"],
     ["124", "74", "590"],
  ],
  "05/22/2023 to 05/28/2023": [
     ["267", "58", "260"],
     ["889", "50", "488"],
     ["335", "12", "589"],
     ["279", "80", "578"],
     ["260", "82", "480"],
     ["348", "58", "279"],
  ],
  "05/29/2023 to 06/04/2023": [
     ["225", "99", "199"],
     ["179", "74", "770"],
     ["578", "09", "478"],
     ["566", "76", "358"],
     ["125", "83", "238"],
     ["167", "42", "679"],
  ],
  "06/05/2023 to 06/11/2023": [
     ["567", "89", "135"],
     ["268", "65", "230"],
     ["790", "68", "189"],
     ["578", "08", "369"],
     ["236", "10", "389"],
     ["680", "49", "388"],
  ],
  "06/12/2023 to 06/18/2023": [
     ["440", "82", "147"],
     ["299", "00", "389"],
     ["347", "47", "566"],
     ["269", "70", "127"],
     ["127", "02", "345"],
     ["170", "81", "236"],
  ],
  "06/19/2023 to 06/25/2023": [
     ["399", "19", "379"],
     ["346", "33", "788"],
     ["567", "88", "170"],
     ["467", "77", "133"],
     ["124", "76", "169"],
     ["567", "88", "125"],
  ],
  "06/26/2023 to 07/02/2023": [
     ["249", "57", "223"],
     ["668", "02", "228"],
     ["660", "23", "689"],
     ["344", "18", "116"],
     ["380", "12", "156"],
     ["124", "73", "120"],
  ],
  "07/03/2023 to 07/09/2023": [
     ["234", "99", "568"],
     ["345", "26", "600"],
     ["467", "71", "119"],
     ["230", "54", "888"],
     ["799", "50", "578"],
     ["468", "86", "899"],
  ],
  "07/10/2023 to 07/16/2023": [
     ["115", "71", "335"],
     ["134", "89", "478"],
     ["136", "03", "229"],
     ["788", "32", "336"],
     ["590", "43", "148"],
     ["137", "12", "345"],
  ],
  "07/17/2023 to 07/23/2023": [
     ["359", "74", "167"],
     ["148", "35", "249"],
     ["157", "33", "779"],
     ["166", "39", "450"],
     ["126", "98", "279"],
     ["670", "33", "490"],
  ],
  "07/24/2023 to 07/30/2023": [
     ["170", "81", "470"],
     ["446", "42", "679"],
     ["238", "30", "190"],
     ["199", "96", "790"],
     ["145", "07", "250"],
     ["145", "02", "246"],
  ],
  "07/31/2023 to 08/06/2023": [
     ["557", "70", "235"],
     ["123", "63", "238"],
     ["158", "45", "168"],
     ["280", "07", "115"],
     ["369", "84", "239"],
     ["490", "38", "134"],
  ],
  "08/07/2023 to 08/13/2023": [
    ["369", "89", "234"],
    ["347", "43", "670"],
    ["568", "90", "136"],
    ["440", "83", "599"],
    ["120", "36", "880"],
    ["349", "66", "240"],
  ],
  "08/14/2023 to 08/20/2023": [
    ["357", "57", "223"],
    ["349", "66", "240"],
    ["137", "11", "245"],
    ["167", "46", "790"],
    ["456", "55", "357"],
    ["270", "92", "246"],
  ],
  "08/21/2023 to 08/27/2023": [
    ["223", "71", "236"],
    ["890", "70", "190"],
    ["125", "87", "269"],
    ["559", "98", "567"],
    ["245", "15", "249"],
    ["270", "92", "246"],
  ],
  "08/28/2023 to 09/03/2023": [
    ["224", "88", "279"],
    ["134", "88", "125"],
    ["160", "70", "389"],
    ["670", "31", "470"],
    ["113", "51", "128"],
    ["668", "05", "249"],
  ],
  "09/04/2023 to 09/10/2023": [
    ["357", "52", "589"],
    ["160", "72", "480"],
    ["233", "80", "190"],
    ["689", "31", "678"],
    ["166", "39", "180"],
    ["135", "94", "266"],
  ],
  "09/11/2023 to 09/17/2023": [
    ["440", "87", "557"],
    ["470", "16", "349"],
    ["470", "17", "458"],
    ["259", "69", "360"],
    ["128", "15", "690"],
    ["347", "49", "388"],
  ],
  "09/18/2023 to 09/24/2023": [
    ["122", "50", "668"],
    ["440", "80", "299"],
    ["399", "11", "137"],
    ["178", "62", "237"],
    ["340", "78", "125"],
    ["699", "43", "337"],
  ],
  "09/25/2023 to 10/01/2023": [
    ["235", "02", "237"],
    ["356", "48", "468"],
    ["166", "31", "146"],
    ["289", "95", "177"],
    ["355", "38", "116"],
    ["340", "72", "129"],
  ],
  "10/02/2023 to 10/08/2023": [
    ["355", "30", "299"],
    ["456", "55", "230"],
    ["380", "12", "480"],
    ["155", "18", "260"],
    ["136", "01", "678"],
    ["258", "54", "770"],
  ],
  "10/09/2023 to 10/15/2023": [
    ["458", "72", "589"],
    ["570", "27", "160"],
    ["788", "33", "120"],
    ["370", "09", "135"],
    ["469", "96", "457"],
    ["127", "04", "266"],
  ],
  "10/16/2023 to 10/22/2023": [
    ["800", "82", "778"],
    ["450", "99", "126"],
    ["357", "51", "678"],
    ["240", "63", "788"],
    ["146", "11", "678"],
    ["567", "86", "367"],
  ],
  "10/23/2023 to 10/29/2023": [
    ["240", "68", "224"],
    ["259", "60", "235"],
    ["170", "83", "148"],
    ["125", "80", "479"],
    ["890", "78", "170"],
    ["779", "32", "390"],
  ],
  "10/30/2023 to 11/05/2023": [
    ["369", "82", "336"],
    ["447", "56", "349"],
    ["336", "29", "117"],
    ["128", "14", "158"],
    ["135", "92", "156"],
    ["145", "04", "220"],
  ],
  "11/06/2023 to 11/12/2023": [
    ["146", "16", "268"],
    ["120", "33", "445"],
    ["389", "09", "289"],
    ["248", "42", "138"],
    ["145", "04", "220"],
    ["336", "29", "117"],
  ],
  "11/13/2023 to 11/19/2023": [
    ["389", "09", "289"],
    ["336", "29", "117"],
    ["135", "92", "156"],
    ["145", "04", "220"],
    ["120", "33", "445"],
    ["128", "14", "158"],
  ],
  "11/20/2023 to 11/26/2023": [
    ["337", "39", "478"],
    ["119", "15", "366"],
    ["770", "49", "360"],
    ["248", "46", "358"],
    ["334", "06", "349"],
    ["134", "89", "478"],
  ],
  "11/27/2023 to 12/03/2023": [
    ["236", "10", "569"],
    ["127", "03", "247"],
    ["299", "01", "678"],
    ["690", "52", "589"],
    ["780", "51", "399"],
    ["123", "62", "147"],
  ],
  "12/04/2023 to 12/10/2023": [
    ["345", "23", "120"],
    ["130", "49", "270"],
    ["799", "55", "500"],
    ["450", "99", "126"],
    ["340", "70", "226"],
    ["580", "39", "450"],
  ],
  "12/11/2023 to 12/17/2023": [
    ["148", "35", "339"],
    ["558", "84", "789"],
    ["400", "49", "225"],
    ["160", "74", "130"],
    ["799", "54", "455"],
    ["288", "81", "155"],
  ],
  "12/18/2023 to 12/24/2023": [
    ["366", "53", "120"],
    ["347", "43", "337"],
    ["390", "23", "670"],
    ["447", "58", "800"],
    ["267", "58", "279"],
    ["446", "44", "356"],
  ],
  "12/25/2023 to 12/31/2023": [
    ["380", "11", "380"],
    ["240", "63", "247"],
    ["348", "55", "357"],
    ["199", "91", "137"],
    ["357", "58", "378"],
    ["260", "81", "119"],
  ],
  "01/01/2024 to 01/07/2024": [
    ["399", "15", "168"],
    ["458", "72", "138"],
    ["246", "26", "899"],
    ["450", "96", "358"],
    ["290", "16", "150"],
    ["357", "55", "249"],
  ],
  "01/08/2024 to 01/14/2024": [
    ["269", "76", "114"],
    ["115", "74", "149"],
    ["125", "88", "279"],
    ["188", "76", "899"],
    ["135", "93", "120"],
    ["469", "98", "459"],
  ],
  "01/15/2024 to 01/21/2024": [
    ["470", "19", "126"],
    ["159", "56", "169"],
    ["477", "81", "669"],
    ["146", "17", "458"],
    ["389", "02", "156"],
    ["289", "96", "330"],
  ],
  "01/22/2024 to 01/28/2024": [
    ["247", "39", "568"],
    ["134", "87", "133"],
    ["140", "52", "147"],
    ["448", "65", "780"],
    ["289", "96", "330"],
    ["118", "02", "129"],
  ],
  "01/29/2024 to 02/04/2024": [
    ["560", "17", "700"],
    ["358", "64", "356"],
    ["235", "07", "278"],
    ["237", "26", "330"],
    ["469", "91", "245"],
    ["270", "98", "260"],
  ],
  "02/05/2024 to 02/11/2024": [
    ["289", "98", "125"],
    ["157", "30", "668"],
    ["240", "62", "345"],
    ["128", "13", "689"],
    ["137", "17", "179"],
    ["389", "01", "560"],
  ],
  "02/12/2024 to 02/18/2024": [
    ["677", "06", "367"],
    ["288", "80", "578"],
    ["379", "95", "140"],
    ["338", "43", "229"],
    ["889", "55", "690"],
    ["359", "78", "279"],
  ],
  "02/19/2024 to 02/25/2024": [
    ["240", "63", "337"],
    ["159", "51", "245"],
    ["380", "15", "267"],
    ["257", "41", "236"],
    ["449", "71", "146"],
    ["347", "40", "578"],
  ],
  "02/26/2024 to 03/03/2024": [
    ["144", "97", "223"],
    ["118", "08", "477"],
    ["145", "09", "234"],
    ["480", "26", "123"],
    ["345", "27", "368"],
    ["160", "76", "600"],
  ],
  "03/04/2024 to 03/10/2024": [
    ["188", "76", "114"],
    ["359", "73", "779"],
    ["188", "78", "116"],
    ["144", "99", "577"],
    ["160", "71", "137"],
    ["278", "71", "236"],
  ],
  "03/11/2024 to 03/17/2024": [
    ["468", "83", "355"],
    ["245", "16", "114"],
    ["500", "59", "117"],
    ["370", "08", "224"],
    ["447", "54", "400"],
    ["169", "65", "140"],
  ],
  "03/18/2024 to 03/24/2024": [
    ["269", "77", "458"],
    ["250", "75", "447"],
    ["236", "11", "399"],
    ["379", "98", "260"],
    ["124", "70", "280"],
    ["280", "01", "399"],
  ],
  "03/25/2024 to 03/31/2024": [
    ["577", "94", "347"],
    ["369", "83", "120"],
    ["479", "04", "266"],
    ["248", "49", "360"],
    ["458", "79", "234"],
    ["280", "01", "399"],
  ],
  "04/01/2024 to 04/07/2024": [
    ["489", "10", "244"],
    ["270", "92", "480"],
    ["568", "91", "335"],
    ["190", "03", "779"],
    ["588", "18", "233"],
    ["123", "63", "247"],
  ],
  "04/08/2024 to 04/14/2024": [
    ["246", "25", "249"],
    ["448", "60", "226"],
    ["249", "56", "268"],
    ["148", "37", "557"],
    ["138", "21", "579"],
    ["138", "26", "259"],
  ],
  "04/15/2024 to 04/21/2024": [
    ["269", "70", "668"],
    ["340", "72", "570"],
    ["778", "25", "177"],
    ["125", "88", "350"],
    ["567", "86", "178"],
    ["370", "04", "167"],
  ],
  "04/22/2024 to 04/28/2024": [
    ["246", "27", "179"],
    ["235", "07", "700"],
    ["358", "66", "358"],
    ["226", "06", "240"],
    ["445", "31", "119"],
    ["260", "80", "235"],
  ],
  "04/29/2024 to 05/05/2024": [
    ["346", "33", "139"],
    ["189", "89", "126"],
    ["469", "95", "357"],
    ["369", "89", "379"],
    ["177", "56", "169"],
    ["268", "66", "178"],
  ],
  "05/06/2024 to 05/12/2024": [
    ["600", "64", "158"],
    ["179", "79", "135"],
    ["357", "54", "347"],
    ["688", "29", "199"],
    ["900", "94", "112"],
    ["124", "77", "269"],
  ],
  "05/13/2024 to 05/19/2024": [
    ["279", "82", "138"],
    ["147", "29", "234"],
    ["167", "49", "379"],
    ["457", "65", "140"],
    ["334", "08", "170"],
    ["599", "37", "115"],
  ],
  "05/20/2024 to 05/26/2024": [
    ["114", "65", "690"],
    ["160", "77", "340"],
    ["135", "94", "789"],
    ["257", "43", "670"],
    ["689", "35", "267"],
    ["238", "38", "170"],
  ],
  "05/27/2024 to 06/02/2024": [
    ["339", "59", "270"],
    ["479", "02", "246"],
    ["990", "86", "259"],
    ["380", "16", "178"],
    ["344", "10", "136"],
    ["577", "98", "440"],
  ],
  "06/03/2024 to 06/09/2024": [
    ["127", "01", "146"],
    ["240", "62", "147"],
    ["349", "69", "333"],
    ["345", "25", "267"],
    ["588", "12", "480"],
    ["234", "94", "257"],
  ],
  "06/10/2024 to 06/16/2024": [
    ["468", "86", "880"],
    ["167", "44", "158"],
    ["146", "15", "258"],
    ["670", "39", "667"],
    ["178", "60", "370"],
    ["340", "78", "558"],
  ],
  "06/17/2024 to 06/23/2024": [
    ["334", "00", "235"],
    ["290", "14", "158"],
    ["490", "32", "147"],
    ["149", "47", "467"],
    ["128", "10", "235"],
    ["445", "31", "128"],
  ],
  "06/24/2024 to 06/30/2024": [
    ["112", "40", "145"],
    ["880", "66", "123"],
    ["337", "34", "167"],
    ["236", "16", "880"],
    ["260", "88", "260"],
    ["257", "49", "180"],
  ],
  "07/01/2024 to 07/07/2024": [
    ["115", "71", "399"],
    ["237", "21", "560"],
    ["230", "50", "389"],
    ["113", "54", "400"],
    ["280", "08", "224"],
    ["144", "91", "245"],
  ],
  "07/08/2024 to 07/14/2024": [
    ["456", "50", "299"],
    ["568", "96", "466"],
    ["789", "41", "245"],
    ["229", "38", "468"],
    ["150", "67", "890"],
    ["369", "83", "120"],
  ],
  "07/15/2024 to 07/21/2024": [
    ["660", "26", "150"],
    ["360", "97", "278"],
    ["270", "99", "379"],
    ["115", "78", "224"],
    ["567", "87", "467"],
    ["267", "58", "468"],
  ],
  "07/22/2024 to 07/28/2024": [
    ["470", "17", "467"],
    ["899", "67", "467"],
    ["140", "57", "160"],
    ["369", "89", "568"],
    ["480", "20", "370"],
    ["480", "28", "170"],
  ],
  "12/30/2024 to 01/05/2025": [
    [558, 88, 990],
    [145, "06", 169],
    [348, 53, 337],
    [366, 59, 180],
    [390, 21, 119],
    [159, 59, 379],
  ],
  "01/06/2025 to 01/12/2025": [
    [139, 32, 237],
    [388, 95, 780],
    [150, 67, 179],
    [488, "06", 349],
    [356, 45, 348],
    [168, 52, 156],
  ],
  "01/13/2025 to 01/19/2025": [
    [157, 39, 126],
    [466, 68, 440],
    [268, 68, 134],
    [279, 83, 148],
    [366, 56, 240],
    [157, 37, 458],
  ],
};

export const KALYAN = {
  "01/02/2023 to 01/08/2023": [
    ["260", "87", "359"],
    ["137", "11", "588"],
    ["678", "11", "380"],
    ["567", "85", "348"],
    ["579", "17", "467"],
    ["470", "19", "126"],
  ],
  "01/09/2023 to 01/15/2023": [
    ["469", "97", "368"],
    ["247", "35", "230"],
    ["359", "79", "180"],
    ["690", "57", "124"],
    ["179", "72", "246"],
    ["247", "33", "670"],
  ],
  "01/16/2023 to 01/22/2023": [
    ["460", "02", "110"],
    ["669", "15", "122"],
    ["245", "15", "168"],
    ["899", "69", "450"],
    ["360", "96", "790"],
    ["459", "82", "246"],
  ],
  "01/23/2023 to 01/29/2023": [
    ["579", "17", "467"],
    ["225", "94", "167"],
    ["177", "56", "123"],
    ["378", "80", "389"],
    ["279", "89", "568"],
    ["137", "15", "230"],
  ],
  "01/30/2023 to 02/05/2023": [
    ["338", "48", "170"],
    ["256", "38", "125"],
    ["130", "48", "378"],
    ["580", "30", "569"],
    ["400", "47", "368"],
    ["236", "12", "570"],
  ],
  "02/06/2023 to 02/12/2023": [
    ["266", "44", "130"],
    ["199", "95", "168"],
    ["100", "11", "470"],
    ["129", "22", "679"],
    ["129", "22", "679"],
    ["270", "92", "589"],
  ],
  "02/13/2023 to 02/19/2023": [
    ["279", "80", "127"],
    ["599", "39", "469"],
    ["889", "52", "336"],
    ["330", "68", "189"],
    ["790", "67", "566"],
    ["700", "73", "355"],
  ],
  "02/20/2023 to 02/26/2023": [
    ["680", "43", "670"],
    ["137", "11", "579"],
    ["780", "50", "244"],
    ["380", "12", "336"],
    ["589", "26", "268"],
    ["113", "56", "240"],
  ],
  "02/27/2023 to 03/05/2023": [
    ["168", "51", "489"],
    ["199", "94", "130"],
    ["567", "85", "366"],
    ["259", "60", "334"],
    ["256", "37", "467"],
    ["579", "16", "259"],
  ],
  "03/06/2023 to 03/12/2023": [
    ["227", "14", "590"],
    ["229", "34", "590"],
    ["579", "17", "467"],
    ["568", "93", "238"],
    ["367", "61", "470"],
    ["358", "64", "248"],
  ],
  "03/13/2023 to 03/19/2023": [
    ["135", "96", "169"],
    ["479", "00", "145"],
    ["157", "30", "145"],
    ["599", "38", "378"],
    ["567", "89", "450"],
    ["459", "83", "256"],
  ],
  "03/20/2023 to 03/26/2023": [
    ["124", "76", "150"],
    ["570", "22", "679"],
    ["550", "07", "566"],
    ["126", "97", "340"],
    ["280", "01", "380"],
    ["456", "58", "134"],
  ],
  "03/27/2023 to 04/02/2023": [
    ["779", "36", "169"],
    ["567", "87", "359"],
    ["247", "37", "700"],
    ["450", "95", "168"],
    ["448", "68", "350"],
    ["145", "07", "160"],
  ],
  "04/03/2023 to 04/09/2023": [
    ["150", "60", "127"],
    ["369", "81", "137"],
    ["257", "43", "355"],
    ["269", "72", "660"],
    ["390", "26", "150"],
    ["126", "98", "567"],
  ],
  "04/10/2023 to 04/16/2023": [
    ["278", "70", "460"],
    ["235", "04", "590"],
    ["248", "42", "679"],
    ["236", "17", "250"],
    ["230", "58", "567"],
    ["300", "35", "780"],
  ],
  "04/17/2023 to 04/23/2023": [
    ["236", "12", "345"],
    ["359", "76", "169"],
    ["366", "51", "560"],
    ["589", "27", "368"],
    ["780", "52", "345"],
    ["389", "04", "257"],
  ],
  "04/24/2023 to 04/30/2023": [
    ["160", "71", "560"],
    ["266", "41", "128"],
    ["480", "28", "378"],
    ["170", "83", "139"],
    ["580", "38", "378"],
    ["280", "00", "127"],
  ],
  "05/01/2023 to 05/07/2023": [
    ["288", "88", "170"],
    ["249", "55", "456"],
    ["880", "63", "148"],
    ["557", "79", "469"],
    ["368", "71", "489"],
    ["240", "62", "589"],
  ],
  "05/08/2023 to 05/14/2023": [
    ["247", "38", "459"],
    ["229", "37", "124"],
    ["229", "35", "267"],
    ["899", "63", "670"],
    ["390", "22", "570"],
    ["456", "51", "137"],
  ],
  "05/15/2023 to 05/21/2023": [
    ["566", "71", "669"],
    ["399", "15", "357"],
    ["389", "00", "145"],
    ["239", "42", "129"],
    ["389", "06", "358"],
    ["149", "45", "456"],
  ],
  "05/22/2023 to 05/28/2023": [
     ["668", "05", "357"],
     ["337", "36", "178"],
     ["569", "06", "367"],
     ["799", "56", "240"],
     ["348", "56", "169"],
     ["569", "06", "349"],
  ],
  "05/29/2023 to 06/04/2023": [
     ["122", "54", "257"],
     ["889", "58", "459"],
     ["345", "20", "479"],
     ["459", "86", "240"],
     ["157", "37", "179"],
     ["346", "32", "138"],
  ],
  "06/05/2023 to 06/11/2023": [
     ["447", "58", "800"],
     ["267", "58", "224"],
     ["499", "20", "460"],
     ["336", "24", "248"],
     ["569", "00", "479"],
     ["237", "29", "270"],
  ],
  "06/12/2023 to 06/18/2023": [
     ["469", "92", "688"],
     ["368", "78", "459"],
     ["778", "24", "158"],
     ["137", "19", "360"],
     ["677", "01", "588"],
     ["690", "52", "200"],
  ],
  "06/19/2023 to 06/25/2023": [
     ["445", "30", "550"],
     ["179", "76", "448"],
     ["280", "03", "346"],
     ["259", "61", "588"],
     ["346", "33", "139"],
     ["359", "73", "490"],
  ],
  "06/26/2023 to 07/02/2023": [
     ["122", "55", "889"],
     ["167", "41", "344"],
     ["570", "24", "167"],
     ["345", "20", "190"],
     ["237", "26", "240"],
     ["580", "31", "128"],
  ],
  "07/03/2023 to 07/09/2023": [
     ["690", "53", "256"],
     ["167", "43", "689"],
     ["168", "56", "123"],
     ["168", "51", "146"],
     ["568", "95", "230"],
     ["567", "80", "460"],
  ],
  "07/10/2023 to 07/16/2023": [
     ["570", "27", "278"],
     ["159", "53", "157"],
     ["178", "61", "470"],
     ["568", "94", "167"],
     ["150", "61", "236"],
     ["130", "46", "899"],
  ],
  "07/17/2023 to 07/23/2023": [
     ["469", "92", "480"],
     ["700", "74", "266"],
     ["399", "14", "590"],
     ["149", "43", "490"],
     ["689", "31", "137"],
     ["488", "03", "139"],
  ],
  "07/24/2023 to 07/30/2023": [
     ["600", "63", "779"],
     ["379", "92", "237"],
     ["224", "83", "157"],
     ["700", "74", "239"],
     ["459", "86", "880"],
     ["789", "40", "668"],
  ],
  "07/31/2023 to 08/06/2023": [
     ["770", "41", "588"],
     ["300", "39", "388"],
     ["157", "35", "456"],
     ["599", "30", "136"],
     ["489", "18", "288"],
     ["778", "26", "259"],
  ],
  "08/07/2023 to 08/13/2023": [
     ["450", "96", "178"],
     ["789", "48", "170"],
     ["380", "10", "488"],
     ["140", "59", "450"],
     ["269", "78", "990"],
     ["348", "57", "359"],
  ],
  "08/14/2023 to 08/20/2023": [
     ["469", "95", "339"],
     ["579", "17", "467"],
     ["270", "98", "125"],
     ["278", "74", "248"],
     ["367", "64", "248"],
     ["233", "84", "167"],
  ],
  "08/21/2023 to 08/27/2023": [
     ["236", "13", "229"],
     ["136", "00", "578"],
     ["135", "92", "679"],
     ["578", "01", "344"],
     ["269", "76", "367"],
     ["240", "67", "269"],
  ],
  "08/28/2023 to 09/03/2023": [
     ["899", "62", "336"],
     ["110", "24", "266"],
     ["589", "22", "480"],
     ["128", "12", "246"],
     ["559", "99", "289"],
     ["790", "60", "578"],
  ],
  "09/04/2023 to 09/10/2023": [
     ["290", "18", "459"],
     ["345", "29", "559"],
     ["336", "25", "889"],
     ["380", "19", "234"],
     ["245", "18", "468"],
     ["780", "51", "236"],
  ],
  "09/11/2023 to 09/17/2023": [
     ["568", "95", "357"],
     ["188", "77", "890"],
     ["600", "69", "568"],
     ["346", "37", "700"],
     ["567", "81", "560"],
     ["290", "12", "237"],
  ],
  "09/18/2023 to 09/24/2023": [
     ["230", "57", "467"],
     ["580", "32", "480"],
     ["136", "03", "247"],
     ["368", "70", "136"],
     ["144", "95", "159"],
     ["249", "54", "789"],
  ],
  "09/25/2023 to 10/01/2023": [
     ["368", "78", "990"],
     ["367", "60", "235"],
     ["399", "10", "145"],
     ["677", "06", "790"],
     ["570", "28", "288"],
     ["148", "39", "450"],
  ],
  "10/02/2023 to 10/08/2023": [
     ["114", "68", "170"],
     ["355", "33", "256"],
     ["460", "00", "226"],
     ["266", "45", "168"],
     ["690", "52", "255"],
     ["479", "01", "236"],
  ],
  "10/09/2023 to 10/15/2023": [
     ["368", "75", "456"],
     ["490", "37", "133"],
     ["178", "67", "467"],
     ["156", "26", "367"],
     ["180", "90", "136"],
     ["459", "89", "180"],
  ],
  "10/16/2023 to 10/22/2023": [
     ["268", "67", "179"],
     ["667", "90", "145"],
     ["199", "95", "357"],
     ["680", "44", "158"],
     ["229", "35", "447"],
     ["566", "72", "237"],
  ],
  "10/23/2023 to 10/29/2023": [
     ["880", "67", "566"],
     ["223", "75", "799"],
     ["689", "39", "379"],
     ["160", "73", "779"],
     ["368", "77", "278"],
     ["135", "93", "580"],
  ],
  "10/30/2023 to 11/05/2023": [
     ["479", "04", "158"],
     ["468", "83", "337"],
     ["668", "08", "288"],
     ["113", "51", "470"],
     ["167", "41", "380"],
     ["460", "00", "370"],
  ],
  "11/06/2023 to 11/12/2023": [
     ["269", "74", "167"],
     ["156", "28", "189"],
     ["579", "17", "467"],
     ["668", "08", "288"],

     ["148", "31", "489"],
     ["257", "40", "479"],
  ],
  "11/13/2023 to 11/19/2023": [
     ["468", "83", "337"],
     ["160", "73", "779"],
     ["179", "70", "389"],
     ["668", "08", "288"],
     ["689", "39", "379"],
     ["156", "28", "189"],
  ],
  "11/20/2023 to 11/26/2023": [
     ["159", "53", "148"],
     ["348", "53", "120"],
     ["156", "28", "189"],
     ["357", "51", "137"],
     ["257", "48", "260"],
     ["179", "70", "389"],
  ],
  "11/27/2023 to 12/03/2023": [
     ["269", "76", "268"],
     ["146", "13", "139"],
     ["230", "56", "169"],
     ["235", "06", "790"],
     ["580", "33", "139"],
     ["120", "31", "489"],
  ],
  "12/04/2023 to 12/10/2023": [
     ["469", "90", "460"],
     ["270", "97", "340"],
     ["256", "35", "447"],
     ["690", "56", "178"],
     ["588", "13", "445"],
     ["124", "72", "129"],
  ],
  "12/11/2023 to 12/17/2023": [
     ["259", "69", "234"],
     ["257", "46", "600"],
     ["450", "96", "349"],
     ["120", "38", "224"],
     ["112", "48", "134"],
     ["150", "65", "230"],
  ],
  "12/18/2023 to 12/24/2023": [
     ["138", "22", "237"],
     ["249", "59", "379"],
     ["589", "29", "478"],
     ["248", "44", "356"],
     ["470", "14", "680"],
     ["678", "16", "349"],
  ],
  "12/25/2023 to 12/31/2023": [
     ["158", "48", "288"],
     ["677", "02", "589"],
     ["589", "24", "455"],
     ["267", "53", "580"],
     ["690", "54", "347"],
     ["135", "97", "250"],
  ],
  "01/01/2024 to 01/07/2024": [
     ["446", "41", "560"],
     ["169", "60", "280"],
     ["135", "95", "267"],
     ["240", "63", "355"],
     ["480", "25", "690"],
     ["245", "15", "140"],
  ],
  "01/08/2024 to 01/14/2024": [
     ["467", "73", "238"],
     ["112", "42", "138"],
     ["200", "29", "577"],
     ["790", "63", "355"],
     ["256", "38", "134"],
     ["290", "12", "345"],
  ],
  "01/15/2024 to 01/21/2024": [
     ["449", "75", "339"],
     ["890", "75", "140"],
     ["345", "27", "890"],
     ["280", "05", "690"],
     ["589", "25", "339"],
     ["490", "37", "160"],
  ],
  "01/22/2024 to 01/28/2024": [
     ["689", "30", "226"],
     ["300", "37", "269"],
     ["230", "51", "380"],
     ["156", "28", "189"],
     ["137", "14", "680"],
     ["237", "20", "145"],
  ],
  "01/29/2024 to 02/04/2024": [
     ["568", "91", "489"],
     ["124", "72", "589"],
     ["139", "30", "668"],
     ["167", "45", "690"],
     ["334", "04", "149"],
     ["455", "48", "378"],
  ],
  "02/05/2024 to 02/11/2024": [
     ["137", "16", "268"],
     ["556", "62", "688"],
     ["770", "45", "159"],
     ["368", "72", "499"],
     ["189", "87", "700"],
     ["379", "98", "170"],
  ],
  "02/12/2024 to 02/18/2024": [
     ["578", "01", "344"],
     ["126", "97", "124"],
     ["578", "06", "150"],
     ["226", "07", "278"],
     ["447", "52", "237"],
     ["390", "25", "168"],
  ],
  "02/19/2024 to 02/25/2024": [
     ["446", "44", "266"],
     ["479", "04", "257"],
     ["159", "52", "129"],
     ["112", "40", "460"],
     ["569", "03", "779"],
     ["558", "89", "478"],
  ],
  "02/26/2024 to 03/03/2024": [
     ["779", "32", "390"],
     ["668", "08", "378"],
     ["348", "58", "170"],
     ["168", "56", "457"],
     ["699", "47", "340"],
     ["450", "96", "178"],
  ],
  "03/04/2024 to 03/10/2024": [
     ["234", "93", "670"],
     ["467", "76", "358"],
     ["120", "37", "467"],
     ["124", "72", "110"],
     ["226", "03", "689"],
     ["479", "03", "256"],
  ],
  "03/11/2024 to 03/17/2024": [
     ["599", "39", "360"],
     ["480", "27", "458"],
     ["580", "39", "225"],
     ["145", "08", "288"],
     ["589", "28", "189"],
     ["289", "96", "457"],
  ],
  "03/18/2024 to 03/24/2024": [
     ["267", "59", "568"],
     ["790", "60", "370"],
     ["237", "27", "359"],
     ["580", "33", "256"],
     ["123", "66", "790"],
     ["446", "40", "235"],
  ],
  "03/25/2024 to 03/31/2024": [
     ["577", "97", "250"],
     ["348", "55", "249"],
     ["156", "28", "189"],
     ["256", "39", "234"],
     ["677", "08", "990"],
     ["478", "91", "560"],
  ],
  "04/01/2024 to 04/07/2024": [
     ["900", "96", "448"],
     ["880", "64", "338"],
     ["667", "97", "359"],
     ["455", "41", "470"],
     ["680", "49", "289"],
     ["148", "36", "123"],
  ],
  "04/08/2024 to 04/14/2024": [
     ["347", "44", "338"],
     ["355", "32", "255"],
     ["233", "88", "558"],
     ["170", "83", "229"],
     ["600", "64", "347"],
     ["367", "67", "223"],
  ],
  "04/15/2024 to 04/21/2024": [
     ["112", "46", "790"],
     ["270", "97", "160"],
     ["357", "52", "679"],
     ["990", "81", "137"],
     ["370", "02", "345"],
     ["235", "04", "680"],
  ],
  "04/22/2024 to 04/28/2024": [
     ["569", "03", "256"],
     ["248", "49", "577"],
     ["257", "42", "147"],
     ["160", "78", "468"],
     ["358", "67", "890"],
     ["569", "02", "390"],
  ],
  "04/29/2024 to 05/05/2024": [
     ["779", "33", "580"],
     ["568", "92", "138"],
     ["230", "58", "189"],
     ["349", "60", "136"],
     ["145", "08", "468"],
     ["390", "24", "257"],
  ],

  "05/06/2024 to 05/12/2024": [
     ["147", "27", "250"],
     ["589", "21", "335"],
     ["116", "83", "670"],
     ["359", "79", "180"],
     ["668", "01", "489"],
     ["158", "44", "789"],
  ],
  "05/13/2024 to 05/19/2024": [
     ["234", "98", "369"],
     ["149", "40", "569"],
     ["347", "45", "249"],
     ["568", "96", "457"],
     ["267", "53", "779"],
     ["238", "30", "190"],
  ],
  "05/20/2024 to 05/26/2024": [
     ["156", "26", "150"],
     ["349", "66", "114"],
     ["133", "70", "118"],
     ["136", "02", "589"],
     ["399", "16", "240"],
     ["347", "42", "147"],
  ],
  "05/27/2024 to 06/02/2024": [
     ["370", "00", "578"],
     ["259", "63", "120"],
     ["126", "94", "130"],
     ["455", "44", "338"],
     ["400", "46", "178"],
     ["157", "34", "680"],
  ],
  "06/03/2024 to 06/09/2024": [
     ["688", "27", "890"],
     ["178", "63", "599"],
     ["799", "50", "127"],
     ["113", "53", "599"],
     ["269", "72", "390"],
     ["277", "62", "390"],
  ],
  "06/24/2024 to 06/30/2024": [
     ["789", "45", "168"],
     ["660", "26", "268"],
     ["349", "64", "149"],
     ["130", "47", "115"],
     ["880", "66", "457"],
     ["560", "15", "690"],
  ],
  "07/01/2024 to 07/07/2024": [
     ["467", "77", "458"],
     ["123", "66", "358"],
     ["138", "24", "167"],
     ["268", "64", "347"],
     ["489", "13", "445"],
     ["468", "84", "356"],
  ],
  "07/08/2024 to 07/14/2024": [
     ["679", "26", "367"],
     ["450", "91", "335"],
     ["129", "29", "900"],
     ["260", "88", "116"],
     ["578", "04", "400"],
     ["177", "55", "168"],
  ],
  "07/15/2024 to 07/21/2024": [
     ["450", "95", "690"],
     ["148", "37", "467"],
     ["126", "92", "480"],
     ["900", "99", "289"],
     ["458", "70", "226"],
     ["459", "82", "679"],
  ],
  "07/22/2024 to 07/28/2024": [
     ["690", "55", "267"],
     ["560", "15", "267"],
     ["689", "34", "266"],
     ["346", "31", "560"],
     ["256", "39", "234"],
     ["125", "89", "135"],
  ],
  "12/30/2024 to 01/05/2025": [
     [167, 41, 560],
     [129, 28, 233],
     [136, "08", 459],
     [240, 69, 450],
     [589, 25, 159],
     [690, 52, 390],
  ],
  "01/06/2025 to 01/12/2025": [
     [289, 97, 467],
     [130, 44, 680],
     [356, 44, 167],
     [127, "04", 248],
     [349, 62, 237],
     [800, 88, 279],
  ],
};

export const KALYANNIGHT = {
  "01/02/2023 to 01/08/2023": [
     ["790", "68", "459"],
     ["380", "12", "336"],
     ["469", "97", "890"],
     ["699", "43", "157"],
     ["778", "21", "399"],
  ],
  "01/09/2023 to 01/15/2023": [
     ["120", "36", "457"],
     ["459", "87", "359"],
     ["278", "70", "569"],
     ["566", "74", "257"],
     ["690", "51", "678"],
  ],
  "01/16/2023 to 01/22/2023": [
     ["370", "04", "149"],
     ["448", "68", "378"],
     ["169", "60", "370"],
     ["600", "60", "334"],
     ["458", "78", "134"],
  ],
  "01/23/2023 to 01/29/2023": [
     ["580", "36", "790"],
     ["349", "69", "289"],
     ["355", "39", "469"],
     ["257", "42", "480"],
     ["278", "70", "569"],
  ],
  "01/30/2023 to 02/05/2023": [
     ["790", "67", "124"],
     ["677", "03", "788"],
     ["346", "32", "147"],
     ["360", "94", "590"],
     ["137", "11", "146"],
  ],
  "02/06/2023 to 02/12/2023": [
     ["447", "57", "188"],
     ["149", "44", "400"],
     ["259", "61", "380"],
     ["117", "98", "224"],
     ["780", "50", "677"],
  ],
  "02/13/2023 to 02/19/2023": [
     ["140", "57", "458"],
     ["116", "84", "400"],
     ["120", "32", "390"],
     ["488", "02", "679"],
     ["369", "81", "128"],
  ],
  "02/20/2023 to 02/26/2023": [
     ["459", "84", "356"],
     ["670", "37", "890"],
     ["120", "34", "158"],
     ["178", "64", "789"],
     ["670", "37", "269"],
  ],
  "02/27/2023 to 03/05/2023": [
     ["245", "15", "230"],
     ["569", "05", "357"],
     ["690", "59", "135"],
     ["249", "55", "168"],
     ["568", "97", "124"],
  ],
  "03/06/2023 to 03/12/2023": [
     ["780", "58", "134"],
     ["136", "06", "457"],
     ["247", "30", "677"],
     ["469", "99", "379"],
     ["488", "02", "679"],
  ],
  "03/13/2023 to 03/19/2023": [
     ["147", "29", "478"],
     ["789", "40", "136"],
     ["346", "38", "378"],
     ["135", "99", "117"],
     ["129", "29", "568"],
  ],
  "03/20/2023 to 03/26/2023": [
     ["469", "96", "457"],
     ["780", "53", "779"],
     ["358", "65", "177"],
     ["480", "21", "678"],
     ["358", "65", "113"],
  ],
  "03/27/2023 to 04/02/2023": [
     ["668", "03", "238"],
     ["116", "88", "990"],
     ["467", "71", "579"],
     ["135", "94", "266"],
     ["247", "38", "468"],
  ],
  "04/03/2023 to 04/09/2023": [
     ["478", "98", "233"],
     ["468", "84", "257"],
     ["449", "75", "799"],
     ["788", "33", "148"],
     ["299", "04", "220"],
  ],
  "04/10/2023 to 04/16/2023": [
     ["488", "00", "370"],
     ["460", "04", "248"],
     ["266", "41", "146"],
     ["130", "47", "269"],
     ["588", "13", "247"],
  ],
  "04/17/2023 to 04/23/2023": [
     ["167", "41", "399"],
     ["489", "12", "688"],
     ["679", "21", "579"],
     ["446", "40", "578"],
     ["158", "42", "138"],
  ],
  "04/24/2023 to 04/30/2023": [
     ["340", "76", "358"],
     ["589", "20", "145"],
     ["488", "04", "356"],
     ["127", "09", "478"],
     ["458", "74", "239"],
  ],
  "05/01/2023 to 05/07/2023": [
     ["116", "85", "140"],
     ["136", "08", "233"],
     ["223", "74", "699"],
     ["137", "19", "270"],
     ["146", "18", "224"],
  ],
  "05/08/2023 to 05/14/2023": [
     ["146", "15", "168"],
     ["260", "82", "660"],
     ["458", "77", "223"],
     ["559", "92", "156"],
     ["379", "93", "670"],
  ],
  "05/15/2023 to 05/21/2023": [
     ["225", "98", "350"],
     ["188", "77", "700"],
     ["237", "26", "358"],
     ["334", "09", "270"],
     ["677", "04", "112"],
  ],
  "05/22/2023 to 05/28/2023": [
     ["269", "79", "469"],
     ["370", "00", "136"],
     ["356", "44", "167"],
     ["145", "06", "600"],
     ["156", "28", "800"],
  ],
  "05/29/2023 to 06/04/2023": [
     ["899", "63", "157"],
     ["124", "73", "166"],
     ["124", "76", "240"],
     ["800", "85", "168"],
     ["133", "78", "260"],
  ],
  "06/05/2023 to 06/11/2023": [
     ["599", "39", "289"],
     ["249", "56", "330"],
     ["166", "34", "149"],
     ["120", "31", "146"],
     ["156", "26", "349"],
  ],
  "06/12/2023 to 06/18/2023": [
     ["277", "68", "125"],
     ["277", "64", "266"],
     ["233", "80", "370"],
     ["147", "22", "129"],
     ["120", "31", "470"],
  ],
  "06/19/2023 to 06/25/2023": [
     ["390", "21", "579"],
     ["778", "22", "156"],
     ["450", "92", "570"],
     ["280", "04", "248"],
     ["113", "56", "790"],
  ],
  "06/26/2023 to 07/02/2023": [
     ["267", "56", "457"],
     ["570", "22", "390"],
     ["256", "37", "179"],
     ["237", "25", "140"],
     ["358", "69", "478"],
  ],
  "07/03/2023 to 07/09/2023": [
     ["168", "58", "440"],
     ["127", "03", "247"],
     ["268", "60", "578"],
     ["270", "96", "367"],
     ["255", "21", "380"],
  ],
  "07/10/2023 to 07/16/2023": [
     ["450", "90", "244"],
     ["269", "70", "299"],
     ["233", "85", "159"],
     ["290", "15", "113"],
     ["170", "86", "790"],
  ],
  "07/17/2023 to 07/23/2023": [
     ["117", "98", "134"],
     ["148", "38", "378"],
     ["236", "16", "277"],
     ["378", "82", "589"],
     ["160", "70", "226"],
  ],
  "07/24/2023 to 07/30/2023": [
     ["230", "59", "126"],
     ["335", "17", "160"],
     ["290", "17", "160"],
     ["669", "15", "230"],
     ["367", "66", "268"],
  ],
  "07/31/2023 to 08/06/2023": [
     ["560", "19", "126"],
     ["789", "40", "479"],
     ["590", "40", "244"],
     ["199", "97", "115"],
     ["378", "89", "379"],
  ],
  "08/07/2023 to 08/13/2023": [
     ["380", "17", "467"],
     ["458", "77", "340"],
     ["570", "24", "455"],
     ["100", "14", "257"],
     ["360", "96", "259"],
  ],
  "08/14/2023 to 08/20/2023": [
     ["336", "22", "660"],
     ["477", "89", "379"],
     ["339", "55", "249"],
     ["477", "89", "900"],
     ["189", "81", "678"],
  ],
  "08/21/2023 to 08/27/2023": [
     ["345", "28", "125"],
     ["190", "02", "138"],
     ["110", "28", "134"],
     ["580", "32", "110"],
     ["159", "50", "145"],
  ],
  "08/28/2023 to 09/03/2023": [
     ["147", "29", "450"],
     ["168", "55", "230"],
     ["378", "84", "770"],
     ["558", "86", "457"],
     ["189", "81", "678"],
  ],
  "09/04/2023 to 09/10/2023": [
     ["234", "97", "458"],
     ["668", "00", "460"],
     ["134", "80", "226"],
     ["146", "16", "448"],
     ["280", "01", "245"],
  ],
  "09/11/2023 to 09/17/2023": [
     ["378", "87", "890"],
     ["269", "78", "134"],
     ["280", "07", "179"],
     ["189", "84", "680"],
     ["566", "71", "489"],
  ],
  "09/18/2023 to 09/24/2023": [
     ["335", "18", "440"],
     ["122", "57", "359"],
     ["169", "61", "579"],
     ["578", "01", "128"],
     ["114", "60", "668"],
  ],
  "09/25/2023 to 10/01/2023": [
     ["238", "35", "140"],
     ["177", "58", "125"],
     ["660", "29", "559"],
     ["267", "55", "348"],
     ["118", "09", "135"],
  ],
  "10/02/2023 to 10/08/2023": [
     ["345", "23", "256"],
     ["125", "81", "290"],
     ["557", "78", "170"],
     ["470", "11", "470"],
     ["138", "23", "346"],
  ],
  "10/09/2023 to 10/15/2023": [
     ["256", "31", "245"],
     ["237", "25", "690"],
     ["267", "50", "136"],
     ["188", "77", "449"],
     ["390", "21", "236"],
  ],
  "10/16/2023 to 10/22/2023": [
     ["150", "66", "790"],
     ["480", "28", "369"],
     ["390", "29", "289"],
     ["224", "83", "689"],
     ["267", "59", "450"],
  ],
  "10/23/2023 to 10/29/2023": [
     ["127", "02", "246"],
     ["237", "24", "239"],
     ["457", "65", "177"],
     ["790", "65", "140"],
     ["239", "44", "347"],
  ],
  "10/30/2023 to 11/05/2023": [
     ["780", "54", "130"],
     ["248", "40", "127"],
     ["257", "46", "123"],
     ["248", "41", "380"],
     ["246", "23", "580"],
  ],
  "11/06/2023 to 11/12/2023": [
     ["457", "63", "599"],
     ["489", "10", "479"],
     ["123", "69", "568"],
     ["568", "93", "148"],
     ["150", "66", "790"],
  ],
  "11/13/2023 to 11/19/2023": [
     ["478", "94", "590"],
     ["780", "54", "130"],
     ["246", "23", "580"],
     ["239", "44", "347"],
     ["267", "59", "450"],
  ],
  "11/20/2023 to 11/26/2023": [
     ["256", "39", "135"],
     ["170", "86", "367"],
     ["150", "66", "367"],
     ["478", "94", "590"],
     ["780", "58", "378"],
  ],
  "11/27/2023 to 12/03/2023": [
     ["256", "37", "368"],
     ["280", "08", "567"],
     ["259", "67", "160"],
     ["223", "76", "466"],
     ["234", "95", "177"],
  ],
  "12/04/2023 to 12/10/2023": [
     ["127", "04", "239"],
     ["158", "41", "489"],
     ["580", "37", "269"],
     ["339", "59", "117"],
     ["235", "03", "337"],
  ],
  "12/11/2023 to 12/17/2023": [
     ["270", "98", "558"],
     ["169", "67", "223"],
     ["459", "82", "147"],
     ["116", "87", "133"],
     ["800", "82", "390"],
  ],
  "12/18/2023 to 12/24/2023": [
     ["379", "90", "136"],
     ["239", "41", "560"],
     ["279", "86", "349"],
     ["140", "53", "346"],
     ["130", "45", "249"],
  ],
  "12/25/2023 to 12/31/2023": [
     ["160", "79", "360"],
     ["190", "03", "148"],
     ["457", "60", "578"],
     ["140", "53", "157"],
     ["122", "59", "199"],
  ],
  "01/01/2024 to 01/07/2024": [
     ["568", "93", "779"],
     ["770", "42", "345"],
     ["360", "98", "116"],
     ["700", "76", "880"],
     ["257", "42", "570"],
  ],
  "01/08/2024 to 01/14/2024": [
     ["128", "19", "126"],
     ["356", "47", "160"],
     ["158", "47", "223"],
     ["124", "75", "456"],
     ["166", "36", "790"],
  ],
  "01/15/2024 to 01/21/2024": [
     ["139", "36", "448"],
     ["679", "29", "568"],
     ["278", "79", "234"],
     ["144", "97", "458"],
     ["690", "51", "236"],
  ],
  "01/22/2024 to 01/28/2024": [
     ["160", "79", "478"],
     ["268", "68", "468"],
     ["355", "35", "447"],
     ["120", "32", "589"],
     ["166", "36", "790"],
   
  ],
  "01/29/2024 to 02/04/2024": [
     ["467", "70", "118"],
     ["250", "70", "280"],
     ["148", "34", "338"],
     ["139", "30", "235"],
     ["455", "42", "156"],
  ],
  "02/05/2024 to 02/11/2024": [
     ["289", "95", "230"],
     ["459", "85", "122"],
     ["790", "62", "480"],
     ["279", "80", "569"],
     ["568", "91", "579"],
  ],
  "02/12/2024 to 02/18/2024": [
     ["679", "28", "459"],
     ["238", "31", "227"],
     ["457", "63", "238"],
     ["447", "51", "146"],
     ["168", "54", "400"],
  ],
  "02/19/2024 to 02/25/2024": [
     ["499", "28", "170"],
     ["580", "35", "258"],
     ["778", "24", "699"],
     ["170", "83", "148"],
     ["113", "52", "200"],
  ],
  "02/26/2024 to 03/03/2024": [
     ["289", "90", "677"],
     ["499", "28", "125"],
     ["440", "87", "340"],
     ["268", "66", "457"],
     ["336", "28", "477"],
  ],
  "03/04/2024 to 03/10/2024": [
     ["770", "44", "699"],
     ["226", "06", "790"],
     ["135", "96", "358"],
     ["670", "33", "256"],
     ["456", "52", "480"],
  ],
  "03/11/2024 to 03/17/2024": [
     ["467", "77", "458"],
     ["350", "80", "668"],
     ["570", "21", "128"],
     ["178", "67", "368"],
     ["147", "25", "249"],
  ],
  "03/18/2024 to 03/24/2024": [
     ["890", "74", "130"],
     ["370", "05", "456"],
     ["348", "59", "577"],
     ["788", "33", "689"],
     ["259", "63", "120"],
  ],
  "03/25/2024 to 03/31/2024": [
     ["356", "44", "239"],
     ["599", "31", "100"],
     ["445", "32", "246"],
     ["679", "29", "469"],
     ["570", "21", "128"],
  ],
  "04/01/2024 to 04/07/2024": [
    ["367", "64", "770"],
    ["445", "33", "670"],
    ["380", "15", "357"],
    ["370", "03", "120"],
    ["789", "45", "249"],
  ],
  "04/08/2024 to 04/14/2024": [
    ["244", "01", "470"],
    ["280", "01", "137"],
    ["389", "07", "449"],
    ["367", "65", "348"],
    ["560", "16", "268"],
  ],
  "04/15/2024 to 04/21/2024": [
    ["679", "29", "568"],
    ["560", "16", "457"],
    ["469", "96", "457"],
    ["340", "71", "579"],
    ["250", "75", "258"],
  ],
  "04/22/2024 to 04/28/2024": [
    ["150", "64", "680"],
    ["137", "12", "499"],
    ["167", "42", "336"],
    ["457", "66", "349"],
    ["169", "61", "290"],
  ],
  "04/29/2024 to 05/05/2024": [
    ["560", "16", "268"],
    ["259", "62", "688"],
    ["147", "26", "240"],
    ["490", "32", "138"],
    ["339", "50", "479"],
  ],
  "05/06/2024 to 05/12/2024": [
    ["590", "49", "559"],
    ["138", "22", "570"],
    ["149", "46", "240"],
    ["680", "42", "237"],
    ["159", "55", "140"],
  ],
  "05/13/2024 to 05/19/2024": [
    ["349", "64", "130"],
    ["668", "07", "566"],
    ["569", "05", "159"],
    ["688", "24", "789"],
    ["345", "20", "479"],
  ],
  "05/20/2024 to 05/26/2024": [
    ["160", "75", "159"],
    ["357", "51", "227"],
    ["117", "95", "799"],
    ["223", "77", "359"],
    ["150", "60", "677"],
  ],
  "05/27/2024 to 06/02/2024": [
    ["188", "71", "146"],
    ["490", "33", "490"],
    ["136", "07", "124"],
    ["249", "59", "126"],
    ["330", "68", "170"],
  ],
  "06/03/2024 to 06/09/2024": [
    ["157", "30", "569"],
    ["780", "59", "144"],
    ["788", "34", "338"],
    ["349", "60", "569"],
    ["370", "02", "679"],
  ],
  "06/10/2024 to 06/16/2024": [
    ["449", "78", "125"],
    ["150", "67", "269"],
    ["250", "70", "460"],
    ["259", "60", "488"],
    ["589", "23", "445"],
  ],
  "06/17/2024 to 06/23/2024": [
    ["668", "07", "115"],
    ["278", "76", "268"],
    ["229", "36", "448"],
    ["358", "61", "470"],
    ["169", "68", "440"],
  ],
  "06/24/2024 to 06/30/2024": [
    ["567", "81", "470"],
    ["116", "84", "130"],
    ["459", "84", "239"],
    ["360", "91", "137"],
    ["137", "18", "170"],
  ],
  "07/01/2024 to 07/07/2024": [
    ["368", "74", "248"],
    ["680", "43", "256"],
    ["368", "79", "469"],
    ["112", "47", "359"],
    ["578", "05", "799"],
  ],
  "07/08/2024 to 07/14/2024": [
    ["127", "00", "370"],
    ["169", "60", "460"],
    ["588", "12", "255"],
    ["238", "31", "236"],
    ["128", "12", "147"],
  ],
  "07/15/2024 to 07/21/2024": [
    ["690", "57", "557"],
    ["269", "77", "179"],
    ["470", "15", "348"],
    ["225", "97", "278"],
    ["368", "77", "467"],
  ],
  "07/22/2024 to 07/28/2024": [
    ["340", "78", "378"],
    ["157", "37", "890"],
    ["134", "84", "455"],
    ["560", "13", "580"],
    ["669", "13", "139"],
  ],
  "07/29/2024 to 08/04/2024": [
    ["689", "39", "270"],
    ["148", "32", "345"],
    ["367", "69", "289"],
    ["234", "90", "145"],
    ["238", "36", "114"],
  ],
  "08/05/2024 to 08/11/2024": [
    ["158", "46", "150"],
    ["128", "16", "330"],
    ["334", "02", "570"],
    ["458", "70", "235"],
    ["379", "97", "179"],
  ],
  "08/12/2024 to 08/18/2024": [
    ["157", "34", "356"],
    ["459", "85", "168"],
    ["880", "61", "470"],
    ["258", "52", "246"],
    ["367", "69", "289"],
  ],
  "08/19/2024 to 08/25/2024": [
    ["279", "81", "669"],
    ["146", "14", "789"],
    ["690", "52", "336"],
    ["257", "41", "489"],
    ["229", "38", "459"],
  ],
  "08/26/2024 to 09/01/2024": [
    ["390", "21", "119"],
    ["790", "61", "380"],
    ["134", "82", "390"],
    ["490", "31", "227"],
    ["460", "01", "236"],
  ],

  "12/30/2024 to 01/05/2025": [
    [378, 84, 347],
    [568, 97, 179],
    [478, 93, 139],
    [259, 64, 158],
    [380, 18, 125],
  ],
  "01/06/2025 to 01/12/2025": [
    [279, 87, 449],
    [669, 17, 890],
    [450, 97, 269],
    [247, 39, 289],
    [569, "01", 380],
  ],
  "01/13/2025 to 01/19/2025": [
    [379, 95, 249],
    [267, 54, 347],
    [339, 57, 700],
    [269, 72, 246],
    [278, 78, 260],
  ],
};

export const SRIDEVINIGHT = {
  "01/01/2024 to 01/07/2024": [
    ["800", "87", "377"],
    ["467", "70", "334"],
    ["477", "86", "169"],
    ["890", "70", "244"],
    ["228", "26", "899"],
    ["450", "93", "490"],
    ["122", "56", "268"],
  ],
  "01/08/2024 to 01/14/2024": [
    ["448", "61", "236"],
    ["668", "04", "248"],
    ["147", "22", "129"],
    ["488", "01", "128"],
    ["119", "18", "459"],
    ["257", "40", "190"],
    ["699", "41", "489"],
  ],
  "01/15/2024 to 01/21/2024": [
    ["146", "19", "289"],
    ["180", "94", "347"],
    ["568", "93", "490"],
    ["134", "82", "138"],
    ["457", "68", "567"],
    ["236", "11", "290"],
    ["458", "71", "245"],
  ],
  "01/22/2024 to 01/28/2024": [
    ["266", "47", "188"],
    ["134", "85", "447"],
    ["448", "65", "348"],
    ["478", "98", "189"],
    ["257", "40", "190"],
    ["129", "21", "146"],
    ["346", "39", "360"],
  ],
  "01/29/2024 to 02/04/2024": [
    ["678", "19", "225"],
    ["156", "23", "670"],
    ["369", "87", "179"],
    ["125", "82", "679"],
    ["167", "40", "569"],
    ["690", "59", "180"],
    ["259", "64", "699"],
  ],
  "02/05/2024 to 02/11/2024": [
    ["338", "44", "239"],
    ["279", "88", "990"],
    ["367", "60", "578"],
    ["334", "08", "350"],
    ["459", "83", "346"],
    ["660", "22", "390"],
    ["356", "48", "477"],
  ],
  "02/12/2024 to 02/18/2024": [
    ["246", "22", "237"],
    ["125", "88", "260"],
    ["446", "45", "267"],
    ["790", "60", "136"],
    ["359", "77", "890"],
    ["577", "92", "255"],
    ["559", "90", "370"],
  ],
  "02/19/2024 to 02/25/2024": [
    ["789", "48", "369"],
    ["600", "60", "190"],
    ["357", "51", "470"],
    ["169", "65", "230"],
    ["179", "79", "126"],
    ["788", "33", "256"],
    ["246", "26", "457"],
  ],
  "02/26/2024 to 03/03/2024": [
    ["255", "27", "359"],
    ["137", "17", "115"],
    ["260", "80", "226"],
    ["140", "58", "477"],
    ["267", "58", "279"],
    ["478", "92", "679"],
    ["290", "15", "258"],
  ],
  "03/04/2024 to 03/10/2024": [
    ["880", "69", "270"],
    ["479", "00", "668"],
    ["334", "08", "134"],
    ["579", "19", "568"],
    ["250", "79", "289"],
    ["128", "15", "249"],
    ["157", "39", "568"],
  ],
  "03/11/2024 to 03/17/2024": [
    ["578", "07", "160"],
    ["255", "28", "189"],
    ["127", "09", "180"],
    ["470", "16", "880"],
    ["557", "74", "770"],
    ["669", "16", "178"],
    ["589", "28", "279"],
  ],
  "03/18/2024 to 03/24/2024": [
    ["122", "55", "258"],
    ["455", "48", "459"],
    ["344", "15", "267"],
    ["800", "81", "227"],
    ["226", "09", "117"],
    ["677", "05", "249"],
    ["457", "61", "155"],
  ],
  "03/25/2024 to 03/31/2024": [
    ["447", "51", "236"],
    ["156", "27", "223"],
    ["160", "74", "699"],
    ["167", "49", "559"],
    ["247", "39", "379"],
    ["467", "78", "125"],
    ["127", "09", "180"],
  ],
  "04/01/2024 to 04/07/2024": [
    ["370", "07", "250"],
    ["299", "00", "668"],
    ["289", "97", "557"],
    ["400", "48", "567"],
    ["388", "95", "122"],
    ["158", "43", "670"],
    ["236", "12", "570"],
  ],
  "04/08/2024 to 04/14/2024": [
    ["334", "07", "458"],
    ["112", "44", "257"],
    ["500", "56", "349"],
    ["990", "80", "668"],
    ["289", "90", "479"],
    ["260", "81", "290"],
    ["689", "35", "113"],
  ],
  "04/15/2024 to 04/21/2024": [
    ["180", "97", "467"],
    ["499", "21", "245"],
    ["135", "94", "266"],
    ["236", "14", "257"],
    ["139", "36", "358"],
    ["158", "41", "560"],
    ["567", "83", "490"],
  ],
  "04/22/2024 to 04/28/2024": [
    ["138", "24", "149"],
    ["566", "73", "445"],
    ["269", "78", "233"],
    ["369", "86", "240"],
    ["168", "55", "159"],
    ["137", "14", "239"],
    ["169", "60", "127"],
  ],
  "04/29/2024 to 05/05/2024": [
    ["140", "55", "258"],
    ["156", "21", "489"],
    ["679", "20", "190"],
    ["125", "85", "159"],
    ["490", "35", "690"],
    ["579", "14", "130"],
    ["128", "13", "238"],
  ],
  "05/06/2024 to 05/12/2024": [
    ["457", "64", "446"],
    ["230", "57", "269"],
    ["679", "23", "580"],
    ["258", "51", "678"],
    ["138", "22", "345"],
    ["128", "17", "467"],
    ["990", "84", "257"],
  ],
  "05/13/2024 to 05/19/2024": [
    ["259", "61", "489"],
    ["290", "16", "259"],
    ["440", "80", "569"],
    ["239", "44", "158"],
    ["479", "07", "890"],
    ["127", "01", "678"],
    ["270", "93", "346"],
  ],
  "05/20/2024 to 05/26/2024": [
    ["450", "98", "233"],
    ["340", "77", "377"],
    ["458", "72", "480"],
    ["347", "41", "344"],
    ["667", "90", "145"],
    ["244", "07", "223"],
    ["257", "47", "269"],
  ],
  "05/27/2024 to 06/02/2024": [
    ["800", "89", "117"],
    ["446", "41", "236"],
    ["136", "02", "237"],
    ["257", "45", "249"],
    ["369", "88", "459"],
    ["166", "35", "690"],
    ["789", "40", "668"],
  ],
  "06/03/2024 to 06/09/2024": [
    ["266", "45", "113"],
    ["150", "62", "138"],
    ["259", "60", "389"],
    ["580", "35", "267"],
    ["358", "62", "660"],
    ["578", "00", "479"],
    ["269", "72", "688"],
  ],
  "06/24/2024 to 06/30/2024": [
    ["299", "03", "689"],
    ["145", "03", "157"],
    ["158", "44", "789"],
    ["237", "25", "249"],
    ["239", "49", "135"],
    ["259", "64", "130"],
    ["238", "39", "270"],
  ],
  "07/01/2024 to 07/07/2024": [
    ["890", "78", "224"],
    ["345", "21", "579"],
    ["479", "04", "158"],
    ["445", "36", "600"],
    ["337", "39", "360"],
    ["145", "00", "479"],
    ["556", "60", "578"],
  ],
  "07/08/2024 to 07/14/2024": [
    ["370", "01", "146"],
    ["778", "29", "126"],
    ["349", "61", "678"],
    ["689", "31", "489"],
    ["580", "31", "290"],
    ["368", "79", "469"],
    ["458", "76", "240"],
  ],
  "07/15/2024 to 07/21/2024": [
    ["159", "53", "580"],
    ["679", "22", "246"],
    ["557", "78", "558"],
    ["229", "30", "677"],
    ["448", "61", "146"],
    ["126", "90", "235"],
    ["229", "30", "389"],
  ],
  "07/22/2024 to 07/28/2024": [
    ["367", "61", "119"],
    ["247", "35", "339"],
    ["133", "78", "189"],
    ["120", "37", "340"],
    ["113", "59", "234"],
    ["400", "41", "579"],
    ["110", "23", "256"],
  ],
  "12/30/2024 to 01/05/2025": [
    [566, 78, 459],
    [113, 50, 127],
    [789, 46, 268],
    [568, 92, 390],
    [140, 51, 245],
    [588, 10, 389],
    [389, "09", 478],
  ],
  "01/06/2025 to 01/12/2025": [
    [223, 72, 390],
    [340, 70, 127],
    [280, "07", 368],
    [144, 94, 356],
    [178, 66, 880],
    [590, 41, 678],
    [456, 52, 228],
  ],
  "01/13/2025 to 01/19/2025": [
    [239, 49, 234],
    [160, 76, 330],
    [699, 40, 280],
    [255, 21, 290],
    [556, 67, 359],
    [244, "02", 570],
    [349, 65, 168],
  ],
};

export const MILANNIGHT = {
  "01/02/2023 to 01/08/2023": [
    ["345", "26", "268"],
    ["370", "04", "167"],
    ["124", "70", "488"],
    ["900", "96", "268"],
    ["459", "81", "588"],
    ["136", "07", "467"],
  ],
  "01/09/2023 to 01/15/2023": [
    ["177", "59", "234"],
    ["127", "07", "890"],
    ["479", "03", "346"],
    ["456", "54", "356"],
    ["478", "92", "246"],
    ["568", "97", "160"],
  ],
  "01/16/2023 to 01/22/2023": [
    ["460", "00", "569"],
    ["246", "25", "500"],
    ["220", "43", "779"],
    ["220", "43", "779"],
    ["160", "71", "380"],
    ["336", "29", "180"],
    ["370", "06", "899"],
  ],
  // "01/23/2023 to 01/29/2023": [
  //    ["246", "21", "128"],
  //    ["680", "48", "468"],
  //    ["577", "91", "678"],
  //    ["224", "81", "100"],
  //    ["459", "80", "370"],
  //    ["456", "54", "356"],

  // ],
  "01/30/2023 to 02/05/2023": [
    ["224", "81", "100"],
    ["259", "67", "467"],
    ["799", "53", "599"],
    ["224", "82", "778"],
    ["370", "03", "148"],
    ["246", "26", "790"],
  ],
  "02/06/2023 to 02/12/2023": [
     ["568", "98", "440"],
     ["669", "13", "490"],
     ["239", "42", "345"],
     ["447", "51", "669"],
     ["170", "89", "388"],
     ["455", "44", "248"],
  ],
  "02/13/2023 to 02/19/2023": [
     ["240", "60", "334"],
     ["600", "67", "269"],
     ["780", "51", "236"],
     ["236", "19", "900"],
     ["368", "71", "470"],
     ["237", "25", "230"],
  ],
  "02/20/2023 to 02/26/2023": [
     ["117", "91", "290"],
     ["266", "45", "799"],
     ["458", "75", "456"],
     ["136", "02", "147"],
     ["334", "01", "146"],
     ["367", "63", "148"],
  ],
  "02/27/2023 to 03/05/2023": [
     ["237", "26", "114"],
     ["590", "47", "449"],
     ["335", "17", "133"],
     ["270", "98", "224"],
     ["459", "80", "235"],
     ["267", "53", "689"],
  ],
 
  "03/13/2023 to 03/19/2023": [
     ["600", "66", "556"],
     ["499", "28", "567"],
     ["290", "12", "237"],
     ["228", "23", "355"],
     ["446", "41", "119"],
     ["345", "25", "122"],
  ],
  "03/20/2023 to 03/26/2023": [
     ["440", "88", "990"],
     ["123", "66", "600"],
     ["139", "30", "299"],
     ["256", "38", "468"],
     ["137", "14", "680"],
     ["149", "44", "130"],
  ],
  "01/02/2023 to 01/08/2023": [
     ["345", "26", "268"],
     ["370", "04", "167"],
     ["124", "70", "488"],
     ["900", "96", "268"],
     ["459", "81", "588"],
     ["136", "07", "467"],
  ],
  "01/09/2023 to 01/15/2023": [
     ["177", "59", "234"],
     ["127", "07", "890"],
     ["479", "03", "346"],
     ["456", "54", "356"],
     ["478", "92", "246"],
     ["568", "97", "160"],
  ],
  "01/16/2023 to 01/22/2023": [
     ["460", "00", "569"],
     ["246", "25", "500"],
     ["220", "43", "779"],
     ["160", "71", "380"],
     ["336", "29", "180"],
     ["370", "06", "899"],
  ],
  "02/13/2023 to 02/19/2023": [
     ["240", "60", "334"],
     ["600", "67", "269"],
     ["780", "51", "236"],
     ["236", "19", "900"],
     ["368", "71", "470"],
     ["237", "25", "230"],
  ],
  "02/20/2023 to 02/26/2023": [
     ["117", "91", "290"],
     ["266", "45", "799"],
     ["458", "75", "456"],
     ["136", "02", "147"],
     ["334", "01", "146"],
     ["367", "63", "148"],
  ],
  "02/27/2023 to 03/05/2023": [
     ["237", "26", "114"],
     ["590", "47", "449"],
     ["335", "17", "133"],
     ["270", "98", "224"],
     ["459", "80", "235"],
     ["267", "53", "689"],
  ],

  "03/13/2023 to 03/19/2023": [
     ["600", "66", "556"],
     ["499", "28", "567"],
     ["290", "12", "237"],
     ["228", "23", "355"],
     ["446", "41", "119"],
     ["345", "25", "122"],
  ],
  "03/20/2023 to 03/26/2023": [
     ["440", "88", "990"],
     ["123", "66", "600"],
     ["139", "30", "299"],
     ["256", "38", "468"],
     ["137", "14", "680"],
     ["149", "44", "130"],
  ],
  "03/27/2023 to 04/02/2023": [
     ["125", "80", "578"],
     ["229", "36", "150"],
     ["277", "63", "229"],
     ["125", "86", "169"],
     ["200", "20", "569"],
     ["135", "90", "569"],
  ],
  "04/03/2023 to 04/09/2023": [
     ["570", "27", "124"],
     ["249", "57", "115"],
     ["580", "30", "226"],
     ["334", "03", "139"],
     ["338", "45", "113"],
     ["169", "62", "246"],
  ],
  "04/10/2023 to 04/16/2023": [
     ["669", "12", "110"],
     ["288", "85", "140"],
     ["257", "46", "150"],
     ["345", "21", "560"],
     ["335", "16", "268"],
     ["560", "13", "157"],
  ],
  "04/17/2023 to 04/23/2023": [
     ["457", "69", "667"],
     ["457", "64", "770"],
     ["168", "51", "290"],
     ["458", "71", "245"],
     ["160", "72", "129"],
     ["237", "29", "568"],
  ],
  "04/24/2023 to 04/30/2023": [
     ["567", "89", "270"],
     ["245", "10", "389"],
     ["130", "45", "357"],
     ["129", "29", "388"],
     ["366", "56", "240"],
     ["139", "34", "338"],
  ],
  "05/01/2023 to 05/07/2023": [
     ["124", "72", "147"],
     ["335", "10", "578"],
     ["578", "05", "889"],
     ["570", "26", "123"],
     ["128", "16", "358"],
     ["225", "93", "788"],
  ],
  "05/08/2023 to 05/14/2023": [
     ["139", "30", "127"],
     ["237", "26", "150"],
     ["278", "76", "790"],
     ["455", "48", "170"],
     ["233", "82", "147"],
     ["249", "55", "249"],
  ],
  "05/15/2023 to 05/21/2023": [
     ["490", "32", "147"],
     ["790", "62", "345"],
     ["259", "64", "699"],
     ["668", "09", "117"],
     ["100", "13", "238"],
     ["236", "19", "568"],
  ],
  "05/22/2023 to 05/28/2023": [
     ["126", "99", "126"],
     ["200", "28", "990"],
     ["680", "49", "577"],
     ["358", "68", "233"],
     ["258", "57", "269"],
     ["460", "09", "270"],
  ],
  "05/29/2023 to 06/04/2023": [
     ["577", "90", "370"],
     ["116", "88", "567"],
     ["450", "98", "558"],
     ["770", "49", "379"],
     ["259", "67", "160"],
     ["240", "64", "347"],
  ],
  "06/05/2023 to 06/11/2023": [
     ["234", "93", "490"],
     ["588", "19", "450"],
     ["255", "23", "337"],
     ["349", "60", "370"],
     ["567", "85", "258"],
     ["589", "24", "680"],
  ],

  "01/09/2023 to 01/15/2023": [
     ["177", "59", "234"],
     ["127", "07", "890"],
     ["479", "03", "346"],
     ["456", "54", "356"],
     ["478", "92", "246"],
     ["568", "97", "160"],
  ],
  "01/16/2023 to 01/22/2023": [
     ["460", "00", "569"],
     ["246", "25", "500"],
     ["220", "43", "779"],
     ["160", "71", "380"],
     ["336", "29", "180"],
     ["370", "06", "899"],
  ],
  "01/23/2023 to 01/29/2023": [
     ["246", "21", "128"],
     ["680", "48", "468"],
     ["220", "43", "779"],
     ["577", "91", "678"],
     ["459", "80", "370"],
     ["114", "69", "117"],
  ],
  "01/30/2023 to 02/05/2023": [
     ["224", "81", "100"],
     ["259", "67", "467"],
     ["799", "53", "599"],
     ["224", "82", "778"],
     ["370", "03", "148"],
     ["246", "26", "790"],
  ],
  "02/06/2023 to 02/12/2023": [
     ["568", "98", "440"],
     ["669", "13", "490"],
     ["239", "42", "345"],
     ["447", "51", "669"],
     ["170", "89", "388"],
     ["455", "44", "248"],
  ],
  "02/13/2023 to 02/19/2023": [
     ["240", "60", "334"],
     ["600", "67", "269"],
     ["780", "51", "236"],
     ["236", "19", "900"],
     ["368", "71", "470"],
     ["237", "25", "230"],
  ],
  "02/20/2023 to 02/26/2023": [
     ["117", "91", "290"],
     ["266", "45", "799"],
     ["458", "75", "456"],
     ["136", "02", "147"],
     ["334", "01", "146"],
     ["367", "63", "148"],
  ],
  "02/27/2023 to 03/05/2023": [
     ["237", "26", "114"],
     ["590", "47", "449"],
     ["335", "17", "133"],
     ["270", "98", "224"],
     ["459", "80", "235"],
     ["267", "53", "689"],
  ],
  "03/06/2023 to 03/12/2023": [
     ["113", "54", "770"],
     ["130", "49", "126"],
     ["240", "61", "470"],
     ["446", "41", "119"],
     ["358", "65", "366"],
     ["245", "17", "278"],
  ],
  "03/13/2023 to 03/19/2023": [
     ["600", "66", "556"],
     ["499", "28", "567"],
     ["290", "12", "237"],
     ["228", "23", "355"],
     ["446", "41", "119"],
     ["345", "25", "122"],
  ],
  "03/20/2023 to 03/26/2023": [
     ["440", "88", "990"],
     ["123", "66", "600"],
     ["139", "30", "299"],
     ["256", "38", "468"],
     ["137", "14", "680"],
     ["149", "44", "130"],
  ],
  "03/27/2023 to 04/02/2023": [
     ["125", "80", "578"],
     ["229", "36", "150"],
     ["277", "63", "229"],
     ["125", "86", "169"],
     ["200", "20", "569"],
     ["135", "90", "569"],
  ],
  "04/03/2023 to 04/09/2023": [
     ["570", "27", "124"],
     ["249", "57", "115"],
     ["580", "30", "226"],
     ["334", "03", "139"],
     ["338", "45", "113"],
     ["169", "62", "246"],
  ],
  "04/10/2023 to 04/16/2023": [
     ["669", "12", "110"],
     ["288", "85", "140"],
     ["257", "46", "150"],
     ["345", "21", "560"],
     ["335", "16", "268"],
     ["560", "13", "157"],
  ],
  "04/17/2023 to 04/23/2023": [
     ["457", "69", "667"],
     ["457", "64", "770"],
     ["168", "51", "290"],
     ["458", "71", "245"],
     ["160", "72", "129"],
     ["237", "29", "568"],
  ],
  "04/24/2023 to 04/30/2023": [
     ["567", "89", "270"],
     ["245", "10", "389"],
     ["130", "45", "357"],
     ["129", "29", "388"],
     ["366", "56", "240"],
     ["139", "34", "338"],
  ],
  "05/01/2023 to 05/07/2023": [
     ["124", "72", "147"],
     ["335", "10", "578"],
     ["578", "05", "889"],
     ["570", "26", "123"],
     ["128", "16", "358"],
     ["225", "93", "788"],
  ],
  "05/08/2023 to 05/14/2023": [
     ["139", "30", "127"],
     ["237", "26", "150"],
     ["278", "76", "790"],
     ["455", "48", "170"],
     ["233", "82", "147"],
     ["249", "55", "249"],
  ],
  "05/15/2023 to 05/21/2023": [
     ["490", "32", "147"],
     ["790", "62", "345"],
     ["259", "64", "699"],
     ["668", "09", "117"],
     ["100", "13", "238"],
     ["236", "19", "568"],
  ],
  "05/22/2023 to 05/28/2023": [
     ["126", "99", "126"],
     ["200", "28", "990"],
     ["680", "49", "577"],
     ["358", "68", "233"],
     ["258", "57", "269"],
     ["460", "09", "270"],
  ],

  "06/12/2023 to 06/18/2023": [
     ["899", "62", "200"],
     ["667", "90", "578"],
     ["240", "65", "177"],
     ["799", "52", "246"],
     ["148", "34", "699"],
     ["148", "32", "345"],
  ],
  "06/19/2023 to 06/25/2023": [
     ["229", "33", "670"],
     ["445", "32", "246"],
     ["349", "69", "450"],
     ["129", "29", "135"],
     ["348", "57", "223"],
     ["346", "31", "119"],
  ],
  "06/26/2023 to 07/02/2023": [
     ["144", "99", "289"],
     ["477", "82", "390"],
     ["489", "16", "457"],
     ["335", "16", "790"],
     ["167", "42", "570"],
     ["345", "27", "458"],
  ],
  "07/03/2023 to 07/09/2023": [
     ["148", "38", "369"],
     ["456", "56", "880"],
     ["780", "59", "478"],
     ["689", "33", "238"],
     ["112", "44", "167"],
     ["170", "85", "690"],
  ],
  "07/10/2023 to 07/16/2023": [
     ["220", "44", "347"],
     ["666", "85", "339"],
     ["125", "85", "267"],
     ["550", "01", "399"],
     ["120", "38", "350"],
     ["368", "71", "245"],
  ],
  "07/17/2023 to 07/23/2023": [
     ["130", "49", "270"],
     ["334", "07", "566"],
     ["489", "11", "560"],
     ["889", "53", "238"],
     ["234", "93", "157"],
     ["289", "95", "456"],
  ],
  "07/24/2023 to 07/30/2023": [
     ["246", "20", "136"],
     ["550", "04", "266"],
     ["225", "99", "289"],
     ["146", "18", "233"],
     ["248", "45", "267"],
     ["578", "04", "590"],
  ],
  "07/31/2023 to 08/06/2023": [
     ["260", "88", "468"],
     ["128", "17", "133"],
     ["126", "91", "380"],
     ["359", "79", "667"],
     ["470", "10", "145"],
     ["115", "72", "679"],
  ],
  "08/07/2023 to 08/13/2023": [
     ["180", "98", "558"],
     ["467", "72", "129"],
     ["378", "85", "168"],
     ["256", "33", "490"],
     ["128", "19", "568"],
     ["370", "05", "249"],
  ],
  "08/14/2023 to 08/20/2023": [
     ["129", "24", "257"],

     ["130", "43", "247"],
     ["678", "11", "380"],
     ["590", "44", "257"],
     ["459", "82", "237"],
  ],
  "08/21/2023 to 08/27/2023": [
     ["499", "28", "260"],
     ["377", "78", "567"],
     ["227", "16", "457"],
     ["770", "47", "133"],
     ["770", "40", "488"],
  ],
  "08/28/2023 to 09/03/2023": [
     ["789", "42", "345"],
     ["788", "39", "234"],
     ["490", "37", "467"],
     ["240", "60", "389"],
     ["689", "36", "367"],
     ["136", "09", "180"],
  ],
  "03/27/2023 to 04/02/2023": [
     ["125", "80", "578"],
     ["229", "36", "150"],
     ["277", "63", "229"],
     ["125", "86", "169"],
     ["200", "20", "569"],
     ["135", "90", "569"],
  ],
  "04/03/2023 to 04/09/2023": [
     ["570", "27", "124"],
     ["249", "57", "115"],
     ["580", "30", "226"],
     ["334", "03", "139"],
     ["338", "45", "113"],
     ["169", "62", "246"],
  ],
  "04/10/2023 to 04/16/2023": [
     ["669", "12", "110"],
     ["288", "85", "140"],
     ["257", "46", "150"],
     ["345", "21", "560"],
     ["335", "16", "268"],
     ["560", "13", "157"],
  ],
  "04/17/2023 to 04/23/2023": [
     ["457", "69", "667"],
     ["457", "64", "770"],
     ["168", "51", "290"],
     ["458", "71", "245"],
     ["160", "72", "129"],
     ["237", "29", "568"],
  ],
  "04/24/2023 to 04/30/2023": [
     ["567", "89", "270"],
     ["245", "10", "389"],
     ["130", "45", "357"],
     ["129", "29", "388"],
     ["366", "56", "240"],
     ["139", "34", "338"],
  ],
  "05/01/2023 to 05/07/2023": [
     ["124", "72", "147"],
     ["335", "10", "578"],
     ["578", "05", "889"],
     ["570", "26", "123"],
     ["128", "16", "358"],
     ["225", "93", "788"],
  ],
  "05/08/2023 to 05/14/2023": [
     ["139", "30", "127"],
     ["237", "26", "150"],
     ["278", "76", "790"],
     ["455", "48", "170"],
     ["233", "82", "147"],
     ["249", "55", "249"],
  ],
  "05/15/2023 to 05/21/2023": [
     ["490", "32", "147"],
     ["790", "62", "345"],
     ["259", "64", "699"],
     ["668", "09", "117"],
     ["100", "13", "238"],
     ["236", "19", "568"],
  ],
  "05/22/2023 to 05/28/2023": [
     ["126", "99", "126"],
     ["200", "28", "990"],
     ["680", "49", "577"],
     ["358", "68", "233"],
     ["258", "57", "269"],
     ["460", "09", "270"],
  ],
  "05/29/2023 to 06/04/2023": [
     ["577", "90", "370"],
     ["116", "88", "567"],
     ["450", "98", "558"],
     ["770", "49", "379"],
     ["259", "67", "160"],
     ["240", "64", "347"],
  ],
  "06/05/2023 to 06/11/2023": [
     ["234", "93", "490"],
     ["588", "19", "450"],
     ["255", "23", "337"],
     ["349", "60", "370"],
     ["567", "85", "258"],
     ["589", "24", "680"],
  ],
  "06/12/2023 to 06/18/2023": [
     ["899", "62", "200"],
     ["667", "90", "578"],
     ["240", "65", "177"],
     ["799", "52", "246"],
     ["148", "34", "699"],
     ["148", "32", "345"],
  ],
  "06/19/2023 to 06/25/2023": [
     ["229", "33", "670"],
     ["445", "32", "246"],
     ["349", "69", "450"],
     ["129", "29", "135"],
     ["348", "57", "223"],
     ["346", "31", "119"],
  ],
  "06/26/2023 to 07/02/2023": [
     ["144", "99", "289"],
     ["477", "82", "390"],
     ["489", "16", "457"],
     ["335", "16", "790"],
     ["167", "42", "570"],
     ["345", "27", "458"],
  ],
  "07/03/2023 to 07/09/2023": [
     ["148", "38", "369"],
     ["456", "56", "880"],
     ["780", "59", "478"],
     ["689", "33", "238"],
     ["112", "44", "167"],
     ["170", "85", "690"],
  ],
  "07/10/2023 to 07/16/2023": [
     ["220", "44", "347"],
     ["666", "85", "339"],
     ["125", "85", "267"],
     ["550", "01", "399"],
     ["120", "38", "350"],
     ["368", "71", "245"],
  ],
  "07/17/2023 to 07/23/2023": [
     ["130", "49", "270"],
     ["334", "07", "566"],
     ["489", "11", "560"],
     ["889", "53", "238"],
     ["234", "93", "157"],
     ["289", "95", "456"],
  ],
  "07/24/2023 to 07/30/2023": [
     ["246", "20", "136"],
     ["550", "04", "266"],
     ["225", "99", "289"],
     ["146", "18", "233"],
     ["248", "45", "267"],
     ["578", "04", "590"],
  ],
  "07/31/2023 to 08/06/2023": [
     ["260", "88", "468"],
     ["128", "17", "133"],
     ["126", "91", "380"],
     ["359", "79", "667"],
     ["470", "10", "145"],
     ["115", "72", "679"],
  ],
  "08/07/2023 to 08/13/2023": [
     ["180", "98", "558"],
     ["467", "72", "129"],
     ["378", "85", "168"],
     ["256", "33", "490"],
     ["128", "19", "568"],
     ["370", "05", "249"],
  ],
  "08/14/2023 to 08/20/2023": [
     ["129", "24", "257"],

     ["130", "43", "247"],
     ["678", "11", "380"],
     ["590", "44", "257"],
     ["459", "82", "237"],
     ["378", "85", "168"],
  ],
  "08/21/2023 to 08/27/2023": [
     ["499", "28", "260"],
     ["377", "78", "567"],
     ["227", "16", "457"],
     ["770", "47", "133"],
     ["770", "40", "488"],
     ["467", "72", "129"],
  ],
  "08/28/2023 to 09/03/2023": [
     ["789", "42", "345"],
     ["788", "39", "234"],
     ["490", "37", "467"],
     ["240", "60", "389"],
     ["689", "36", "367"],
     ["136", "09", "180"],
  ],
  "09/04/2023 to 09/10/2023": [
     ["399", "19", "360"],
     ["348", "57", "250"],
     ["240", "60", "569"],
     ["147", "20", "299"],
     ["569", "00", "235"],
     ["378", "84", "789"],
  ],
  "09/11/2023 to 09/17/2023": [
     ["890", "70", "677"],
     ["237", "26", "349"],
     ["889", "51", "290"],
     ["568", "93", "229"],
     ["180", "97", "377"],
     ["458", "78", "116"],
  ],
  "09/18/2023 to 09/24/2023": [
     ["147", "25", "348"],
     ["125", "89", "450"],
     ["234", "97", "160"],
     ["460", "04", "680"],
     ["490", "34", "266"],
     ["112", "43", "490"],
  ],
  "09/25/2023 to 10/01/2023": [
     ["458", "73", "247"],
     ["380", "15", "780"],
     ["136", "05", "500"],
     ["256", "39", "117"],
     ["269", "77", "340"],
     ["468", "80", "578"],
  ],
  "10/02/2023 to 10/08/2023": [
     ["670", "32", "129"],
     ["257", "47", "340"],
     ["233", "85", "348"],
     ["247", "32", "570"],
     ["158", "43", "670"],
     ["130", "40", "190"],
  ],
  "10/09/2023 to 10/15/2023": [
     ["470", "15", "249"],
     ["279", "86", "457"],
     ["126", "99", "360"],
     ["580", "38", "567"],
     ["469", "99", "450"],
     ["120", "38", "558"],
  ],
  "10/16/2023 to 10/22/2023": [
     ["560", "13", "599"],
     ["170", "84", "158"],
     ["578", "06", "448"],
     ["240", "65", "168"],
     ["360", "98", "260"],
     ["669", "16", "268"],
  ],
  "10/23/2023 to 10/29/2023": [
     ["689", "38", "125"],
     ["345", "26", "123"],
     ["334", "02", "778"],
     ["578", "02", "336"],
     ["580", "39", "126"],
     ["348", "57", "160"],
  ],
  "10/30/2023 to 11/05/2023": [
     ["126", "90", "479"],
     ["137", "19", "289"],
     ["889", "56", "240"],
     ["790", "69", "117"],
     ["345", "23", "139"],
     ["466", "62", "480"],
  ],
  "11/06/2023 to 11/12/2023": [
     ["114", "65", "249"],
     ["128", "10", "578"],
     ["678", "19", "379"],
     ["268", "68", "189"],
     ["334", "02", "778"],
     ["689", "38", "125"],
  ],
  "11/13/2023 to 11/19/2023": [
     ["689", "38", "125"],
     ["449", "77", "467"],
     ["137", "19", "289"],
     ["678", "19", "379"],
     ["268", "68", "189"],
     ["126", "90", "479"],
  ],
  "11/20/2023 to 11/26/2023": [
     ["189", "82", "255"],
     ["120", "34", "248"],
     ["447", "51", "588"],
     ["449", "77", "467"],
     ["356", "45", "348"],
     ["669", "15", "348"],
  ],
  "11/27/2023 to 12/03/2023": [
     ["399", "14", "446"],
     ["234", "99", "568"],
     ["378", "84", "239"],
     ["457", "64", "400"],
     ["334", "08", "800"],
     ["237", "23", "256"],
  ],
  "12/04/2023 to 12/10/2023": [
     ["144", "90", "578"],
     ["156", "24", "446"],
     ["680", "48", "990"],
     ["268", "68", "125"],
     ["159", "57", "368"],
     ["359", "71", "146"],
  ],
  "12/11/2023 to 12/17/2023": [
     ["559", "94", "789"],
     ["234", "95", "267"],
     ["467", "76", "268"],
     ["890", "79", "135"],
     ["249", "50", "389"],
     ["359", "76", "123"],
  ],
  "12/18/2023 to 12/24/2023": [
     ["340", "77", "890"],
     ["167", "41", "678"],
     ["267", "53", "256"],
     ["113", "54", "347"],
     ["255", "21", "137"],
     ["268", "63", "148"],
  ],
  "12/25/2023 to 12/31/2023": [
     ["400", "42", "778"],
     ["467", "75", "113"],
     ["588", "14", "248"],
     ["359", "79", "126"],
     ["600", "67", "467"],
     ["560", "15", "267"],
  ],
  "01/01/2024 to 01/07/2024": [
     ["230", "50", "280"],
     ["279", "88", "288"],
     ["459", "80", "488"],
     ["568", "96", "349"],
     ["150", "69", "270"],
     ["340", "79", "478"],
  ],
  "01/08/2024 to 01/14/2024": [
     ["790", "61", "777"],
     ["299", "02", "480"],
     ["889", "50", "190"],
     ["349", "68", "468"],
     ["127", "02", "345"],
     ["156", "27", "250"],
  ],
  "01/15/2024 to 01/21/2024": [
     ["890", "77", "188"],
     ["145", "08", "189"],
     ["369", "88", "440"],
     ["244", "01", "380"],
     ["890", "77", "458"],
     ["290", "18", "369"],
  ],
  "01/22/2024 to 01/28/2024": [
     ["568", "91", "146"],
     ["169", "61", "380"],
     ["570", "28", "279"],
     ["123", "64", "149"],
     ["244", "01", "380"],

     ["789", "44", "789"],
  ],
  "01/29/2024 to 02/04/2024": [
     ["137", "12", "480"],
     ["456", "50", "145"],
     ["226", "05", "456"],
     ["135", "99", "478"],
     ["550", "05", "357"],
     ["145", "04", "257"],
  ],
  "02/05/2024 to 02/11/2024": [
     ["250", "70", "190"],
     ["180", "95", "159"],
     ["134", "87", "368"],
     ["134", "81", "245"],
     ["239", "41", "678"],
     ["249", "58", "189"],
  ],
  "02/12/2024 to 02/18/2024": [
     ["149", "40", "578"],
     ["123", "66", "178"],
     ["158", "44", "149"],
     ["456", "52", "480"],
     ["118", "05", "230"],
     ["358", "62", "246"],
  ],
  "02/19/2024 to 02/25/2024": [
     ["225", "97", "115"],
     ["156", "20", "479"],
     ["455", "40", "479"],
     ["235", "08", "666"],
     ["790", "67", "449"],
     ["670", "36", "358"],
  ],
  "02/26/2024 to 03/03/2024": [
     ["460", "01", "155"],
     ["569", "05", "780"],
     ["699", "46", "178"],
     ["234", "94", "455"],
     ["129", "27", "250"],
     ["450", "92", "570"],
  ],
  "03/04/2024 to 03/10/2024": [
     ["560", "17", "368"],
     ["449", "70", "280"],
     ["600", "63", "229"],
     ["248", "47", "890"],
     ["568", "95", "258"],
     ["237", "24", "699"],
  ],
  "03/11/2024 to 03/17/2024": [
     ["678", "13", "166"],
     ["180", "98", "260"],
     ["370", "01", "579"],
     ["160", "78", "350"],
     ["159", "53", "670"],
     ["236", "19", "180"],
  ],
  "03/18/2024 to 03/24/2024": [
     ["347", "44", "248"],
     ["578", "01", "245"],
     ["146", "12", "156"],
     ["399", "16", "240"],
     ["238", "34", "347"],
     ["240", "66", "349"],
  ],
  "03/25/2024 to 03/31/2024": [
     ["157", "37", "340"],
     ["378", "84", "257"],
     ["670", "30", "569"],
     ["267", "57", "250"],
     ["257", "46", "358"],
     ["180", "98", "260"],
  ],
  "04/01/2024 to 04/07/2024": [
     ["169", "67", "269"],
     ["178", "62", "228"],
     ["689", "39", "270"],
     ["244", "04", "680"],
     ["689", "32", "138"],
     ["800", "88", "224"],
  ],
  "04/08/2024 to 04/14/2024": [
     ["126", "91", "399"],
     ["160", "78", "567"],
     ["230", "51", "560"],
     ["280", "04", "347"],
     ["578", "06", "358"],
     ["139", "35", "168"],
  ],
  "04/15/2024 to 04/21/2024": [
     ["455", "41", "137"],
     ["479", "03", "238"],
     ["467", "73", "490"],
     ["670", "39", "478"],
     ["779", "39", "360"],
     ["669", "10", "578"],
  ],
  "04/22/2024 to 04/28/2024": [
     ["126", "90", "569"],
     ["179", "71", "560"],
     ["178", "69", "478"],
     ["148", "31", "669"],
     ["240", "65", "168"],
     ["146", "13", "148"],
  ],
  "04/29/2024 to 05/05/2024": [
     ["278", "78", "459"],
     ["155", "19", "379"],
     ["256", "39", "900"],
     ["336", "29", "180"],
     ["235", "02", "129"],
     ["280", "09", "450"],
  ],
  "05/06/2024 to 05/12/2024": [
     ["468", "82", "129"],
     ["400", "40", "244"],
     ["137", "17", "449"],
     ["239", "43", "247"],
     ["279", "89", "478"],
     ["478", "91", "137"],
  ],
  "05/13/2024 to 05/19/2024": [
     ["445", "35", "140"],
     ["167", "43", "346"],
     ["167", "46", "880"],
     ["590", "42", "589"],
     ["350", "84", "158"],
     ["149", "47", "557"],
  ],
  "05/20/2024 to 05/26/2024": [
     ["590", "40", "127"],
     ["246", "25", "690"],
     ["350", "86", "349"],
     ["249", "57", "160"],
     ["789", "43", "139"],
     ["249", "57", "250"],
  ],
  "05/27/2024 to 06/02/2024": [
     ["380", "19", "478"],
     ["170", "89", "379"],
     ["157", "35", "230"],
     ["148", "32", "679"],
     ["269", "76", "268"],
     ["230", "59", "568"],
  ],
  "06/03/2024 to 06/09/2024": [
     ["567", "85", "267"],
     ["358", "63", "148"],
     ["680", "43", "788"],
     ["148", "30", "280"],
     ["137", "15", "889"],
     ["557", "79", "360"],
  ],
  "06/24/2024 to 06/30/2024": [
     ["369", "82", "237"],
     ["170", "86", "790"],
     ["779", "31", "588"],
     ["337", "33", "346"],
     ["126", "95", "113"],
     ["778", "23", "689"],
  ],
  "07/01/2024 to 07/07/2024": [
     ["688", "25", "230"],
     ["358", "68", "279"],
     ["380", "14", "112"],
     ["660", "28", "558"],
     ["350", "88", "468"],
     ["156", "26", "268"],
  ],
  "07/08/2024 to 07/14/2024": [
     ["358", "62", "156"],
     ["790", "62", "228"],
     ["179", "72", "147"],
     ["269", "76", "123"],
     ["140", "54", "239"],
     ["790", "68", "170"],
  ],
  "07/15/2024 to 07/21/2024": [
     ["789", "48", "260"],
     ["239", "43", "256"],
     ["157", "36", "349"],
     ["347", "40", "677"],
     ["458", "72", "679"],
     ["226", "08", "125"],
  ],
  "07/22/2024 to 07/28/2024": [
     ["459", "88", "369"],
     ["136", "06", "268"],
     ["236", "11", "678"],
     ["789", "41", "236"],
     ["450", "90", "190"],
     ["780", "55", "159"],
  ],

  "12/30/2024 to 01/05/2025": [
     [345, 28, 134],
     [169, 69, 360],
     [199, 98, 233],
     [678, 19, 180],
     [130, 46, 150],
     [169, 68, 350],
  ],
  "01/06/2025 to 01/12/2025": [
     [567, 81, 678],
     [479, "03", 247],
     [480, 24, 130],
     [169, 67, 359],
     [579, 19, 360],
     [490, 38, 369],
  ],
  "01/13/2025 to 01/19/2025": [
     [480, 26, 880],
     [278, 72, 156],
     [127, "08", 468],
     [235, "07", 160],
     [260, 88, 189],
     [140, 56, 259],
  ],
};

export const RAJDHANINIGHT = {
  "01/02/2023 to 01/08/2023": [
     ["334", "02", "336"],
     ["169", "67", "179"],
     ["490", "38", "378"],
     ["147", "23", "355"],
     ["137", "17", "890"],
  ],
  "01/09/2023 to 01/15/2023": [
     ["689", "34", "158"],
     ["177", "58", "468"],
     ["150", "60", "127"],
     ["145", "06", "457"],
     ["799", "56", "349"],
  ],
  "01/16/2023 to 01/22/2023": [
     ["117", "97", "557"],
     ["179", "72", "228"],
     ["360", "98", "134"],
     ["470", "18", "224"],
     ["179", "75", "339"],
  ],
  "01/23/2023 to 01/29/2023": [
     ["125", "89", "289"],
     ["133", "76", "349"],
     ["255", "21", "560"],
     ["177", "58", "468"],
     ["167", "40", "370"],
  ],
  "01/30/2023 to 02/05/2023": [
     ["129", "24", "770"],
     ["566", "73", "580"],
     ["239", "40", "280"],
     ["340", "78", "170"],
     ["138", "23", "148"],
  ],
  "02/06/2023 to 02/12/2023": [
     ["458", "76", "790"],
     ["590", "46", "600"],
     ["288", "87", "890"],
     ["155", "15", "159"],
     ["138", "28", "134"],
  ],
  "02/13/2023 to 02/19/2023": [
     ["258", "53", "148"],
     ["345", "21", "119"],
     ["136", "08", "116"],
     ["688", "21", "245"],
     ["790", "69", "289"],
  ],
  "02/20/2023 to 02/26/2023": [
     ["458", "70", "370"],
     ["189", "80", "226"],
     ["125", "84", "680"],
     ["138", "21", "489"],
     ["800", "82", "480"],
  ],
  "02/27/2023 to 03/05/2023": [
     ["146", "18", "189"],
     ["569", "01", "579"],
     ["147", "23", "229"],
     ["279", "82", "147"],
     ["126", "93", "247"],
  ],
  "03/06/2023 to 03/12/2023": [
     ["246", "23", "256"],
     ["550", "09", "379"],
     ["177", "58", "468"],
     ["566", "78", "468"],
     ["456", "53", "148"],
  ],
  "03/13/2023 to 03/19/2023": [
     ["289", "98", "233"],
     ["160", "74", "590"],
     ["256", "37", "133"],
     ["348", "56", "358"],
     ["115", "70", "479"],
  ],
  "03/20/2023 to 03/26/2023": [
     ["146", "19", "270"],
     ["340", "74", "149"],
     ["468", "85", "177"],
     ["389", "03", "490"],
     ["130", "42", "129"],
  ],
  "03/27/2023 to 04/02/2023": [
     ["578", "04", "266"],
     ["490", "34", "680"],
     ["170", "87", "566"],
     ["127", "03", "139"],
     ["136", "05", "690"],
  ],
  "04/03/2023 to 04/09/2023": [
     ["900", "94", "266"],
     ["459", "85", "447"],
     ["677", "09", "379"],
     ["270", "94", "130"],
     ["780", "59", "289"],
  ],
  "04/10/2023 to 04/16/2023": [
     ["250", "77", "269"],
     ["389", "04", "149"],
     ["223", "72", "688"],
     ["469", "92", "499"],
     ["457", "65", "780"],
  ],
  "04/17/2023 to 04/23/2023": [
     ["680", "44", "257"],
     ["335", "19", "360"],
     ["379", "95", "267"],
     ["358", "68", "567"],
     ["249", "51", "290"],
  ],
  "04/24/2023 to 04/30/2023": [
     ["789", "42", "679"],
     ["228", "22", "147"],
     ["245", "12", "228"],
     ["189", "83", "300"],
     ["358", "63", "157"],
  ],
  "05/01/2023 to 05/07/2023": [
     ["339", "51", "678"],
     ["358", "67", "250"],
     ["567", "83", "120"],
     ["147", "25", "799"],
     ["129", "25", "159"],
  ],
  "05/08/2023 to 05/14/2023": [
     ["677", "02", "110"],
     ["145", "00", "235"],
     ["340", "73", "139"],
     ["158", "46", "114"],
     ["245", "14", "239"],
  ],
  "05/15/2023 to 05/21/2023": [
     ["288", "84", "789"],
     ["456", "59", "469"],
     ["678", "19", "234"],
     ["369", "86", "330"],
     ["110", "24", "149"],
  ],
  "05/22/2023 to 05/28/2023": [
     ["145", "05", "780"],
     ["457", "67", "160"],
     ["290", "13", "256"],
     ["245", "17", "359"],
     ["345", "20", "389"],
  ],
  "05/29/2023 to 06/04/2023": [
     ["224", "88", "459"],
     ["236", "10", "677"],
     ["355", "39", "469"],
     ["389", "00", "479"],
     ["556", "65", "357"],
  ],
  "06/05/2023 to 06/11/2023": [
     ["379", "95", "230"],
     ["179", "77", "160"],
     ["589", "24", "167"],
     ["588", "18", "134"],
     ["560", "13", "247"],
  ],
  "06/12/2023 to 06/18/2023": [
     ["246", "21", "489"],
     ["289", "93", "337"],
     ["123", "61", "245"],
     ["477", "83", "788"],
     ["150", "60", "190"],
  ],
  "06/19/2023 to 06/25/2023": [
     ["688", "23", "490"],
     ["356", "40", "299"],
     ["690", "57", "467"],
     ["679", "26", "259"],
     ["220", "45", "348"],
  ],
  "06/26/2023 to 07/02/2023": [
     ["367", "61", "678"],
     ["150", "67", "160"],
     ["557", "78", "134"],
     ["155", "11", "245"],
     ["689", "33", "689"],
  ],
  "07/03/2023 to 07/09/2023": [
     ["569", "09", "379"],
     ["560", "11", "128"],
     ["890", "72", "246"],
     ["579", "14", "167"],
     ["660", "20", "127"],
  ],
  "07/10/2023 to 07/16/2023": [
     ["346", "39", "568"],
     ["245", "13", "148"],
     ["110", "27", "133"],
     ["190", "07", "377"],
     ["188", "78", "260"],
  ],
  "07/17/2023 to 07/23/2023": [
     ["256", "37", "269"],
     ["346", "39", "667"],
     ["670", "30", "460"],
     ["478", "93", "120"],
     ["577", "91", "489"],
  ],
  "07/24/2023 to 07/30/2023": [
     ["240", "68", "800"],
     ["468", "89", "568"],
     ["366", "57", "467"],
     ["267", "56", "178"],
     ["568", "99", "144"],
  ],
  "07/31/2023 to 08/06/2023": [
     ["356", "49", "135"],
     ["279", "81", "245"],
     ["670", "33", "157"],
     ["160", "71", "290"],
     ["450", "91", "128"],
  ],
  "08/07/2023 to 08/13/2023": [
     ["144", "99", "135"],
     ["269", "76", "457"],
     ["188", "70", "136"],
     ["159", "55", "366"],
     ["133", "78", "567"],
  ],
  "08/14/2023 to 08/20/2023": [
     ["235", "06", "790"],

     ["177", "58", "468"],
     ["140", "52", "147"],
     ["400", "44", "680"],
     ["488", "09", "577"],
  ],
  "08/21/2023 to 08/27/2023": [
     ["357", "58", "288"],
     ["880", "65", "159"],
     ["690", "59", "270"],
     ["160", "78", "369"],
     ["468", "89", "568"],
  ],
  "08/28/2023 to 09/03/2023": [
     ["366", "57", "467"],
     ["267", "56", "178"],
     ["349", "68", "189"],
     ["148", "36", "169"],
     ["299", "04", "248"],
  ],
  "09/04/2023 to 09/10/2023": [
     ["400", "43", "256"],
     ["180", "99", "478"],
     ["134", "86", "556"],
     ["790", "67", "188"],
     ["900", "99", "469"],
  ],
  "09/11/2023 to 09/17/2023": [
     ["566", "72", "138"],
     ["114", "61", "579"],
     ["450", "94", "149"],
     ["469", "99", "126"],
     ["145", "01", "579"],
  ],
  "09/18/2023 to 09/24/2023": [
     ["289", "98", "990"],
     ["128", "16", "448"],
     ["468", "87", "269"],
     ["236", "12", "156"],
     ["225", "96", "457"],
  ],
  "09/25/2023 to 10/01/2023": [
     ["129", "20", "578"],
     ["114", "63", "238"],
     ["180", "99", "568"],
     ["338", "45", "780"],
     ["279", "81", "245"],
  ],
  "10/02/2023 to 10/08/2023": [
     ["559", "94", "112"],
     ["340", "73", "689"],
     ["158", "47", "223"],
     ["258", "53", "247"],
     ["357", "53", "599"],
  ],
  "10/09/2023 to 10/15/2023": [
     ["144", "91", "678"],
     ["370", "04", "158"],
     ["400", "41", "137"],
     ["390", "27", "467"],
     ["259", "65", "447"],
  ],
  "10/16/2023 to 10/22/2023": [
     ["445", "37", "368"],
     ["190", "02", "246"],
     ["126", "91", "560"],
     ["440", "89", "270"],
     ["130", "49", "180"],
  ],
  "10/23/2023 to 10/29/2023": [
     ["445", "33", "247"],
     ["130", "40", "190"],
     ["880", "61", "470"],
     ["399", "12", "138"],
     ["168", "53", "238"],
  ],
  "10/30/2023 to 11/05/2023": [
     ["146", "16", "556"],
     ["145", "02", "589"],
     ["170", "84", "158"],
     ["235", "01", "470"],
     ["480", "20", "136"],
  ],


  "11/20/2023 to 11/26/2023": [
     ["258", "54", "130"],
     ["135", "93", "148"],
     ["589", "29", "478"],
     ["780", "51", "335"],
     ["136", "08", "468"],
  ],
  "11/27/2023 to 12/03/2023": [
     ["345", "24", "149"],
     ["158", "49", "289"],
     ["690", "54", "167"],
     ["126", "99", "379"],
     ["366", "55", "168"],
  ],
  "12/04/2023 to 12/10/2023": [
     ["458", "74", "400"],
     ["570", "26", "600"],
     ["248", "47", "179"],
     ["570", "24", "257"],
     ["247", "37", "340"],
  ],
  "12/11/2023 to 12/17/2023": [
     ["478", "94", "347"],
     ["288", "83", "445"],
     ["238", "34", "347"],
     ["350", "87", "278"],
     ["156", "28", "477"],
  ],
  "12/18/2023 to 12/24/2023": [
     ["144", "94", "680"],
     ["167", "47", "377"],
     ["689", "30", "145"],
     ["678", "15", "500"],
     ["247", "38", "189"],
  ],
  "12/25/2023 to 12/31/2023": [
     ["445", "37", "179"],
     ["129", "28", "170"],
     ["136", "09", "234"],
     ["689", "30", "389"],
     ["699", "42", "200"],
  ],
  "01/01/2024 to 01/07/2024": [
     ["138", "22", "499"],
     ["990", "86", "169"],
     ["170", "85", "357"],
     ["236", "18", "189"],
     ["589", "22", "660"],
  ],
  "01/08/2024 to 01/14/2024": [
     ["699", "47", "368"],
     ["167", "41", "678"],
     ["399", "17", "458"],
     ["280", "09", "135"],
     ["255", "25", "500"],
  ],
  "01/15/2024 to 01/21/2024": [
     ["234", "90", "235"],
     ["380", "12", "228"],
     ["235", "01", "344"],
     ["570", "21", "678"],
     ["348", "52", "679"],
  ],

  "01/29/2024 to 02/04/2024": [
     ["771", "38", "170"],
     ["117", "95", "230"],
     ["589", "24", "789"],
     ["270", "90", "479"],
     ["259", "60", "299"],
  ],
  "02/05/2024 to 02/11/2024": [
     ["340", "77", "359"],
     ["660", "22", "679"],
     ["567", "83", "670"],
     ["480", "28", "260"],
     ["359", "72", "129"],
  ],
  "02/12/2024 to 02/18/2024": [
     ["389", "03", "580"],
     ["556", "60", "677"],
     ["120", "36", "880"],
     ["370", "07", "449"],
     ["347", "45", "357"],
  ],
  "02/19/2024 to 02/25/2024": [
     ["123", "60", "460"],
     ["579", "11", "669"],
     ["349", "60", "226"],
     ["126", "91", "155"],
     ["179", "77", "467"],
  ],
  "02/26/2024 to 03/03/2024": [
     ["346", "38", "459"],
     ["279", "84", "590"],
     ["490", "36", "367"],
     ["368", "79", "144"],
     ["469", "91", "137"],
  ],
  "03/04/2024 to 03/10/2024": [
     ["458", "79", "270"],
     ["570", "23", "247"],
     ["800", "86", "600"],
     ["278", "74", "338"],
     ["170", "86", "556"],
  ],
  "03/11/2024 to 03/17/2024": [
     ["150", "68", "260"],
     ["147", "25", "690"],
     ["567", "85", "258"],
     ["890", "79", "450"],
     ["470", "17", "179"],
  ],
  "03/18/2024 to 03/24/2024": [
     ["133", "76", "358"],
     ["470", "13", "490"],
     ["247", "34", "239"],
     ["267", "56", "169"],
     ["889", "51", "579"],
  ],
  "03/25/2024 to 03/31/2024": [
     ["128", "18", "116"],
     ["157", "31", "470"],
     ["170", "83", "120"],
     ["366", "55", "140"],
     ["247", "34", "239"],
  ],
  "04/01/2024 to 04/07/2024": [
     ["347", "48", "350"],
     ["236", "14", "400"],
     ["360", "91", "489"],
     ["223", "77", "458"],
     ["460", "09", "667"],
  ],
  "04/08/2024 to 04/14/2024": [
     ["680", "43", "238"],
     ["167", "41", "380"],
     ["122", "54", "239"],
     ["136", "02", "345"],
     ["268", "63", "670"],
  ],
  "04/15/2024 to 04/21/2024": [
     ["236", "16", "240"],
     ["338", "40", "280"],
     ["247", "32", "480"],
     ["170", "80", "145"],
     ["344", "13", "238"],
  ],
  "04/22/2024 to 04/28/2024": [
     ["480", "28", "459"],
     ["290", "18", "189"],
     ["390", "29", "450"],
     ["446", "48", "279"],
     ["334", "05", "267"],
  ],
  "04/29/2024 to 05/05/2024": [
     ["246", "21", "245"],
     ["248", "49", "360"],
     ["560", "14", "446"],
     ["140", "56", "466"],
     ["168", "52", "156"],
  ],
  "05/06/2024 to 05/12/2024": [
     ["370", "05", "230"],
     ["149", "46", "178"],
     ["577", "96", "349"],
     ["245", "18", "134"],
     ["169", "64", "266"],
  ],
  "05/13/2024 to 05/19/2024": [
     ["130", "42", "570"],
     ["177", "50", "127"],
     ["125", "80", "190"],
     ["389", "08", "558"],
     ["147", "20", "280"],
  ],
  "05/20/2024 to 05/26/2024": [
     ["789", "40", "136"],
     ["499", "21", "489"],
     ["480", "25", "140"],
     ["679", "27", "278"],
     ["466", "63", "247"],
  ],
  "05/27/2024 to 06/02/2024": [
     ["235", "08", "125"],
     ["267", "51", "579"],
     ["134", "87", "278"],
     ["122", "57", "467"],
     ["459", "81", "227"],
  ],

  "06/03/2024 to 06/09/2024": [
     ["179", "72", "138"],
     ["390", "20", "370"],
     ["780", "53", "670"],
     ["455", "41", "137"],
     ["168", "55", "267"],
  ],
  "06/24/2024 to 06/30/2024": [
     ["688", "25", "249"],
     ["900", "93", "580"],
     ["366", "57", "250"],
     ["579", "13", "300"],
     ["480", "23", "670"],
  ],
  "07/01/2024 to 07/07/2024": [
     ["256", "37", "188"],
     ["240", "67", "890"],
     ["290", "11", "678"],
     ["457", "61", "579"],
     ["359", "78", "369"],
  ],
  "07/08/2024 to 07/14/2024": [
     ["470", "12", "228"],
     ["568", "90", "460"],
     ["467", "77", "890"],
     ["778", "23", "490"],
     ["247", "33", "256"],
  ],
  "07/15/2024 to 07/21/2024": [
     ["160", "77", "278"],
     ["445", "34", "158"],
     ["590", "49", "478"],
     ["480", "27", "340"],
     ["588", "17", "890"],
  ],
  "07/22/2024 to 07/28/2024": [
     ["134", "81", "579"],
     ["279", "02", "138"],
     ["690", "51", "489"],
     ["400", "45", "140"],
     ["379", "98", "369"],
  ],

  "12/30/2024 to 01/05/2025": [
     [147, 22, 345],
     [590, 40, 136],
     [790, 60, 479],
     [489, 13, 247],
     [267, 54, 680],
  ],
  "01/06/2025 to 01/12/2025": [
     [155, 16, 178],
     [578, "00", 190],
     [448, 62, 345],
     [280, "04", 257],
     [245, 19, 234],
  ],
  "01/13/2025 to 01/19/2025": [
     [249, 58, 567],
     [355, 32, 570],
     [339, 53, 238],
     [123, 68, 558],
     [480, 27, 160],
  ],
};

export const MAINBAZAR = {
  "01/02/2023 to 01/08/2023": [
     ["144", "93", "238"],
     ["239", "49", "577"],
     ["489", "15", "258"],
     ["457", "62", "345"],
     ["233", "88", "134"],
  ],
  "01/09/2023 to 01/15/2023": [
     ["890", "74", "266"],
     ["139", "31", "146"],
     ["258", "56", "259"],
     ["339", "53", "490"],
     ["490", "31", "380"],
  ],
  "01/16/2023 to 01/22/2023": [
     ["788", "31", "489"],
     ["249", "52", "336"],
     ["688", "24", "590"],
     ["367", "60", "299"],
     ["800", "84", "257"],
  ],
  "01/23/2023 to 01/29/2023": [
     ["245", "18", "800"],
     ["150", "64", "680"],
     ["367", "63", "355"],
     ["139", "31", "146"],
     ["248", "40", "668"],
  ],
  "01/30/2023 to 02/05/2023": [
     ["137", "10", "460"],
     ["348", "53", "300"],
     ["125", "89", "379"],
     ["189", "85", "140"],
     ["113", "52", "237"],
  ],
  "02/06/2023 to 02/12/2023": [
     ["377", "76", "367"],
     ["780", "53", "238"],
     ["270", "92", "237"],
     ["257", "48", "990"],
     ["470", "19", "478"],
  ],
  "02/13/2023 to 02/19/2023": [
     ["245", "19", "379"],
     ["490", "36", "448"],
     ["234", "97", "359"],
     ["560", "12", "345"],
     ["229", "36", "466"],
  ],
  "02/20/2023 to 02/26/2023": [
     ["456", "57", "160"],
     ["449", "79", "126"],
     ["890", "76", "790"],
     ["126", "96", "240"],
     ["248", "44", "248"],
  ],
  "02/27/2023 to 03/05/2023": [
     ["278", "75", "780"],
     ["134", "84", "248"],
     ["590", "45", "267"],
     ["170", "88", "170"],
     ["680", "43", "346"],
  ],
  "03/06/2023 to 03/12/2023": [
     ["247", "32", "390"],
     ["189", "88", "233"],
     ["139", "31", "146"],
     ["140", "51", "579"],
     ["268", "65", "339"],
  ],
  "03/13/2023 to 03/19/2023": [
     ["369", "89", "225"],
     ["234", "92", "679"],
     ["249", "58", "134"],
     ["168", "57", "359"],
     ["399", "13", "337"],
  ],
  "03/20/2023 to 03/26/2023": [
     ["157", "32", "110"],
     ["179", "71", "236"],
     ["134", "88", "125"],
     ["458", "76", "457"],
     ["369", "81", "128"],
  ],
  "03/27/2023 to 04/02/2023": [
     ["680", "44", "699"],
     ["458", "71", "678"],
     ["114", "60", "127"],
     ["289", "93", "355"],
     ["490", "30", "460"],
  ],
  "04/03/2023 to 04/09/2023": [
     ["260", "88", "567"],
     ["377", "72", "390"],
     ["456", "57", "368"],
     ["338", "40", "334"],
     ["144", "90", "668"],
  ],
  "04/10/2023 to 04/16/2023": [
     ["128", "13", "256"],
     ["335", "10", "479"],
     ["289", "95", "230"],
     ["478", "90", "479"],
     ["577", "95", "249"],
  ],
  "04/17/2023 to 04/23/2023": [
     ["255", "28", "350"],
     ["246", "28", "134"],
     ["380", "11", "236"],
     ["799", "56", "880"],
     ["129", "27", "458"],
  ],
  "04/24/2023 to 04/30/2023": [
     ["100", "12", "390"],
     ["160", "72", "336"],
     ["138", "26", "150"],
     ["278", "77", "160"],
     ["469", "93", "300"],
  ],
  "05/01/2023 to 05/07/2023": [
     ["249", "58", "378"],
     ["279", "87", "340"],
     ["570", "24", "130"],
     ["159", "56", "600"],
     ["679", "26", "349"],
  ],
  "05/08/2023 to 05/14/2023": [
     ["178", "64", "699"],
     ["238", "34", "158"],
     ["459", "87", "179"],
     ["336", "24", "455"],
     ["134", "80", "460"],
  ],
  "05/15/2023 to 05/21/2023": [
     ["149", "47", "340"],
     ["236", "15", "230"],
     ["126", "93", "148"],
     ["134", "82", "660"],
     ["178", "64", "239"],
  ],
  "05/22/2023 to 05/28/2023": [
     ["169", "62", "110"],
     ["170", "85", "690"],
     ["166", "37", "124"],
     ["790", "61", "399"],
     ["678", "13", "238"],
  ],
  "05/29/2023 to 06/04/2023": [
     ["270", "95", "780"],
     ["290", "14", "789"],
     ["460", "03", "247"],
     ["180", "98", "116"],
     ["688", "20", "569"],
  ],
  "06/05/2023 to 06/11/2023": [
     ["489", "10", "488"],
     ["278", "77", "467"],
     ["460", "05", "799"],
     ["150", "69", "126"],
     ["114", "63", "120"],
  ],
  "06/12/2023 to 06/18/2023": [
     ["349", "61", "344"],
     ["158", "43", "229"],
     ["389", "05", "168"],
     ["119", "13", "779"],
     ["379", "94", "400"],
  ],
  "06/19/2023 to 06/25/2023": [
     ["580", "35", "348"],
     ["160", "73", "779"],
     ["147", "20", "677"],
     ["578", "07", "890"],
     ["128", "14", "149"],
  ],
  "06/26/2023 to 07/02/2023": [
     ["568", "99", "225"],
     ["345", "26", "358"],
     ["577", "93", "580"],
     ["456", "50", "145"],
     ["289", "99", "180"],
  ],
  "07/03/2023 to 07/09/2023": [
     ["123", "65", "113"],
     ["400", "43", "247"],
     ["789", "42", "138"],
     ["170", "81", "245"],
     ["334", "05", "357"],
  ],
  "07/10/2023 to 07/16/2023": [
     ["456", "52", "129"],
     ["569", "03", "599"],
     ["238", "31", "588"],
     ["699", "48", "800"],
     ["699", "48", "800"],
  ],
  "07/17/2023 to 07/23/2023": [
     ["270", "91", "137"],
     ["155", "11", "470"],
     ["590", "42", "679"],
     ["227", "11", "290"],
     ["259", "69", "469"],
  ],
  "07/24/2023 to 07/30/2023": [
     ["247", "30", "677"],
     ["270", "94", "266"],
     ["246", "24", "239"],
     ["129", "25", "348"],
     ["457", "61", "489"],
  ],
  "07/31/2023 to 08/06/2023": [
     ["289", "94", "239"],
     ["160", "77", "458"],
     ["227", "18", "378"],
     ["233", "88", "224"],
     ["390", "24", "356"],
  ],
  "08/07/2023 to 08/13/2023": [
     ["368", "75", "267"],
     ["126", "92", "147"],
     ["150", "69", "144"],
     ["239", "40", "569"],
     ["126", "92", "390"],
  ],
  "08/14/2023 to 08/20/2023": [
     ["239", "44", "266"],
     ["139", "31", "146"],

     ["259", "61", "128"],
     ["457", "67", "250"],
     ["679", "20", "235"],
  ],
  "08/21/2023 to 08/27/2023": [
     ["390", "22", "390"],
     ["467", "75", "889"],
     ["280", "05", "690"],
     ["180", "94", "158"],
     ["590", "44", "257"],
  ],
  "08/28/2023 to 09/03/2023": [
     ["790", "60", "677"],
     ["237", "22", "129"],
     ["170", "89", "469"],
     ["116", "81", "146"],
     ["400", "47", "250"],
  ],
  "09/04/2023 to 09/10/2023": [
     ["158", "41", "290"],
     ["157", "37", "278"],
     ["155", "14", "356"],
     ["360", "98", "567"],
     ["250", "74", "699"],
  ],
  "09/11/2023 to 09/17/2023": [
     ["336", "26", "169"],
     ["300", "31", "290"],
     ["377", "78", "170"],
     ["339", "59", "559"],
     ["780", "59", "270"],
  ],
  "09/18/2023 to 09/24/2023": [
     ["125", "88", "369"],
     ["469", "97", "160"],
     ["158", "44", "770"],
     ["679", "25", "249"],
     ["366", "51", "245"],
  ],
  "09/25/2023 to 10/01/2023": [
     ["790", "69", "469"],
     ["134", "86", "169"],
     ["457", "68", "233"],
     ["139", "38", "558"],
     ["269", "77", "368"],
  ],
  "10/02/2023 to 10/08/2023": [
     ["279", "83", "580"],
     ["369", "83", "337"],
     ["346", "35", "140"],
     ["570", "21", "290"],
     ["480", "26", "259"],
  ],
  "10/09/2023 to 10/15/2023": [
     ["369", "80", "668"],
     ["123", "61", "380"],
     ["580", "39", "144"],
     ["249", "56", "178"],
     ["300", "30", "488"],
  ],
  "10/16/2023 to 10/22/2023": [
     ["660", "25", "456"],
     ["390", "24", "590"],
     ["770", "40", "578"],
     ["345", "25", "159"],
     ["145", "04", "789"],
  ],
  "10/23/2023 to 10/29/2023": [
     ["699", "47", "160"],
     ["158", "40", "145"],
     ["246", "24", "130"],
     ["247", "35", "159"],
     ["279", "84", "266"],
  ],
  "10/30/2023 to 11/05/2023": [
     ["348", "50", "578"],
     ["889", "55", "889"],
     ["558", "87", "179"],
     ["445", "30", "136"],
     ["138", "28", "279"],
  ],
  "11/06/2023 to 11/12/2023": [
     ["246", "29", "199"],
     ["240", "67", "115"],
     ["139", "31", "146"],
     ["158", "41", "137"],
     ["256", "30", "460"],
  ],
  "11/13/2023 to 11/19/2023": [
     ["290", "15", "339"],
     ["139", "31", "146"],
     ["158", "40", "145"],
     ["558", "87", "179"],
     ["122", "59", "180"],
  ],
  "11/20/2023 to 11/26/2023": [
     ["122", "59", "180"],
     ["238", "34", "257"],
     ["179", "72", "156"],
     ["290", "15", "339"],
     ["116", "83", "337"],
  ],
  "11/27/2023 to 12/03/2023": [
     ["690", "55", "357"],
     ["169", "66", "268"],
     ["259", "69", "180"],
     ["478", "91", "227"],
     ["180", "97", "188"],
  ],
  "12/04/2023 to 12/10/2023": [
     ["345", "27", "269"],
     ["477", "89", "559"],
     ["480", "28", "350"],
     ["390", "26", "178"],
     ["146", "10", "578"],
  ],
  "12/11/2023 to 12/17/2023": [
     ["457", "62", "688"],
     ["334", "09", "900"],
     ["268", "66", "358"],
     ["155", "14", "149"],
     ["479", "03", "346"],
  ],
  "12/18/2023 to 12/24/2023": [
     ["340", "71", "489"],
     ["358", "66", "880"],
     ["357", "51", "678"],
     ["670", "34", "220"],
     ["246", "29", "577"],
  ],
  "12/25/2023 to 12/31/2023": [
     ["157", "39", "234"],
     ["220", "48", "459"],
     ["489", "19", "234"],
     ["270", "91", "236"],
     ["166", "34", "112"],
  ],
  "01/01/2024 to 01/07/2024": [
     ["170", "81", "137"],
     ["279", "85", "159"],
     ["237", "25", "159"],
     ["440", "82", "688"],
     ["670", "34", "338"],
  ],
  "01/08/2024 to 01/14/2024": [
     ["279", "85", "500"],
     ["390", "21", "560"],
     ["235", "02", "237"],
     ["667", "90", "460"],
     ["345", "23", "238"],
  ],
  "01/15/2024 to 01/21/2024": [
     ["789", "45", "267"],
     ["245", "11", "470"],
     ["124", "78", "170"],
     ["570", "25", "555"],
     ["133", "74", "167"],
  ],
  "01/22/2024 to 01/28/2024": [
     ["990", "89", "469"],
     ["290", "15", "339"],
     ["338", "47", "368"],
     ["118", "04", "446"],
     ["236", "16", "358"],
  ],
  "01/29/2024 to 02/04/2024": [
     ["249", "58", "233"],
     ["223", "70", "280"],
     ["357", "55", "159"],
     ["125", "87", "359"],
     ["160", "72", "129"],
  ],
  "02/05/2024 to 02/11/2024": [
     ["589", "28", "477"],
     ["469", "99", "469"],
     ["467", "72", "570"],
     ["460", "01", "380"],
     ["123", "65", "357"],
  ],
  "02/12/2024 to 02/18/2024": [
     ["668", "04", "338"],
     ["890", "77", "133"],
     ["348", "55", "140"],
     ["456", "52", "336"],
     ["124", "77", "223"],
  ],
  "02/19/2024 to 02/25/2024": [
     ["160", "70", "145"],
     ["126", "96", "150"],
     ["267", "54", "400"],
     ["180", "94", "167"],
     ["489", "14", "356"],
  ],
  "02/26/2024 to 03/03/2024": [
     ["249", "50", "190"],
     ["460", "04", "257"],
     ["259", "68", "288"],
     ["550", "03", "670"],
     ["456", "55", "168"],
  ],
  "03/04/2024 to 03/10/2024": [
     ["355", "31", "399"],
     ["459", "88", "279"],
     ["237", "20", "280"],
     ["290", "11", "344"],
     ["800", "82", "246"],
  ],
  "03/11/2024 to 03/17/2024": [
     ["588", "15", "230"],
     ["245", "15", "690"],
     ["700", "71", "669"],
     ["135", "90", "389"],
     ["680", "41", "335"],
  ],
  "03/18/2024 to 03/24/2024": [
     ["144", "98", "288"],
     ["356", "42", "228"],
     ["457", "63", "599"],
     ["269", "71", "470"],
     ["578", "02", "156"],
  ],
  "03/25/2024 to 03/31/2024": [
     ["470", "12", "589"],
     ["890", "71", "560"],
     ["290", "15", "339"],
     ["369", "84", "770"],
     ["460", "08", "378"],
  ],
  "04/01/2024 to 04/07/2024": [
     ["123", "67", "377"],
     ["889", "54", "680"],
     ["124", "71", "560"],
     ["190", "03", "256"],
     ["147", "22", "688"],
  ],
  "04/08/2024 to 04/14/2024": [
     ["169", "61", "489"],
     ["144", "97", "340"],
     ["355", "38", "189"],
     ["578", "01", "489"],
     ["250", "79", "289"],
  ],
  "04/15/2024 to 04/21/2024": [
     ["790", "63", "670"],
     ["559", "90", "136"],
     ["116", "85", "249"],
     ["240", "64", "590"],
     ["799", "58", "189"],
  ],
  "04/22/2024 to 04/28/2024": [
     ["267", "55", "456"],
     ["347", "44", "257"],
     ["489", "11", "470"],
     ["233", "87", "160"],
     ["344", "14", "257"],
  ],
  "04/29/2024 to 05/05/2024": [
     ["245", "11", "236"],
     ["358", "66", "178"],
     ["356", "40", "569"],
     ["347", "44", "130"],
     ["167", "40", "488"],
  ],
  "05/06/2024 to 05/12/2024": [
     ["349", "67", "269"],
     ["688", "20", "280"],
     ["670", "32", "200"],
     ["189", "86", "268"],
     ["358", "67", "359"],
  ],
  "05/13/2024 to 05/19/2024": [
     ["136", "03", "148"],
     ["117", "98", "260"],
     ["125", "80", "127"],
     ["345", "20", "127"],
     ["138", "29", "469"],
  ],
  "05/20/2024 to 05/26/2024": [
     ["159", "54", "789"],
     ["189", "81", "236"],
     ["145", "04", "680"],
     ["270", "97", "368"],
     ["347", "46", "330"],
  ],
  "05/27/2024 to 06/02/2024": [
     ["490", "39", "559"],
     ["346", "36", "240"],
     ["447", "58", "233"],
     ["139", "32", "156"],
     ["359", "74", "789"],
  ],
  "06/03/2024 to 06/09/2024": [
     ["335", "19", "234"],
     ["466", "67", "458"],
     ["277", "68", "224"],
     ["238", "32", "200"],
     ["330", "65", "348"],
  ],
  "06/24/2024 to 06/30/2024": [
     ["590", "48", "369"],
     ["270", "93", "445"],
     ["780", "52", "589"],
     ["144", "97", "458"],
     ["144", "97", "700"],
  ],
  "07/01/2024 to 07/07/2024": [
     ["148", "32", "200"],
     ["159", "50", "578"],
     ["356", "47", "179"],
     ["369", "89", "568"],
     ["245", "12", "138"],
  ],
  "07/08/2024 to 07/14/2024": [
     ["389", "09", "469"],
     ["169", "66", "150"],
     ["228", "25", "366"],
     ["579", "13", "490"],
     ["279", "81", "146"],
  ],
  "07/15/2024 to 07/21/2024": [
     ["459", "82", "156"],
     ["150", "67", "179"],
     ["360", "95", "267"],
     ["169", "68", "170"],
     ["789", "44", "248"],
  ],
  "07/22/2024 to 07/28/2024": [
     ["770", "40", "136"],
     ["356", "45", "267"],
     ["130", "40", "370"],
     ["125", "82", "778"],
     ["588", "13", "148"],
  ],
};

export const MAYAMORNING = {
  "01/01/2024 to 01/07/2024": [
     [245, 16, 169],
     [480, 27, 124],
     [677, "09", 577],
     [120, 36, 448],
     [180, 92, 345],
     [125, 87, 188],
     [338, 41, 236],
  ],
  "01/08/2024 to 01/14/2024": [
     [368, 74, 167],
     [559, 98, 260],
     [880, 69, 225],
     [489, 12, 200],
     [290, 17, 188],
     [249, 51, 128],
     [460, "03", 256],
  ],
  "01/15/2024 to 01/21/2024": [
     [369, 88, 378],
     [679, 24, 149],
     [345, 28, 233],
     [380, 13, 689],
     [248, 44, 356],
     [127, "05", 140],
     [568, 90, 578],
  ],
  "01/22/2024 to 01/28/2024": [
     [579, 13, 670],
     [470, 11, 344],
     [268, 65, 456],
     [147, 20, 145],
     [679, 24, 149],
     [489, 12, 200],
     [170, 88, 459],
  ],
  "01/29/2024 to 02/04/2024": [
     [115, 72, 129],
     [479, "05", 159],
     [189, 84, 220],
     [123, 62, 390],
     [190, "05", 447],
     [670, 32, 138],
     [347, 45, 690],
  ],
  "02/05/2024 to 02/11/2024": [
     [156, 24, 789],
     [267, 59, 360],
     [249, 54, 356],
     [156, 26, 457],
     [146, 12, 237],
     [288, 80, 668],
     [349, 63, 157],
  ],
  "02/12/2024 to 02/18/2024": [
     [139, 35, 230],
     [257, 49, 289],
     [778, 29, 135],
     [288, 85, 780],
     [389, "08", 134],
     [125, 86, 600],
     [148, 38, 279],
  ],
  "02/19/2024 to 02/25/2024": [
     [137, 19, 478],
     [466, 67, 278],
     [457, 65, 177],
     [348, 52, 679],
     [467, 72, 147],
     [235, "07", 368],
     [577, 94, 167],
  ],
  "02/26/2024 to 03/03/2024": [
     [359, 71, 146],
     [590, 49, 379],
     [358, 68, 468],
     [357, 55, 780],
     [579, 11, 245],
     [570, 20, 460],
     [225, 90, 389],
  ],
  "03/04/2024 to 03/10/2024": [
     [778, 28, 369],
     [350, 89, 180],
     [390, 20, 479],
     [156, 28, 279],
     [158, 46, 790],
     ["259", "63", "256"],
     [278, 76, 169],
  ],
  "03/11/2024 to 03/17/2024": [
     [178, 66, 268],
     [350, 89, 180],
     [145, 0, 280],
     [337, 39, 234],
     [235, "05", 168],
     [459, 87, 269],
     [345, 28, 125],
  ],
  "03/18/2024 to 03/24/2024": [
     [456, 52, 237],
     [789, 48, 567],
     [370, 0, 370],
     [158, 46, 790],
     [347, 40, 226],
     [470, 18, 279],
     [138, 23, 580],
  ],
  "03/25/2024 to 03/31/2024": [
     [370, "03", 247],
     [160, 79, 289],
     [589, 27, 359],
     [137, 13, 247],
     [489, 15, 348],
     [260, 89, 270],
     [158, 42, 147],
  ],
  "04/01/2024 to 04/07/2024": [
     [478, 91, 155],
     [589, 25, 267],
     [156, 28, 279],
     [790, 60, 127],
     [456, 55, 249],
     [130, 43, 148],
     ["148", "30", "127"],
  ],
  "04/08/2024 to 04/14/2024": [
     [699, 41, 399],
     [388, 91, 236],
     [256, 33, 120],
     [117, 98, 369],

     [144, 96, 259],
     [123, 66, 240],
     ["259", "93", "256"],
  ],
  "04/15/2024 to 04/21/2024": [
     [450, 98, 350],
     [568, 90, 136],
     [258, 53, 139],
     [457, 66, 358],
     [235, "08", 288],
     [390, 29, 568],
     ["450", "96", "358"],
  ],
  "04/22/2024 to 04/28/2024": [
     [278, 73, 148],
     [559, 91, 137],
     [169, 68, 189],
     [389, "01", 470],
     [160, 71, 146],
     [378, 87, 133],
     ["559", "91", "470"],
  ],
  "04/29/2024 to 05/05/2024": [
     [347, 46, 448],
     [380, 11, 560],
     [377, 72, 480],
     [147, 27, 133],
     [336, 26, 556],
     [130, 42, 480],
     ["377", "74", "130"],
  ],
  "05/06/2024 to 05/12/2024": [
     [117, 98, 369],
     [668, "06", 790],
     [246, 24, 158],
     [170, 83, 580],
     [267, 57, 115],
     [468, 87, 890],
     ["668", "07", "115"],
  ],
  "05/13/2024 to 05/19/2024": [
     [369, 84, 239],
     [780, 50, 370],
     [117, 98, 369],
     [789, 46, 259],
     [780, 53, 256],
     [126, 97, 160],
     ["468", "88", "369"],
  ],
  "05/20/2024 to 05/26/2024": [
     [336, 20, 370],
     [134, 80, 136],
     [668, "09", 289],
     [448, 65, 122],
     [590, 48, 279],
     [669, 10, 118],
     [246, 24, 158],
  ],
  "05/27/2024 to 06/02/2024": [
     [117, 98, 369],
     [668, "06", 790],
     [246, 24, 158],
     [170, 83, 580],
     [267, 57, 115],
     [468, 87, 890],
     [448, 65, 122],
  ],
  "06/03/2024 to 06/09/2024": [
     [369, 84, 239],
     [780, 50, 370],
     [668, "09", 289],
     [789, 46, 259],
     [780, 53, 256],
     [126, 97, 160],
     [668, "09", 289],
  ],
  "06/10/2024 to 06/16/2024": [
     [336, 20, 370],
     [134, 80, 136],
     [668, "09", 289],
     [448, 65, 122],
     [590, 48, 279],
     [669, 10, 118],
     [170, 83, 580],
  ],

  "06/17/2024 to 06/23/2024": [
     ["200", "22", "345"],
     ["250", "76", "178"],
     ["144", "94", "356"],
     ["122", "57", "278"],
     ["238", "34", "248"],
     ["128", "12", "156"],
     ["134", "80", "136"],
  ],
  "06/24/2024 to 06/30/2024": [
     ["180", "90", "280"],
     ["239", "45", "258"],
     ["188", "72", "345"],
     ["268", "68", "279"],
     ["247", "33", "256"],
     ["290", "18", "990"],
     ["150", "66", "330"],
  ],
  "07/01/2024 to 07/07/2024": [
     ["167", "44", "699"],
     ["189", "85", "159"],
     ["146", "13", "148"],
     ["900", "90", "127"],
     ["560", "40", "320"],
     ["167", "55", "889"],
     ["448", "65", "122"],
  ],
  "07/08/2024 to 07/14/2024": [
     ["129", "22", "778"],
     ["123", "67", "179"],
     ["680", "48", "567"],
     ["160", "77", "449"],
     ["247", "23", "355"],
     ["355", "39", "289"],
     ["577", "90", "280"],
  ],
  "07/15/2024 to 07/21/2024": [
     ["990", "88", "288"],
     ["146", "12", "255"],
     ["115", "77", "250"],
     ["120", "33", "300"],
     ["448", "64", "220"],
     ["360", "90", "000"],
     ["140", "53", "670"],
  ],
  "07/22/2024 to 07/28/2024": [
     ["459", "88", "369"],
     ["136", "06", "268"],
     ["236", "11", "678"],
     ["789", "41", "236"],
     ["450", "90", "190"],
     ["780", "55", "159"],
     ["126", "90", "244"],
  ],
  "07/29/2024 to 08/04/2024": [
     ["169", "66", "899"],
     ["356", "47", "124"],
     ["469", "93", "355"],
     ["137", "15", "500"],
     ["120", "34", "158"],
     ["122", "58", "558"],
     ["000", "06", "114"],
  ],
  "08/05/2024 to 08/11/2024": [
     ["778", "25", "177"],
     ["270", "93", "166"],
     ["689", "39", "126"],
     ["299", "03", "337"],
     ["145", "02", "679"],
     ["190", "09", "379"],
     ["155", "14", "220"],
  ],
  "08/12/2024 to 08/18/2024": [
     ["258", "89", "370"],
     ["456", "64", "245"],
     ["170", "30", "389"],
     ["289", "75", "472"],
     ["304", "52", "278"],
     ["496", "11", "355"],
     [457, 64, 287],
  ],
  "08/19/2024 to 08/25/2024": [
     ["239", "90", "377"],
     ["478", "35", "256"],
     ["192", "83", "460"],
     ["357", "14", "328"],
     ["496", "22", "178"],
     ["278", "99", "462"],
     ["148", "33", "445"],
  ],
  "08/26/2024 to 09/01/2024": [
     ["356", "67", "220"],
     ["299", "88", "431"],
     ["175", "43", "379"],
     ["489", "56", "293"],
     ["214", "90", "457"],
     ["388", "27", "345"],
     ["240", "64", "139"],
  ],
  "09/02/2024 to 09/08/2024": [
     ["312", "64", "287"],
     ["489", "23", "358"],
     ["157", "82", "274"],
     ["236", "47", "190"],
     ["413", "55", "369"],
     ["278", "68", "305"],
     ["169", "67", "269"],
  ],
};

export const INDRAMORNING = {
  "01/01/2024 to 01/07/2024": [
     ["880", "66", "600"],
     ["467", "77", "179"],
     ["888", "42", "246"],
     ["226", "09", "568"],
     ["177", "53", "120"],
     ["577", "96", "466"],
     ["111", "39", "333"],
  ],
  "01/08/2024 to 01/14/2024": [
     ["110", "23", "337"],
     ["240", "66", "169"],
     ["479", "03", "355"],
     ["689", "30", "677"],
     ["249", "50", "488"],
     ["160", "71", "489"],
     ["140", "54", "158"],
  ],
  "01/15/2024 to 01/21/2024": [
     ["236", "14", "158"],
     ["880", "60", "550"],
     ["349", "61", "100"],
     ["358", "60", "226"],
     ["590", "41", "678"],
     ["349", "68", "990"],
     ["136", "03", "337"],
  ],
  "01/22/2024 to 01/28/2024": [
     ["338", "49", "180"],
     ["589", "27", "250"],
     ["488", "05", "230"],
     ["290", "17", "188"],
     ["355", "32", "156"],
     ["112", "42", "228"],
     ["777", "14", "220"],
  ],
  "01/29/2024 to 02/04/2024": [
     ["112", "41", "100"],
     ["138", "29", "117"],
     ["579", "10", "370"],
     ["347", "45", "168"],
     ["267", "54", "338"],
     ["138", "22", "390"],
     ["259", "64", "455"],
  ],
  "02/05/2024 to 02/11/2024": [
     ["445", "33", "139"],
     ["136", "00", "550"],
     ["258", "59", "289"],
     ["158", "41", "560"],
     ["456", "58", "224"],
     ["777", "15", "249"],
     ["468", "80", "226"],
  ],
  "02/12/2024 to 02/18/2024": [
     ["236", "15", "357"],
     ["446", "47", "124"],
     ["337", "31", "146"],
     ["990", "83", "689"],
     ["357", "51", "236"],
     ["199", "92", "570"],
     ["146", "15", "780"],
  ],
  "02/19/2024 to 02/25/2024": [
     ["900", "92", "336"],
     ["139", "31", "128"],
     ["680", "42", "110"],
     ["256", "32", "345"],
     ["149", "42", "660"],
     ["119", "10", "145"],
     ["577", "95", "113"],
  ],
  "02/26/2024 to 03/03/2024": [
     ["489", "13", "346"],
     ["125", "80", "488"],
     ["139", "35", "140"],
     ["456", "55", "348"],
     ["669", "19", "379"],
     ["489", "10", "389"],
     ["390", "23", "599"],
  ],
  "03/04/2024 to 03/10/2024": [
     ["127", "04", "149"],
     ["468", "89", "577"],
     ["356", "49", "360"],
     ["370", "02", "336"],
     ["459", "83", "670"],
     ["660", "21", "245"],
     ["356", "43", "337"],
  ],
  "03/11/2024 to 03/17/2024": [
     ["550", "01", "489"],
     ["244", "08", "558"],
     ["455", "49", "289"],
     ["299", "05", "357"],
     ["246", "22", "499"],
     ["189", "88", "170"],
     ["339", "52", "589"],
  ],
  "03/18/2024 to 03/24/2024": [
     ["456", "52", "345"],
     ["128", "11", "470"],
     ["268", "65", "366"],
     ["467", "78", "279"],
     ["120", "30", "550"],
     ["223", "70", "488"],
     ["236", "14", "167"],
  ],
  "03/25/2024 to 03/31/2024": [
     ["117", "90", "226"],
     ["470", "18", "990"],
     ["117", "90", "000"],
     ["337", "39", "135"],
     ["346", "31", "579"],
     ["500", "55", "168"],
     ["457", "66", "150"],
  ],
  "04/01/2024 to 04/07/2024": [
     ["556", "67", "250"],
     ["300", "31", "380"],
     ["289", "90", "118"],
     ["180", "94", "680"],
     ["368", "79", "450"],
     ["356", "46", "259"],
     ["440", "82", "345"],
  ],
  "04/08/2024 to 04/14/2024": [
     ["150", "64", "347"],
     ["560", "12", "110"],
     ["358", "69", "135"],
     ["348", "53", "157"],
     ["145", "03", "247"],
     ["340", "78", "189"],
     ["338", "42", "129"],
  ],
  "04/15/2024 to 04/21/2024": [
     ["679", "27", "890"],
     ["260", "83", "139"],
     ["179", "70", "190"],
     ["569", "05", "339"],
     ["126", "98", "170"],
     ["233", "82", "255"],
     ["667", "99", "478"],
  ],
  "04/22/2024 to 04/28/2024": [
     ["990", "80", "460"],
     ["300", "32", "589"],
     ["469", "96", "448"],
     ["459", "86", "277"],
     ["349", "67", "223"],
     ["566", "77", "458"],
     ["220", "47", "368"],
  ],
  "04/29/2024 to 05/05/2024": [
     ["223", "79", "117"],
     ["370", "09", "568"],
     ["228", "29", "900"],
     ["359", "74", "130"],
     ["148", "39", "234"],
     ["348", "56", "150"],
     ["270", "95", "140"],
  ],
  "05/06/2024 to 05/12/2024": [
     ["239", "45", "456"],
     ["378", "84", "356"],
     ["127", "08", "459"],
     ["168", "55", "690"],
     ["269", "75", "258"],
     ["360", "94", "789"],
     ["590", "40", "145"],
  ],
  "05/13/2024 to 05/19/2024": [
     ["156", "23", "120"],
     ["136", "07", "890"],
     ["345", "24", "257"],
     ["455", "48", "459"],
     ["159", "51", "489"],
     ["117", "99", "126"],
     ["600", "63", "355"],
  ],
  "05/20/2024 to 05/26/2024": [
     ["579", "19", "225"],
     ["448", "68", "567"],
     ["570", "22", "679"],
     ["127", "01", "560"],
     ["667", "96", "899"],
     ["399", "17", "124"],
     ["668", "08", "440"],
  ],

  "05/27/2024 to 06/02/2024": [
     ["880", "61", "380"],
     ["470", "10", "226"],
     ["134", "83", "346"],
     ["360", "91", "137"],
     ["238", "35", "456"],
     ["467", "79", "379"],
     ["390", "27", "278"],
  ],
  "06/03/2024 to 06/09/2024": [
     ["170", "88", "224"],
     ["466", "67", "890"],
     ["340", "77", "124"],
     ["156", "22", "679"],
     ["125", "82", "228"],
     ["157", "30", "136"],
     ["560", "18", "369"],
  ],
  "06/10/2024 to 06/16/2024": [
     ["780", "58", "170"],
     ["138", "25", "168"],
     ["459", "82", "246"],
     ["340", "75", "690"],
     ["479", "08", "233"],
     ["457", "62", "156"],
     ["200", "20", "127"],
  ],
  "06/17/2024 to 06/23/2024": [
     ["260", "80", "145"],
     ["259", "64", "248"],
     ["245", "15", "889"],
     ["234", "97", "377"],
     ["169", "65", "348"],
     ["369", "87", "160"],
     ["379", "96", "330"],
  ],
  "06/24/2024 to 06/30/2024": [
     ["457", "61", "128"],
     ["379", "99", "289"],
     ["245", "15", "889"],
     ["256", "39", "270"],
     ["477", "81", "119"],
     ["679", "25", "168"],
     ["179", "77", "340"],
  ],
  "07/01/2024 to 07/07/2024": [
     ["177", "58", "459"],
     ["680", "49", "360"],
     ["579", "17", "124"],
     ["990", "80", "569"],
     ["289", "93", "247"],
     ["300", "30", "460"],
     ["129", "22", "228"],
  ],
  "07/08/2024 to 07/14/2024": [
     ["180", "99", "126"],
     ["589", "21", "344"],
     ["358", "67", "115"],
     ["244", "07", "278"],
     ["113", "51", "470"],
     ["340", "74", "149"],
     ["146", "13", "247"],
  ],
  "07/15/2024 to 07/21/2024": [
     ["440", "89", "900"],
     ["113", "55", "249"],
     ["689", "31", "137"],
     ["559", "97", "890"],
     ["279", "88", "350"],
     ["490", "30", "389"],
     ["135", "96", "899"],
  ],
  "07/22/2024 to 07/28/2024": [
     ["557", "73", "148"],
     ["478", "93", "346"],
     ["259", "67", "133"],
     ["799", "50", "460"],
     ["678", "15", "357"],
     ["247", "32", "138"],
     ["560", "19", "388"],
  ],
  "07/29/2024 to 08/04/2024": [
     ["258", "51", "669"],
     ["490", "34", "789"],
     ["568", "99", "126"],
     ["670", "35", "348"],
     ["566", "70", "479"],
     ["129", "28", "260"],
     ["347", "44", "158"],
  ],
  "08/05/2024 to 08/11/2024": [
     ["570", "27", "467"],
     ["190", "05", "339"],
     ["266", "45", "122"],
     ["568", "99", "126"],
     ["170", "84", "699"],
     ["377", "75", "447"],
     ["470", "17", "133"],
  ],
  "08/12/2024 to 08/18/2024": [
     ["150", "67", "557"],
     ["568", "96", "178"],
     ["680", "40", "145"],
     ["489", "13", "670"],
     ["358", "60", "235"],
     ["290", "11", "579"],
     ["346", "34", "130"],
  ],
  "08/19/2024 to 08/25/2024": [
     ["148", "30", "127"],
     ["570", "23", "256"],
     ["679", "21", "470"],
     ["125", "88", "378"],
     ["789", "41", "380"],
     ["458", "78", "134"],
     ["238", "37", "890"],
  ],
  "08/26/2024 to 09/01/2024": [
     ["130", "49", "270"],
     ["399", "10", "578"],
     ["589", "21", "146"],
     ["460", "02", "688"],
     ["566", "70", "280"],
     ["245", "16", "358"],
     ["679", "25", "140"],
  ],
  "09/02/2024 to 09/08/2024": [
     ["457", "66", "880"],
     ["239", "41", "344"],
     ["478", "99", "180"],
     ["579", "15", "366"],
     ["267", "59", "568"],
     ["170", "89", "900"],
     ["138", "20", "370"],
  ],
  "09/09/2024 to 09/15/2024": [
     ["499", "24", "158"],
     ["260", "80", "569"],
     ["440", "86", "358"],
     ["188", "71", "236"],
     ["799", "54", "347"],
     ["259", "66", "150"],
     ["137", "17", "458"],
  ],
};
export const INDRADAY = {
  "01/01/2024 to 07/01/2024": [
     ["278", "73", "139"],
     ["150", "61", "290"],
     ["235", "04", "220"],
     ["448", "69", "559"],
     ["278", "76", "367"],
     ["280", "04", "266"],
     ["288", "85", "122"],
  ],
  "08/01/2024 to 14/01/2024": [
     ["160", "77", "179"],
     ["379", "96", "367"],
     ["377", "73", "779"],
     ["680", "42", "589"],
     ["347", "43", "670"],
     ["148", "35", "690"],
     ["379", "96", "466"],
  ],
  "15/01/2024 to 21/01/2024": [
     ["689", "37", "467"],
     ["668", "03", "599"],
     ["299", "01", "678"],
     ["389", "04", "789"],
     ["234", "97", "890"],
     ["577", "95", "168"],
     ["666", "83", "779"],
  ],
  "22/01/2024 to 28/01/2024": [
     ["357", "54", "455"],
     ["339", "58", "378"],
     ["669", "14", "347"],
     ["389", "07", "223"],
     ["690", "51", "669"],
     ["479", "07", "467"],
     ["266", "46", "448"],
  ],
  "29/01/2024 to 04/02/2024": [
     ["679", "24", "789"],
     ["360", "99", "900"],
     ["260", "85", "113"],
     ["279", "82", "228"],
     ["578", "00", "389"],
     ["269", "79", "577"],
     ["288", "86", "899"],
  ],
  "05/02/2024 to 11/02/2024": [
     ["339", "51", "678"],
     ["159", "57", "188"],
     ["268", "62", "589"],
     ["240", "62", "228"],
     ["379", "94", "149"],
     ["690", "58", "233"],
     ["388", "97", "115"],
  ],
  "12/02/2024 to 18/02/2024": [
     ["260", "87", "269"],
     ["668", "00", "578"],
     ["367", "64", "789"],
     ["189", "82", "129"],
     ["240", "67", "179"],
     ["677", "05", "889"],
     ["589", "26", "330"],
  ],
  "19/02/2024 to 25/02/2024": [
     ["578", "06", "358"],
     ["127", "02", "147"],
     ["390", "27", "124"],
     ["126", "96", "790"],
     ["367", "64", "789"],
     ["156", "22", "480"],
     ["446", "40", "334"],
  ],
  "26/02/2024 to 03/03/2024": [
     ["790", "67", "458"],
     ["679", "25", "159"],
     ["137", "19", "135"],
     ["289", "98", "440"],
     ["234", "95", "780"],
     ["234", "95", "780"],
     ["899", "68", "558"],
  ],
  "04/03/2024 to 10/03/2024": [
     ["560", "19", "379"],
     ["167", "46", "790"],
     ["358", "68", "567"],
     ["177", "59", "667"],
     ["116", "87", "467"],
     ["157", "32", "156"],
     ["336", "24", "266"],
  ],
  "11/03/2024 to 17/03/2024": [
     ["157", "34", "167"],
     ["190", "09", "270"],
     ["180", "94", "680"],
     ["257", "46", "358"],
     ["569", "09", "126"],
     ["356", "49", "469"],
     ["257", "47", "359"],
  ],
  "19/03/2024 to 25/03/2024": [
     ["389", "01", "588"],
     ["230", "51", "678"],
     ["149", "47", "359"],
     ["579", "19", "478"],
     ["220", "48", "477"],
     ["357", "57", "890"],
     ["559", "97", "368"],
  ],
  "26/03/2024 to 01/04/2024": [
     ["189", "89", "135"],
     ["123", "64", "158"],
     ["125", "88", "260"],
     ["260", "84", "257"],
     ["570", "29", "478"],
     ["480", "26", "600"],
     ["899", "62", "255"],
  ],
  "02/04/2024 to 08/04/2024": [
     ["159", "54", "167"],
     ["123", "60", "460"],
     ["380", "14", "130"],
     ["234", "94", "770"],
     ["126", "94", "680"],
     ["267", "59", "478"],
     ["189", "87", "467"],
  ],
  "09/04/2024 to 15/04/2024": [
     ["157", "39", "577"],
     ["247", "35", "690"],
     ["113", "57", "278"],
     ["270", "96", "240"],
     ["578", "01", "489"],
     ["579", "14", "112"],
     ["459", "82", "228"],
  ],
  "16/04/2024 to 22/04/2024": [
     ["168", "55", "357"],
     ["770", "45", "456"],
     ["147", "25", "140"],
     ["347", "49", "180"],
     ["456", "58", "468"],
     ["129", "22", "480"],
     ["146", "19", "379"],
  ],
  "23/04/2024 to 29/04/2024": [
     ["235", "01", "678"],
     ["178", "60", "127"],
     ["670", "38", "800"],
     ["235", "04", "239"],
     ["880", "60", "190"],
     ["700", "79", "568"],
     ["278", "72", "390"],
  ],
  "30/04/2024 to 06/05/2024": [
     ["680", "47", "890"],
     ["145", "09", "135"],
     ["280", "08", "369"],
     ["479", "09", "135"],
     ["167", "49", "469"],
     ["334", "06", "268"],
     ["126", "94", "130"],
  ],
  "07/05/2024 to 13/05/2024": [
     ["280", "08", "369"],
     ["369", "81", "560"],
     ["368", "71", "128"],
     ["179", "71", "678"],
     ["245", "18", "567"],
     ["130", "48", "189"],
     ["138", "29", "469"],
  ],
  "14/05/2024 to 20/05/2024": [
     ["459", "86", "150"],
     ["236", "13", "139"],
     ["568", "97", "359"],
     ["678", "17", "458"],
     ["230", "56", "268"],
     ["189", "84", "590"],
     ["579", "16", "169"],
  ],
  "21/05/2024 to 27/05/2024": [
     ["367", "64", "167"],
     ["270", "90", "235"],
     ["139", "35", "230"],
     ["367", "62", "679"],
     ["579", "18", "468"],
     ["268", "63", "346"],
     ["688", "21", "227"],
  ],
  "28/05/2024 to 03/06/2024": [
     ["178", "60", "578"],
     ["350", "82", "246"],
     ["240", "69", "126"],
     ["124", "79", "450"],
     ["578", "01", "137"],
     ["350", "85", "267"],
     ["289", "98", "260"],
  ],
  "04/06/2024 to 10/06/2024": [
     ["244", "05", "780"],
     ["150", "61", "227"],
     ["359", "70", "578"],
     ["269", "70", "370"],
     ["299", "03", "788"],
     ["123", "60", "578"],
     ["257", "45", "177"],
  ],
  "11/06/2024 to 17/06/2024": [
     ["290", "14", "130"],
     ["358", "68", "990"],
     ["389", "00", "569"],
     ["445", "32", "200"],
     ["479", "02", "778"],
     ["190", "06", "448"],
     ["138", "22", "147"],
  ],
  "18/06/2024 to 24/06/2024": [
     ["699", "43", "599"],
     ["689", "36", "259"],
     ["240", "64", "789"],
     ["179", "79", "199"],
     ["160", "79", "568"],
     ["667", "91", "579"],
     ["890", "77", "179"],
  ],
  "25/06/2024 to 01/07/2024": [
     ["140", "58", "125"],
     ["460", "04", "590"],
     ["690", "50", "677"],
     ["134", "86", "349"],
     ["379", "92", "679"],
     ["380", "11", "236"],
     ["670", "30", "299"],
  ],
  "02/07/2024 to 08/07/2024": [
     ["688", "28", "369"],
     ["137", "19", "289"],
     ["168", "53", "229"],
     ["239", "46", "114"],
     ["167", "47", "278"],
     ["188", "76", "367"],
     ["137", "12", "336"],
  ],
  "09/07/2024 to 15/07/2024": [
     ["559", "92", "255"],
     ["457", "63", "157"],
     ["460", "07", "250"],
     ["158", "41", "245"],
     ["249", "57", "250"],
     ["128", "13", "580"],
     ["369", "81", "560"],
  ],
  "16/07/2024 to 22/07/2024": [
     ["269", "79", "379"],
     ["780", "54", "167"],
     ["170", "80", "145"],
     ["489", "13", "689"],
     ["670", "37", "467"],
     ["122", "59", "559"],
     ["136", "08", "279"],
  ],
  "23/07/2024 to 29/07/2024": [
     ["450", "98", "125"],
     ["260", "82", "679"],
     ["880", "64", "257"],
     ["248", "40", "280"],
     ["130", "48", "468"],
     ["267", "58", "378"],
     ["990", "89", "117"],
  ],
  "30/07/2024 to 05/08/2024": [
     ["560", "15", "366"],
     ["339", "51", "227"],
     ["179", "71", "137"],
     ["170", "88", "116"],
     ["258", "59", "577"],
     ["158", "44", "770"],
     ["489", "17", "368"],
  ],
  "06/08/2024 to 12/08/2024": [
     ["288", "84", "239"],
     ["479", "06", "240"],
     ["249", "58", "116"],
     ["179", "75", "168"],
     ["889", "55", "267"],
     ["560", "13", "599"],
     ["480", "26", "259"],
  ],
  "13/08/2024 to 19/08/2024": [
     ["347", "46", "123"],
     ["788", "35", "168"],
     ["569", "05", "348"],
     ["479", "06", "240"],
     ["559", "97", "278"],
     ["156", "21", "128"],
     ["149", "44", "257"],
  ],
  "20/08/2024 to 26/08/2024": [
     ["579", "17", "467"],
     ["688", "22", "345"],
     ["350", "85", "113"],
     ["236", "19", "225"],
     ["124", "72", "129"],
     ["244", "04", "266"],
     ["236", "10", "244"],
  ],
  "27/08/2024 to 02/09/2024": [
     ["123", "65", "258"],
     ["346", "33", "490"],
     ["277", "65", "113"],
     ["770", "41", "146"],
     ["126", "92", "390"],
     ["344", "17", "458"],
     ["569", "09", "568"],
  ],
  "03/09/2024 to 09/09/2024": [
     ["234", "94", "220"],
     ["122", "54", "356"],
     ["126", "98", "350"],
     ["123", "63", "166"],
     ["680", "44", "770"],
     ["134", "89", "117"],
     ["225", "94", "590"],
  ],
  "10/09/2024 to 15/09/2024": [
     ["400", "43", "157"],
     ["240", "62", "778"],
     ["227", "11", "678"],
     ["500", "52", "156"],
     ["136", "02", "345"],
     ["134", "82", "147"],
     ["790", "64", "356"],
  ],
};

export const INDRANIGHT = {
  "01/01/2024 to 07/01/2024": [
     ["100", "16", "448"],
     ["122", "51", "227"],
     ["589", "24", "248"],
     ["115", "71", "579"],
     ["667", "97", "160"],
     ["166", "39", "568"],
     ["246", "23", "337"],
  ],
  "08/01/2024 to 14/01/2024": [
     ["148", "39", "333"],
     ["468", "88", "170"],
     ["800", "82", "444"],
     ["278", "76", "556"],
     ["134", "82", "444"],
     ["133", "78", "440"],
     ["168", "59", "225"],
  ],
  "15/01/2024 to 21/01/2024": [
     ["134", "86", "457"],
     ["559", "95", "122"],
     ["334", "03", "157"],
     ["770", "43", "300"],
     ["267", "55", "357"],
     ["477", "81", "489"],
     ["250", "78", "260"],
  ],
  "22/01/2024 to 28/01/2024": [
     ["600", "65", "348"],
     ["390", "22", "147"],
     ["278", "70", "569"],
     ["257", "45", "177"],
     ["280", "08", "260"],
     ["288", "82", "589"],
     ["269", "71", "588"],
  ],
  "29/01/2024 to 04/02/2024": [
     ["339", "58", "666"],
     ["179", "75", "889"],
     ["660", "23", "490"],
     ["280", "09", "478"],
     ["111", "35", "889"],
     ["578", "07", "340"],
     ["256", "36", "899"],
  ],
  "05/02/2024 to 11/02/2024": [
     ["556", "65", "122"],
     ["259", "68", "666"],
     ["000", "08", "558"],
     ["700", "73", "247"],
     ["499", "28", "279"],
     ["790", "60", "460"],
     ["157", "36", "240"],
  ],
  "12/02/2024 to 18/02/2024": [
     ["990", "83", "445"],
     ["590", "41", "588"],
     ["223", "70", "668"],
     ["470", "16", "790"],
     ["244", "06", "358"],
     ["367", "69", "199"],
     ["599", "32", "660"],
  ],
  "19/02/2024 to 25/02/2024": [
     ["889", "52", "660"],
     ["123", "62", "390"],
     ["888", "49", "333"],
     ["578", "07", "890"],
     ["488", "03", "779"],
     ["880", "67", "368"],
     ["344", "18", "477"],
  ],
  "26/02/2024 to 03/03/2024": [
     ["477", "86", "790"],
     ["158", "48", "350"],
     ["138", "28", "116"],
     ["360", "94", "149"],
     ["290", "12", "499"],
     ["669", "12", "129"],
     ["289", "91", "290"],
  ],
  "04/03/2024 to 10/03/2024": [
     ["116", "86", "259"],
     ["550", "08", "800"],
     ["777", "11", "128"],
     ["119", "11", "669"],
     ["227", "17", "160"],
     ["366", "55", "267"],
     ["157", "37", "458"],
  ],
  "11/03/2024 to 17/03/2024": [
     ["245", "14", "590"],
     ["338", "45", "230"],
     ["666", "87", "278"],
     ["230", "58", "189"],
     ["990", "89", "559"],
     ["180", "98", "224"],
     ["150", "64", "149"],
  ],
  "18/03/2024 to 24/03/2024": [
     ["666", "89", "225"],
     ["167", "45", "339"],
     ["223", "74", "167"],
     ["567", "83", "247"],
     ["168", "50", "569"],
     ["358", "62", "255"],
     ["100", "11", "290"],
  ],
  "25/03/2024 to 31/03/2024": [
     ["350", "87", "359"],
     ["446", "44", "888"],
     ["990", "81", "579"],
     ["680", "43", "256"],
     ["257", "43", "157"],
     ["199", "98", "369"],
     ["339", "56", "222"],
  ],
  "01/04/2024 to 07/04/2024": [
     ["377", "78", "369"],
     ["135", "91", "678"],
     ["579", "19", "333"],
     ["479", "08", "477"],
     ["660", "26", "169"],
     ["115", "73", "139"],
     ["237", "20", "488"],
  ],
  "08/04/2024 to 14/04/2024": [
     ["455", "43", "346"],
     ["200", "20", "460"],
     ["478", "95", "348"],
     ["235", "07", "467"],
     ["389", "01", "380"],
     ["227", "11", "344"],
     ["189", "88", "558"],
  ],
  "15/04/2024 to 21/04/2024": [
     ["112", "49", "469"],
     ["270", "90", "389"],
     ["440", "83", "580"],
     ["579", "16", "899"],
     ["138", "24", "167"],
     ["118", "04", "400"],
     ["256", "30", "460"],
  ],
  "22/04/2024 to 28/04/2024": [
     ["290", "13", "346"],
     ["589", "21", "335"],
     ["788", "39", "577"],
     ["225", "99", "180"],
     ["469", "93", "580"],
     ["366", "52", "228"],
     ["345", "22", "156"],
  ],
  "29/04/2024 to 05/05/2024": [
     ["130", "46", "457"],
     ["178", "60", "479"],
     ["370", "01", "137"],
     ["200", "20", "127"],
     ["359", "74", "149"],
     ["567", "84", "158"],
     ["330", "67", "890"],
  ],
  "06/05/2024 to 12/05/2024": [
     ["299", "04", "257"],
     ["133", "79", "667"],
     ["134", "86", "169"],
     ["590", "41", "470"],
     ["229", "37", "269"],
     ["289", "97", "115"],
     ["136", "00", "578"],
  ],
  "13/05/2024 to 19/05/2024": [
     ["558", "81", "128"],
     ["138", "26", "150"],
     ["250", "73", "166"],
     ["157", "31", "399"],
     ["126", "96", "169"],
     ["167", "43", "238"],
     ["236", "18", "477"],
  ],
  "11/03/2024 to 17/03/2024": [
     ["245", "14", "590"],
     ["338", "45", "230"],
     ["666", "87", "278"],
     ["230", "58", "189"],
     ["990", "89", "559"],
     ["180", "98", "224"],
     ["150", "64", "149"],
  ],
  "18/03/2024 to 24/03/2024": [
     ["666", "89", "225"],
     ["167", "45", "339"],
     ["223", "74", "167"],
     ["567", "83", "247"],
     ["168", "50", "569"],
     ["358", "62", "255"],
     ["100", "11", "290"],
  ],
  "25/03/2024 to 31/03/2024": [
     ["350", "87", "359"],
     ["446", "44", "888"],
     ["990", "81", "579"],
     ["680", "43", "256"],
     ["257", "43", "157"],
     ["199", "98", "369"],
     ["339", "56", "222"],
  ],
  "01/04/2024 to 07/04/2024": [
     ["377", "78", "369"],
     ["135", "91", "678"],
     ["579", "19", "333"],
     ["479", "08", "477"],
     ["660", "26", "169"],
     ["115", "73", "139"],
     ["237", "20", "488"],
  ],
  "08/04/2024 to 14/04/2024": [
     ["455", "43", "346"],
     ["200", "20", "460"],
     ["478", "95", "348"],
     ["235", "07", "467"],
     ["389", "01", "380"],
     ["227", "11", "344"],
     ["189", "88", "558"],
  ],
  "15/04/2024 to 21/04/2024": [
     ["112", "49", "469"],
     ["270", "90", "389"],
     ["440", "83", "580"],
     ["579", "16", "899"],
     ["138", "24", "167"],
     ["118", "04", "400"],
     ["256", "30", "460"],
  ],
  "22/04/2024 to 28/04/2024": [
     ["290", "13", "346"],
     ["589", "21", "335"],
     ["788", "39", "577"],
     ["225", "99", "180"],
     ["469", "93", "580"],
     ["366", "52", "228"],
     ["345", "22", "156"],
  ],
  "29/04/2024 to 05/05/2024": [
     ["130", "46", "457"],
     ["178", "60", "479"],
     ["370", "01", "137"],
     ["200", "20", "127"],
     ["359", "74", "149"],
     ["567", "84", "158"],
     ["330", "67", "890"],
  ],
  "06/05/2024 to 12/05/2024": [
     ["299", "04", "257"],
     ["133", "79", "667"],
     ["134", "86", "169"],
     ["590", "41", "470"],
     ["229", "37", "269"],
     ["289", "97", "115"],
     ["136", "00", "578"],
  ],
  "13/05/2024 to 19/05/2024": [
     ["558", "81", "128"],
     ["138", "26", "150"],
     ["250", "73", "166"],
     ["157", "31", "399"],
     ["126", "96", "169"],
     ["167", "43", "238"],
     ["236", "18", "477"],
  ],
  "20/05/2024 to 26/05/2024": [
     ["399", "17", "467"],
     ["126", "95", "690"],
     ["480", "29", "568"],
     ["120", "34", "266"],
     ["389", "08", "468"],
     ["890", "73", "229"],
     ["567", "87", "359"],
  ],
  "27/05/2024 to 02/06/2024": [
     ["589", "24", "130"],
     ["233", "86", "349"],
     ["490", "31", "119"],
     ["370", "04", "257"],
     ["790", "61", "119"],
     ["339", "52", "156"],
     ["579", "12", "499"],
  ],
  "03/06/2024 to 09/06/2024": [
     ["334", "09", "559"],
     ["140", "51", "380"],
     ["126", "96", "277"],
     ["279", "82", "390"],
     ["550", "03", "157"],
     ["155", "18", "224"],
     ["890", "74", "347"],
  ],
  "10/06/2024 to 16/06/2024": [
     ["470", "17", "377"],
     ["667", "92", "246"],
     ["138", "20", "370"],
     ["880", "66", "178"],
     ["579", "19", "180"],
     ["468", "83", "247"],
     ["670", "30", "127"],
  ],
  "17/06/2024 to 23/06/2024": [
     ["567", "81", "380"],
     ["145", "08", "459"],
     ["689", "39", "234"],
     ["348", "51", "245"],
     ["136", "06", "349"],
     ["167", "46", "259"],
     ["780", "54", "356"],
  ],
  "24/06/2024 to 30/06/2024": [
     ["670", "30", "578"],
     ["147", "26", "240"],
     ["460", "02", "156"],
     ["450", "97", "557"],
     ["377", "71", "236"],
     ["468", "84", "789"],
     ["118", "07", "566"],
  ],
  "01/07/2024 to 07/07/2024": [
     ["360", "98", "189"],
     ["145", "04", "446"],
     ["337", "39", "469"],
     ["680", "42", "138"],
     ["150", "67", "340"],
     ["400", "44", "347"],
     ["270", "91", "236"],
  ],
  "08/07/2024 to 14/07/2024": [
    ["790", "63", "157"],
    ["256", "32", "589"],
    ["239", "48", "170"],
    ["780", "50", "479"],
    ["180", "93", "346"],
    ["370", "07", "467"],
    ["190", "03", "779"],
  ],
  "15/07/2024 to 21/07/2024": [
    ["179", "71", "678"],
    ["234", "98", "459"],
    ["149", "42", "660"],
    ["468", "81", "155"],
    ["178", "63", "689"],
    ["168", "57", "250"],
    ["289", "91", "380"],
  ],
  "22/07/2024 to 28/07/2024": [
    ["459", "88", "369"],
    ["136", "06", "268"],
    ["236", "11", "678"],
    ["789", "41", "236"],
    ["450", "90", "190"],
    ["780", "55", "159"],
    ["337", "39", "469"],
  ],
  "29/07/2024 to 04/08/2024": [
    ["567", "81", "380"],
    ["145", "08", "459"],
    ["689", "39", "234"],
    ["348", "51", "245"],
    ["136", "06", "349"],
    ["167", "46", "259"],
    ["780", "54", "356"],
  ],
  "05/08/2024 to 11/08/2024": [
    ["778", "25", "177"],
    ["270", "93", "166"],
    ["689", "39", "126"],
    ["299", "03", "337"],
    ["145", "02", "679"],
    ["190", "09", "379"],
    ["167", "46", "259"],
  ],
  "12/08/2024 to 18/08/2024": [
    ["247", "32", "778"],
    ["126", "99", "289"],
    ["128", "16", "268"],
    ["246", "25", "168"],
    ["119", "10", "136"],
    ["170", "77", "700"],
    ["134", "83", "580"],
  ],
  "19/08/2024 to 25/08/2024": [
    ["236", "14", "130"],
    ["337", "31", "489"],
    ["170", "88", "189"],
    ["167", "43", "247"],
    ["255", "29", "225"],
    ["678", "12", "390"],
    ["357", "56", "114"],
  ],
  "26/08/2024 to 01/09/2024": [
    ["179", "70", "000"],
    ["489", "19", "469"],
    ["580", "32", "444"],
    ["170", "84", "220"],
    ["266", "49", "289"],
    ["469", "93", "300"],
    ["588", "10", "280"],
  ],
  "02/09/2024 to 08/09/2024": [
    ["227", "13", "599"],
    ["456", "58", "288"],
    ["337", "30", "479"],
    ["356", "45", "690"],
    ["199", "90", "460"],
    ["119", "18", "800"],
    ["255", "24", "770"],
  ],
  "09/09/2024 to 15/09/2024": [
    ["600", "62", "147"],
    ["112", "40", "145"],
    ["288", "88", "800"],
    ["489", "15", "366"],
    ["457", "67", "377"],
    ["246", "21", "227"],
    ["467", "73", "166"],
  ],
};

export const MAYADAY = {
  "01/01/2024 to 01/07/2024": [
    ["379", "93", "670"],
    ["357", "50", "370"],
    ["336", "27", "124"],
    ["150", "65", "249"],
    ["780", "53", "670"],
    ["259", "62", "345"],
    ["780", "54", "455"],
  ],
  "01/08/2024 to 01/14/2024": [
    ["690", "51", "344"],
    ["300", "39", "469"],
    ["390", "26", "169"],
    ["489", "10", "569"],
    ["360", "91", "380"],
    ["115", "72", "778"],
    ["880", "67", "269"],
  ],
  "01/15/2024 to 01/21/2024": [
    ["140", "54", "789"],
    ["138", "28", "288"],
    ["250", "79", "568"],
    ["200", "29", "568"],
    ["339", "51", "678"],
    ["159", "57", "188"],
    ["268", "62", "589"],
  ],
  "01/22/2024 to 01/28/2024": [
    ["458", "77", "890"],
    ["224", "81", "128"],
    ["356", "48", "189"],
    ["199", "93", "166"],
    ["260", "87", "269"],
    ["668", "00", "578"],
    ["367", "64", "789"],
  ],
  "01/29/2024 to 02/04/2024": [
    ["470", "14", "248"],
    ["689", "30", "479"],
    ["234", "94", "680"],
    ["146", "14", "248"],
    ["189", "85", "159"],
    ["379", "95", "690"],
    ["360", "90", "677"],
  ],
  "02/05/2024 to 02/11/2024": [
    ["177", "50", "136"],
    ["440", "87", "467"],
    ["778", "23", "599"],
    ["244", "04", "167"],
    ["135", "95", "113"],
    ["479", "06", "466"],
    ["234", "93", "256"],
  ],
  "02/12/2024 to 02/18/2024": [
    ["280", "06", "330"],
    ["123", "68", "350"],
    ["122", "50", "136"],
    ["789", "42", "237"],
    ["367", "62", "345"],
    ["669", "16", "358"],
    ["226", "03", "490"],
  ],
  "02/19/2024 to 02/25/2024": [
    ["120", "31", "380"],
    ["570", "26", "330"],
    ["115", "78", "134"],
    ["130", "49", "450"],
    ["469", "91", "489"],
    ["589", "20", "145"],
    ["246", "29", "234"],
  ],
  "02/26/2024 to 03/03/2024": [
    ["250", "73", "670"],
    ["567", "82", "570"],
    ["124", "79", "135"],
    ["139", "37", "566"],
    ["450", "95", "690"],
    ["590", "46", "367"],
    ["900", "95", "249"],
  ],
  "03/04/2024 to 03/10/2024": [
    ["234", "90", "677"],
    ["167", "40", "479"],
    ["359", "74", "257"],
    ["570", "28", "459"],
    ["135", "93", "229"],
    ["479", "07", "359"],
    ["367", "69", "667"],
  ],
  "03/11/2024 to 03/17/2024": [
    ["478", "90", "136"],
    ["689", "32", "237"],
    ["268", "63", "148"],
    ["139", "37", "368"],
    ["234", "97", "269"],
    ["230", "55", "267"],
    ["557", "72", "129"],
  ],
  "03/18/2024 to 03/24/2024": [
    ["237", "23", "300"],
    ["135", "97", "458"],
    ["577", "92", "345"],
    ["480", "28", "378"],
    ["159", "53", "599"],
    ["550", "03", "157"],
    ["128", "15", "555"],
  ],
  "03/25/2024 to 03/31/2024": [
    ["400", "43", "157"],
    ["240", "62", "778"],
    ["227", "11", "678"],
    ["500", "52", "156"],
    ["136", "02", "345"],
    ["134", "82", "147"],
    ["790", "64", "356"],
  ],
  "04/01/2024 to 04/07/2024": [
    ["790", "66", "349"],
    ["270", "98", "260"],
    ["470", "14", "248"],
    ["789", "40", "299"],
    ["457", "65", "168"],
    ["789", "45", "348"],
    ["559", "98", "477"],
  ],
  "04/08/2024 to 04/14/2024": [
    ["469", "96", "358"],
    ["136", "09", "126"],
    ["138", "25", "690"],
    ["123", "61", "290"],
    ["116", "84", "158"],
    ["100", "13", "300"],
    ["259", "67", "160"],
  ],
  "04/15/2024 to 04/21/2024": [
    ["146", "11", "245"],
    ["689", "37", "890"],
    ["235", "09", "135"],
    ["477", "88", "279"],
    ["357", "54", "149"],
    ["299", "06", "240"],
    ["225", "93", "599"],
  ],
  "04/22/2024 to 04/28/2024": [
    ["157", "38", "459"],
    ["668", "07", "124"],
    ["244", "00", "488"],
    ["123", "65", "113"],
    ["256", "31", "380"],
    ["112", "45", "113"],
    ["478", "95", "249"],
  ],
  "04/29/2024 to 05/05/2024": [
    ["334", "04", "455"],
    ["459", "86", "330"],
    ["357", "50", "280"],
    ["224", "80", "280"],
    ["144", "93", "256"],
    ["590", "44", "590"],
    ["440", "86", "880"],
  ],
  "05/06/2024 to 05/12/2024": [
    ["334", "04", "455"],
    ["459", "86", "330"],
    ["357", "50", "280"],
    ["224", "80", "280"],
    ["144", "93", "256"],
    ["590", "44", "590"],
    ["440", "86", "880"],
  ],
  "05/13/2024 to 05/19/2024": [
    ["440", "81", "335"],
    ["460", "02", "589"],
    ["179", "76", "880"],
    ["680", "44", "167"],
    ["230", "51", "146"],
    ["459", "80", "389"],
    ["557", "73", "490"],
  ],
  "05/20/2024 to 05/26/2024": [
    ["148", "39", "360"],
    ["600", "61", "579"],
    ["127", "02", "660"],
    ["678", "10", "235"],
    ["166", "39", "577"],
    ["180", "90", "460"],
    ["228", "26", "150"],
  ],
  "05/27/2024 to 06/02/2024": [
    ["135", "94", "347"],
    ["480", "22", "778"],
    ["157", "34", "356"],
    ["380", "19", "289"],
    ["568", "93", "346"],
    ["400", "41", "669"],
    ["668", "04", "789"],
  ],
  "06/03/2024 to 06/09/2024": [
    ["178", "66", "457"],
    ["447", "56", "790"],
    ["160", "74", "149"],
    ["188", "75", "267"],
    ["137", "19", "135"],
    ["233", "89", "469"],
    ["468", "89", "180"],
  ],
  "06/10/2024 to 06/16/2024": [
    ["144", "95", "177"],
    ["189", "85", "339"],
    ["455", "47", "250"],
    ["336", "20", "299"],
    ["370", "06", "899"],
    ["349", "60", "479"],
    ["134", "80", "280"],
  ],
  "06/17/2024 to 06/23/2024": [
    ["590", "47", "458"],
    ["337", "31", "245"],
    ["170", "81", "579"],
    ["448", "65", "456"],
    ["667", "92", "156"],
    ["224", "81", "560"],
    ["250", "71", "245"],
  ],
  "06/24/2024 to 06/30/2024": [
    ["890", "73", "120"],
    ["168", "50", "569"],
    ["400", "43", "670"],
    ["690", "51", "146"],
    ["249", "55", "159"],
    ["229", "38", "369"],
    ["480", "22", "138"],
  ],
  "07/01/2024 to 07/07/2024": [
    ["279", "83", "580"],
    ["678", "18", "459"],
    ["336", "25", "140"],
    ["247", "30", "578"],
    ["124", "70", "460"],
    ["678", "14", "239"],
    ["355", "31", "489"],
  ],
  "07/08/2024 to 07/14/2024": [
    ["799", "54", "680"],
    ["344", "10", "136"],
    ["158", "40", "334"],
    ["556", "68", "189"],
    ["233", "89", "469"],
    ["235", "08", "378"],
    ["379", "94", "446"],
  ],
  "07/15/2024 to 07/21/2024": [
    ["127", "03", "256"],
    ["479", "08", "134"],
    ["266", "48", "440"],
    ["570", "22", "390"],
    ["260", "84", "356"],
    ["899", "62", "688"],
    ["566", "79", "270"],
  ],
  "07/22/2024 to 07/28/2024": [
    ["448", "69", "379"],
    ["390", "22", "246"],
    ["119", "17", "160"],
    ["488", "08", "369"],
    ["250", "70", "145"],
    ["490", "35", "799"],
    ["127", "01", "344"],
  ],
  "07/29/2024 to 08/04/2024": [
    ["459", "87", "368"],
    ["180", "96", "277"],
    ["347", "43", "337"],
    ["148", "39", "568"],
    ["125", "87", "188"],
    ["366", "51", "236"],
    ["469", "99", "270"],
  ],
  "08/05/2024 to 08/11/2024": [
    ["778", "25", "177"],
    ["270", "93", "166"],
    ["689", "39", "126"],
    ["299", "03", "337"],
    ["145", "02", "679"],
    ["190", "09", "379"],
    ["390", "22", "246"],
  ],
  "08/12/2024 to 08/18/2024": [
    ["337", "33", "445"],
    ["188", "77", "299"],
    ["469", "99", "270"],
    ["190", "09", "379"],
    ["689", "39", "126"],
    ["146", "11", "236"],
    ["366", "51", "236"],
  ],
  "08/19/2024 to 08/25/2024": [
    ["123", "66", "114"],
    ["126", "90", "280"],
    ["188", "78", "288"],
    ["190", "09", "379"],
    ["110", "21", "236"],
    ["288", "88", "990"],
    ["470", "13", "337"],
  ],
  "08/26/2024 to 09/01/2024": [
    ["124", "72", "200"],
    ["122", "55", "690"],
    ["380", "16", "169"],
    ["257", "44", "158"],
    ["120", "33", "148"],
    ["349", "61", "489"],
    ["480", "29", "469"],
  ],
  "09/02/2024 to 09/08/2024": [
    ["278", "78", "279"],
    ["448", "67", "377"],
    ["170", "82", "499"],
    ["270", "93", "445"],
    ["680", "41", "335"],
    ["119", "19", "289"],
    ["178", "64", "400"],
  ],
  "09/09/2024 to 09/15/2024": [
    ["239", "45", "140"],
    ["300", "38", "800"],
    ["260", "81", "155"],
    ["110", "29", "388"],
    ["225", "96", "880"],
    ["233", "84", "680"],
    ["122", "55", "690"],
  ],
};
export const MAYANIGHT = {
  "01/01/2024 to 01/07/2024": [
    ["120", "31", "380"],
    ["118", "02", "480"],
    ["160", "75", "140"],
    ["280", "09", "270"],
    ["150", "64", "220"],
    ["120", "32", "480"],
    ["336", "21", "290"],
  ],
  "01/08/2024 to 01/14/2024": [
    ["223", "74", "220"],
    ["245", "11", "335"],
    ["135", "94", "130"],
    ["490", "31", "137"],
    ["455", "43", "120"],
    ["390", "26", "114"],
    ["170", "89", "270"],
  ],
  "01/15/2024 to 01/21/2024": [
    ["560", "12", "336"],
    ["115", "72", "480"],
    ["455", "47", "250"],
    ["240", "60", "226"],
    ["120", "33", "490"],
    ["113", "52", "336"],
    ["280", "04", "338"],
  ],
  "01/22/2024 to 01/28/2024": [
    ["344", "14", "130"],
    ["133", "70", "280"],
    ["150", "68", "116"],
    ["480", "21", "227"],
    ["350", "86", "240"],
    ["225", "90", "280"],
    ["160", "73", "120"],
  ],
  "01/29/2024 to 02/04/2024": [
    ["139", "32", "110"],
    ["150", "64", "130"],
    ["122", "51", "380"],
    ["390", "20", "118"],
    ["380", "12", "480"],
    ["490", "33", "157"],
    ["170", "86", "880"],
  ],
  "02/05/2024 to 02/11/2024": [
    ["280", "05", "122"],
    ["110", "21", "137"],
    ["120", "36", "330"],
    ["339", "54", "220"],
    ["113", "59", "135"],
    ["240", "66", "330"],
    ["220", "43", "120"],
  ],
  "02/12/2024 to 02/18/2024": [
     ["130", "47", "250"],
     ["123", "62", "110"],
     ["124", "70", "118"],
     ["440", "83", "120"],
     ["590", "45", "230"],
     ["120", "30", "280"],
     ["380", "13", "490"],
  ],
  "02/19/2024 to 02/25/2024": [
     ["220", "42", "390"],
     ["334", "08", "350"],
     ["200", "23", "120"],
     ["126", "99", "270"],
     ["350", "82", "480"],
     ["270", "97", "124"],
     ["360", "91", "380"],
  ],
  "02/26/2024 to 03/03/2024": [
     ["100", "10", "370"],
     ["240", "64", "112"],
     ["330", "66", "123"],
     ["240", "60", "280"],
     ["360", "98", "350"],
     ["368", "71", "146"],
     ["400", "47", "340"],
  ],
  "03/04/2024 to 03/10/2024": [
     ["330", "62", "156"],
     ["580", "36", "330"],
     ["117", "91", "380"],
     ["490", "37", "160"],
     ["220", "43", "120"],
     ["440", "83", "490"],
     ["200", "25", "230"],
  ],
  "03/11/2024 to 03/17/2024": [
     ["550", "09", "450"],
     ["270", "96", "330"],
     ["116", "89", "450"],
     ["123", "68", "260"],
     ["490", "32", "480"],
     ["230", "55", "780"],
     ["550", "01", "380"],
  ],
  "03/18/2024 to 03/24/2024": [
     ["129", "25", "113"],
     ["230", "51", "128"],
     ["120", "31", "380"],
     ["240", "63", "490"],
     ["780", "51", "290"],
     ["110", "20", "460"],
     ["220", "47", "160"],
  ],
  "03/25/2024 to 03/31/2024": [
     ["140", "55", "500"],
     ["125", "80", "190"],
     ["110", "29", "270"],
     ["127", "02", "480"],
     ["139", "33", "120"],
     ["123", "65", "140"],
     ["260", "81", "380"],
  ],
  "04/01/2024 to 04/07/2024": [
     ["113", "59", "135"],
     ["112", "40", "190"],
     ["390", "24", "220"],
     ["225", "92", "110"],
     ["500", "52", "345"],
     ["260", "86", "178"],
     ["226", "02", "156"],
  ],
  "04/08/2024 to 04/14/2024": [
     ["380", "16", "330"],
     ["350", "87", "160"],
     ["330", "65", "230"],
     ["690", "58", "260"],
     ["270", "95", "113"],
     ["220", "49", "225"],
     ["300", "35", "140"],
  ],
  "04/15/2024 to 04/21/2024": [
     ["480", "22", "660"],
     ["550", "08", "260"],
     ["680", "44", "220"],
     ["123", "65", "230"],
     ["160", "79", "270"],
     ["580", "36", "123"],
     ["680", "42", "570"],
  ],
  "04/22/2024 to 04/28/2024": [
     ["123", "64", "112"],
     ["260", "80", "280"],
     ["113", "56", "240"],
     ["550", "02", "390"],
     ["340", "78", "350"],
     ["220", "46", "150"],
     ["233", "85", "230"],
  ],
  "04/29/2024 to 05/05/2024": [
     ["146", "15", "780"],
     ["350", "84", "590"],
     ["160", "77", "133"],
     ["660", "21", "470"],
     ["190", "04", "130"],
     ["100", "19", "180"],
     ["270", "94", "220"],
  ],
  "05/06/2024 to 05/12/2024": [
     ["124", "79", "360"],
     ["120", "30", "370"],
     ["180", "95", "230"],
     ["330", "61", "100"],
     ["220", "42", "570"],
     ["138", "23", "247"],
     ["126", "90", "280"],
  ],
  "05/13/2024 to 05/19/2024": [
     ["190", "01", "380"],
     ["400", "41", "335"],
     ["490", "38", "350"],
     ["660", "25", "140"],
     ["239", "49", "568"],
     ["168", "52", "390"],
     ["578", "06", "123"],
  ],
  "05/20/2024 to 05/26/2024": [
     ["220", "44", "130"],
     ["450", "90", "370"],
     ["560", "15", "230"],
     ["114", "69", "234"],
     ["123", "65", "690"],
     ["224", "81", "146"],
     ["478", "98", "233"],
  ],
  "05/27/2024 to 06/02/2024": [
     ["150", "61", "560"],
     ["117", "97", "160"],
     ["280", "03", "120"],
     ["660", "28", "350"],
     ["158", "43", "238"],
     ["780", "53", "229"],
     ["456", "57", "188"],
  ],
  "06/03/2024 to 06/09/2024": [
     ["120", "37", "340"],
     ["380", "18", "170"],
     ["470", "14", "220"],
     ["260", "89", "450"],
     ["700", "77", "359"],
     ["440", "84", "789"],
     ["689", "32", "147"],
  ],
  "06/10/2024 to 06/16/2024": [
     ["230", "52", "570"],
     ["225", "93", "120"],
     ["220", "49", "450"],
     ["200", "25", "140"],
     ["157", "33", "788"],
     ["340", "79", "234"],
     ["148", "38", "279"],
  ],
  "06/17/2024 to 06/23/2024": [
     ["480", "27", "250"],
     ["550", "00", "190"],
     ["455", "48", "260"],
     ["160", "73", "490"],
     ["189", "81", "344"],
     ["770", "43", "256"],
     ["136", "08", "279"],
  ],
  "06/24/2024 to 06/30/2024": [
     ["134", "81", "236"],
     ["456", "52", "138"],
     ["130", "49", "360"],
     ["180", "96", "268"],
     ["136", "07", "340"],
     ["113", "59", "234"],
     ["233", "80", "145"],
  ],

  "07/15/2024 to 07/21/2024": [
     ["690", "51", "344"],
     ["300", "39", "469"],
     ["390", "26", "169"],
     ["489", "10", "569"],
     ["360", "91", "380"],
     ["115", "72", "778"],
     ["880", "67", "269"],
  ],
  "07/22/2024 to 07/28/2024": [
   ["899", "60", "569"],
   ["900", "98", "116"],
   ["666", "88", "134"],
   ["228", "25", "168"],
   ["379", "90", "389"],
   ["456", "56", "349"],
   ["124", "74", "266"],
  ],
  "07/29/2024 to 08/04/2024": [
     ["148", "33", "337"],
     ["667", "98", "134"],
     ["256", "30", "235"],
     ["234", "91", "146"],
     ["335", "16", "114"],
     ["580", "37", "890"],
     ["500", "56", "880"],
  ],
  "08/05/2024 to 08/11/2024": [
     ["237", "25", "267"],
     ["120", "31", "380"],
     ["240", "63", "490"],
     ["255", "24", "220"],
     ["235", "03", "580"],
     ["300", "36", "330"],
     ["120", "38", "440"],
  ],
  "08/12/2024 to 08/18/2024": [
     ["567", "82", "138"],
     ["100", "12", "110"],
     ["126", "91", "380"],
     ["570", "25", "500"],
     ["112", "44", "680"],
     ["560", "14", "680"],
     ["120", "30", "280"],
  ],
  "08/19/2024 to 08/25/2024": [
     ["220", "44", "770"],
     ["350", "80", "460"],
     ["112", "47", "250"],
     ["780", "52", "679"],
     ["220", "44", "770"],
     ["350", "80", "460"],
     ["300", "38", "224"],
  ],
  "08/26/2024 to 09/01/2024": [
     ["126", "90", "460"],
     ["550", "03", "490"],
     ["260", "86", "114"],
     ["389", "06", "880"],
     ["126", "90", "460"],
     ["550", "03", "490"],
     ["270", "91", "380"],
  ],
  "09/02/2024 to 09/08/2024": [
     ["120", "30", "280"],
     ["150", "61", "380"],
     ["150", "62", "147"],
     ["888", "46", "330"],
     ["160", "70", "280"],
     ["780", "54", "266"],
     ["230", "55", "267"],
  ],
  "09/09/2024 to 09/15/2024": [
     ["300", "38", "224"],
     ["366", "51", "128"],
     ["344", "16", "330"],
     ["122", "53", "580"],
     ["125", "81", "128"],
     ["200", "22", "390"],
     ["550", "03", "157"],
  ],
};

export const SUPREMEDAY = {
  "01/01/2024 to 07/01/2024": [
     ["569", "00", "389"],
     ["240", "68", "189"],
     ["356", "46", "790"],
     ["578", "01", "128"],
     ["349", "66", "358"],
     ["568", "97", "160"],
     ["246", "28", "170"],
  ],
  "08/01/2024 to 14/01/2024": [
     ["250", "79", "225"],
     ["569", "08", "440"],
     ["589", "20", "244"],
     ["458", "79", "568"],
     ["139", "36", "178"],
     ["138", "26", "123"],
     ["678", "10", "118"],
  ],
  "15/01/2024 to 21/01/2024": [
     ["158", "46", "169"],
     ["247", "38", "378"],
     ["577", "97", "700"],
     ["138", "20", "235"],
     ["189", "85", "690"],
     ["179", "70", "668"],
     ["280", "06", "259"],
  ],
  "22/01/2024 to 28/01/2024": [
     ["127", "09", "144"],
     ["139", "39", "180"],
     ["230", "52", "129"],
     ["560", "11", "236"],
     ["459", "81", "236"],
     ["136", "01", "344"],
     ["550", "07", "458"],
  ],
  "29/01/2024 to 04/02/2024": [
     ["135", "91", "128"],
     ["120", "32", "390"],
     ["157", "35", "159"],
     ["459", "81", "236"],
     ["239", "45", "780"],
     ["566", "79", "667"],
     ["338", "45", "780"],
  ],
  "05/02/2024 to 11/02/2024": [
     ["224", "86", "268"],
     ["677", "09", "199"],
     ["700", "71", "155"],
     ["289", "93", "779"],
     ["134", "82", "589"],
     ["223", "75", "267"],
     ["667", "93", "580"],
  ],
  "12/02/2024 to 18/02/2024": [
     ["177", "59", "450"],
     ["889", "55", "122"],
     ["139", "33", "670"],
     ["145", "08", "134"],
     ["136", "06", "169"],
     ["236", "15", "780"],
     ["170", "81", "119"],
  ],
  "19/02/2024 to 25/02/2024": [
     ["377", "74", "149"],
     ["128", "11", "344"],
     ["688", "22", "480"],
     ["167", "49", "135"],
     ["123", "65", "889"],
     ["226", "02", "480"],
     ["334", "05", "168"],
  ],
  "26/02/2024 to 03/03/2024": [
     ["770", "41", "669"],
     ["779", "35", "113"],
     ["440", "86", "123"],
     ["179", "76", "899"],
     ["469", "92", "237"],
     ["560", "15", "780"],
     ["567", "86", "880"],
  ],
  "04/03/2024 to 10/03/2024": [
     ["225", "96", "268"],
     ["168", "55", "267"],
     ["147", "21", "560"],
     ["469", "94", "347"],
     ["234", "92", "336"],
     ["280", "04", "590"],
     ["138", "21", "290"],
  ],
  "11/03/2024 to 17/03/2024": [
     ["148", "35", "249"],
     ["160", "76", "123"],
     ["268", "64", "257"],
     ["490", "35", "500"],
     ["356", "45", "348"],
     ["229", "33", "788"],
     ["459", "84", "149"],
  ],
  "18/03/2024 to 24/03/2024": [
     ["150", "67", "179"],
     ["278", "71", "128"],
     ["358", "62", "660"],
     ["133", "75", "140"],
     ["590", "40", "235"],
     ["360", "90", "127"],
     ["368", "75", "177"],
  ],
  "25/03/2024 to 31/03/2024": [
     ["130", "48", "125"],
     ["228", "23", "247"],
     ["139", "34", "149"],
     ["349", "62", "110"],
     ["299", "09", "199"],
     ["350", "89", "568"],
     ["149", "43", "157"],
  ],
  "01/04/2024 to 07/04/2024": [
     ["113", "54", "770"],
     ["550", "08", "288"],
     ["389", "08", "125"],
     ["112", "46", "466"],
     ["270", "91", "119"],
     ["489", "11", "137"],
     ["250", "70", "479"],
  ],
  "08/04/2024 to 14/04/2024": [
     ["390", "25", "357"],
     ["178", "64", "257"],
     ["578", "02", "589"],
     ["247", "39", "135"],
     ["120", "31", "290"],
     ["245", "15", "447"],
     ["137", "13", "445"],
  ],
  "15/04/2024 to 21/04/2024": [
     ["278", "75", "366"],
     ["250", "76", "330"],
     ["126", "98", "459"],
     ["199", "98", "477"],
     ["356", "41", "227"],
     ["136", "05", "339"],
     ["580", "35", "249"],
  ],
  "22/04/2024 to 28/04/2024": [
     ["456", "55", "889"],
     ["700", "71", "380"],
     ["130", "48", "125"],
     ["399", "16", "790"],
     ["880", "66", "367"],
     ["190", "05", "357"],
     ["349", "61", "380"],
  ],
  "29/04/2024 to 05/05/2024": [
     ["478", "98", "558"],
     ["256", "37", "458"],
     ["149", "47", "160"],
     ["678", "12", "156"],
     ["114", "66", "457"],
     ["345", "25", "168"],
     ["468", "88", "233"],
  ],
  "06/05/2024 to 12/05/2024": [
     ["244", "01", "669"],
     ["670", "38", "279"],
     ["290", "12", "228"],
     ["236", "11", "227"],
     ["379", "90", "190"],
     ["126", "90", "280"],
     ["568", "97", "179"],
  ],
  "13/05/2024 to 19/05/2024": [
     ["500", "55", "113"],
     ["116", "81", "227"],
     ["680", "47", "124"],
     ["156", "22", "138"],
     ["490", "38", "125"],
     ["149", "45", "230"],
     ["124", "73", "157"],
  ],
  "20/05/2024 to 26/05/2024": [
     ["366", "59", "117"],
     ["458", "78", "990"],
     ["244", "06", "150"],
     ["137", "15", "168"],
     ["128", "10", "136"],
     ["679", "22", "499"],
     ["100", "10", "334"],
  ],
  "27/05/2024 to 02/06/2024": [
     ["269", "77", "890"],
     ["234", "96", "114"],
     ["244", "00", "145"],
     ["449", "73", "157"],
     ["350", "84", "266"],
     ["470", "19", "559"],
     ["578", "07", "124"],
  ],
  "03/06/2024 to 09/06/2024": [
     ["370", "03", "139"],
     ["278", "72", "589"],
     ["128", "11", "236"],
     ["160", "77", "179"],
     ["378", "89", "469"],
     ["789", "44", "680"],
     ["160", "79", "180"],
  ],
  "10/06/2024 to 16/06/2024": [
     ["120", "33", "148"],
     ["158", "48", "134"],
     ["689", "32", "688"],
     ["890", "75", "357"],
     ["345", "26", "178"],
     ["227", "15", "267"],
     ["470", "19", "289"],
  ],
  "17/06/2024 to 23/06/2024": [
     ["990", "85", "780"],
     ["679", "20", "550"],
     ["559", "94", "446"],
     ["477", "88", "125"],
     ["457", "69", "144"],
     ["188", "78", "350"],
     ["990", "88", "369"],
  ],
  "24/06/2024 to 30/06/2024": [
     ["800", "88", "134"],
     ["366", "55", "348"],
     ["169", "69", "135"],
     ["668", "09", "450"],
     ["135", "98", "189"],
     ["357", "52", "237"],
     ["256", "34", "789"],
  ],
  "01/07/2024 to 07/07/2024": [
     ["667", "98", "170"],
     ["138", "26", "169"],
     ["570", "26", "448"],
     ["368", "71", "146"],
     ["136", "00", "235"],
     ["469", "95", "159"],
     ["569", "02", "660"],
  ],
  "08/07/2024 to 14/07/2024": [
     ["460", "08", "567"],
     ["239", "42", "480"],
     ["178", "66", "367"],
     ["223", "77", "269"],
     ["467", "77", "124"],
     ["135", "95", "456"],
     ["245", "15", "780"],
  ],
  "15/07/2024 to 21/07/2024": [
     ["280", "03", "139"],
     ["600", "69", "667"],
     ["348", "54", "167"],
     ["136", "07", "160"],
     ["178", "62", "345"],
     ["990", "81", "119"],
     ["680", "45", "267"],
  ],
  "22/07/2024 to 28/07/2024": [
     ["569", "03", "256"],
     ["460", "08", "558"],
     ["248", "44", "149"],
     ["569", "05", "357"],
     ["478", "92", "129"],
     ["499", "29", "270"],
     ["577", "92", "660"],
  ],
  "29/07/2024 to 04/08/2024": [
     ["377", "78", "567"],
     ["257", "46", "150"],
     ["227", "12", "589"],
     ["899", "64", "158"],
     ["220", "45", "140"],
     ["118", "09", "135"],
     ["779", "37", "449"],
  ],
  "05/08/2024 to 11/08/2024": [
     ["558", "88", "125"],
     ["145", "01", "128"],
     ["157", "33", "689"],
     ["460", "03", "247"],
     ["128", "16", "114"],
     ["388", "90", "370"],
     ["458", "71", "128"],
  ],
  "12/08/2024 to 18/08/2024": [
     ["680", "41", "588"],
     ["145", "05", "230"],
     ["134", "83", "238"],
     ["458", "71", "128"],
     ["127", "09", "144"],
     ["456", "59", "577"],
     ["260", "84", "590"],
  ],
  "19/08/2024 to 25/08/2024": [
     ["560", "14", "167"],
     ["157", "36", "600"],
     ["470", "16", "114"],
     ["560", "14", "680"],
     ["113", "52", "660"],
     ["390", "22", "246"],
     ["580", "34", "149"],
  ],
  "26/08/2024 to 01/09/2024": [
     ["100", "11", "344"],
     ["689", "36", "169"],
     ["349", "60", "118"],
     ["488", "06", "114"],
     ["136", "08", "477"],
     ["124", "79", "126"],
     ["369", "83", "247"],
  ],
  "02/09/2024 to 08/09/2024": [
     ["489", "12", "129"],
     ["160", "77", "368"],
     ["336", "25", "168"],
     ["468", "80", "389"],
     ["460", "08", "125"],
     ["379", "98", "189"],
     ["250", "71", "290"],
  ],
  "09/09/2024 to 15/09/2024": [
     ["450", "97", "133"],
     ["119", "16", "150"],
     ["790", "65", "168"],
     ["236", "10", "460"],
     ["200", "25", "500"],
     ["188", "76", "277"],
     ["160", "70", "460"],
  ],
  "16/09/2024 to 22/09/2024": [
     ["990", "89", "225"],
     ["200", "21", "560"],
     ["133", "70", "569"],
     ["350", "84", "266"],
     ["799", "54", "112"],
     ["133", "73", "580"],
     ["157", "39", "199"],
  ],
  "23/09/2024 to 29/09/2024": [
     ["577", "94", "356"],
     ["770", "47", "223"],
     ["557", "79", "270"],
     ["480", "25", "230"],
     ["460", "06", "367"],
     ["670", "33", "256"],
     ["180", "90", "299"],
  ],
  "30/09/2024 to 06/10/2024": [
     ["279", "88", "990"],
     ["778", "20", "118"],
     ["149", "42", "237"],
     ["257", "41", "236"],
     ["126", "98", "170"],
     ["679", "29", "450"],
     ["139", "30", "370"],
  ],
  "07/10/2024 to 13/10/2024": [
     ["490", "34", "158"],
     ["190", "00", "479"],
     ["467", "79", "568"],
     ["570", "22", "200"],
     ["567", "89", "450"],
     ["136", "08", "189"],
     ["115", "77", "269"],
  ],
  "14/10/2024 to 20/10/2024": [
     ["224", "81", "678"],
     ["134", "83", "337"],
     ["790", "66", "259"],
     ["238", "39", "135"],
     ["255", "20", "127"],
     ["357", "56", "277"],
     ["156", "22", "589"],
  ],
};

export const SUPREMENIGHT = {
  "01/01/2024 to 07/01/2024": [
     ["137", "16", "123"],
     ["178", "61", "236"],
     ["289", "93", "256"],
     ["369", "88", "378"],
     ["280", "07", "890"],
     ["467", "73", "580"],
     ["360", "98", "567"],
  ],
  "08/01/2024 to 14/01/2024": [
     ["124", "76", "268"],
     ["270", "99", "234"],
     ["356", "49", "117"],
     ["168", "58", "224"],
     ["235", "03", "157"],
     ["145", "00", "244"],
     ["578", "01", "155"],
  ],
  "15/01/2024 to 21/01/2024": [
     ["256", "34", "680"],
     ["236", "11", "489"],
     ["120", "36", "169"],
     ["349", "69", "289"],
     ["450", "97", "160"],
     ["158", "48", "125"],
     ["122", "53", "139"],
  ],
  "22/01/2024 to 28/01/2024": [
     ["150", "69", "199"],
     ["133", "70", "668"],
     ["450", "96", "178"],
     ["469", "90", "389"],
     ["236", "17", "449"],
     ["155", "11", "579"],
     ["469", "97", "368"],
  ],
  "29/01/2024 to 04/02/2024": [
     ["124", "77", "890"],
     ["127", "07", "160"],
     ["589", "28", "134"],
     ["139", "32", "480"],
     ["567", "88", "189"],
     ["144", "91", "678"],
     ["880", "60", "145"],
  ],
  "05/02/2024 to 11/02/2024": [
     ["447", "51", "290"],
     ["260", "89", "234"],
     ["446", "42", "255"],
     ["299", "01", "119"],
     ["249", "52", "778"],
     ["158", "44", "789"],
     ["156", "21", "344"],
  ],
  "12/02/2024 to 18/02/2024": [
     ["445", "33", "229"],
     ["266", "42", "336"],
     ["470", "10", "235"],
     ["115", "73", "247"],
     ["126", "93", "238"],
     ["230", "55", "348"],
     ["389", "00", "280"],
  ],
  "19/02/2024 to 25/02/2024": [
     ["244", "06", "123"],
     ["450", "95", "357"],
     ["250", "75", "168"],
     ["350", "87", "160"],
     ["138", "23", "166"],
     ["670", "39", "559"],
     ["179", "76", "240"],
  ],
  "26/02/2024 to 03/03/2024": [
     ["190", "05", "357"],
     ["356", "41", "470"],
     ["568", "92", "147"],
     ["680", "46", "240"],
     ["789", "41", "146"],
     ["278", "73", "779"],
     ["479", "08", "440"],
  ],
  "04/03/2024 to 10/03/2024": [
     ["136", "06", "457"],
     ["160", "72", "390"],
     ["460", "00", "235"],
     ["368", "73", "157"],
     ["300", "39", "135"],
     ["379", "95", "348"],
     ["189", "81", "146"],
  ],
  "11/03/2024 to 17/03/2024": [
     ["225", "99", "126"],
     ["368", "76", "114"],
     ["447", "56", "466"],
     ["158", "41", "128"],
     ["248", "41", "560"],
     ["677", "02", "129"],
     ["166", "35", "780"],
  ],
  "18/03/2024 to 24/03/2024": [
     ["138", "25", "168"],
     ["678", "19", "469"],
     ["579", "13", "445"],
     ["233", "87", "377"],
     ["126", "93", "580"],
     ["156", "21", "146"],
     ["570", "20", "479"],
  ],
  "25/03/2024 to 31/03/2024": [
     ["236", "17", "449"],
     ["770", "46", "268"],
     ["790", "65", "690"],
     ["678", "10", "488"],
     ["670", "37", "890"],
     ["225", "98", "440"],
     ["168", "53", "120"],
  ],
  "01/04/2024 to 07/04/2024": [
     ["300", "37", "449"],
     ["345", "29", "469"],
     ["268", "60", "145"],
     ["459", "80", "578"],
     ["340", "74", "257"],
     ["689", "33", "256"],
     ["455", "46", "240"],
  ],
  "08/04/2024 to 14/04/2024": [
     ["456", "51", "128"],
     ["370", "07", "269"],
     ["220", "47", "566"],
     ["268", "68", "134"],
     ["178", "68", "369"],
     ["278", "75", "500"],
     ["237", "24", "130"],
  ],
  "15/04/2024 to 21/04/2024": [
     ["450", "99", "270"],
     ["167", "44", "266"],
     ["160", "74", "158"],
     ["799", "55", "267"],
     ["567", "87", "124"],
     ["470", "11", "669"],
     ["278", "79", "469"],
  ],
  "22/04/2024 to 28/04/2024": [
     ["123", "66", "556"],
     ["127", "05", "177"],
     ["567", "81", "128"],
     ["680", "46", "123"],
     ["138", "26", "178"],
     ["446", "45", "780"],
     ["356", "49", "180"],
  ],
  "29/04/2024 to 05/05/2024": [
     ["358", "66", "600"],
     ["124", "78", "369"],
     ["337", "38", "279"],
     ["460", "09", "126"],
     ["177", "53", "689"],
     ["128", "11", "146"],
     ["590", "46", "259"],
  ],
  "06/05/2024 to 12/05/2024": [
     ["480", "27", "269"],
     ["225", "90", "136"],
     ["280", "06", "556"],
     ["357", "54", "338"],
     ["440", "83", "256"],
     ["149", "40", "136"],
     ["240", "62", "570"],
  ],
  "13/05/2024 to 19/05/2024": [
     ["256", "39", "135"],
     ["278", "77", "188"],
     ["155", "18", "170"],
     ["117", "95", "799"],
     ["678", "14", "789"],
     ["150", "64", "455"],
     ["559", "94", "239"],
  ],
  "20/05/2024 to 26/05/2024": [
     ["228", "20", "550"],
     ["678", "12", "336"],
     ["123", "65", "230"],
     ["467", "73", "580"],
     ["112", "48", "260"],
     ["144", "97", "890"],
     ["389", "01", "137"],
  ],
  "27/05/2024 to 02/06/2024": [
     ["120", "31", "128"],
     ["179", "75", "690"],
     ["459", "85", "357"],
     ["367", "66", "123"],
     ["159", "58", "369"],
     ["360", "99", "667"],
     ["147", "28", "189"],
  ],
  "03/06/2024 to 09/06/2024": [
     ["449", "79", "360"],
     ["470", "12", "570"],
     ["379", "95", "690"],
     ["120", "33", "346"],
     ["248", "48", "125"],
     ["778", "20", "190"],
     ["400", "47", "223"],
  ],
  "10/06/2024 to 16/06/2024": [
     ["456", "51", "678"],
     ["179", "72", "345"],
     ["146", "11", "489"],
     ["558", "84", "149"],
     ["368", "73", "670"],
     ["258", "57", "359"],
     ["135", "99", "126"],
  ],
  "22/07/2024 to 28/07/2024": [
     ["238", "34", "257"],
     ["233", "89", "180"],
     ["138", "20", "299"],
     ["448", "65", "113"],
     ["149", "44", "680"],
     ["150", "63", "355"],
     ["236", "17", "449"],
  ],
  "29/07/2024 to 04/08/2024": [
     ["237", "20", "118"],
     ["567", "86", "277"],
     ["690", "53", "157"],
     ["145", "02", "570"],
     ["359", "71", "344"],
     ["123", "62", "129"],
     ["260", "84", "680"],
  ],
  "05/08/2024 to 11/08/2024": [
     ["336", "22", "237"],
     ["478", "90", "370"],
     ["137", "15", "168"],
     ["467", "75", "456"],
     ["178", "64", "158"],
     ["378", "88", "189"],
     ["459", "84", "590"],
  ],
  "12/08/2024 to 18/08/2024": [
     ["458", "74", "338"],
     ["689", "33", "157"],
     ["146", "17", "467"],
     ["145", "02", "570"],
     ["150", "62", "480"],
     ["135", "93", "445"],
     ["290", "17", "250"],
  ],
  "19/08/2024 to 25/08/2024": [
     ["267", "55", "159"],
     ["189", "85", "690"],
     ["199", "90", "118"],
     ["139", "30", "578"],
     ["148", "33", "788"],
     ["158", "41", "245"],
     ["135", "90", "299"],
  ],
  "26/08/2024 to 01/09/2024": [
     ["157", "35", "780"],
     ["377", "72", "570"],
     ["560", "19", "135"],
     ["345", "27", "179"],
     ["116", "86", "457"],
     ["127", "06", "178"],
     ["279", "87", "377"],
  ],
  "02/09/2024 to 08/09/2024": [
     ["447", "59", "234"],
     ["770", "44", "338"],
     ["146", "11", "100"],
     ["457", "69", "667"],
     ["157", "34", "347"],
     ["560", "13", "139"],
     ["349", "63", "120"],
  ],
  "09/09/2024 to 15/09/2024": [
     ["700", "75", "168"],
     ["134", "80", "668"],
     ["347", "44", "149"],
     ["368", "73", "238"],
     ["137", "15", "456"],
     ["138", "25", "348"],
     ["689", "37", "368"],
  ],
  "16/09/2024 to 22/09/2024": [
     ["178", "63", "670"],
     ["128", "18", "279"],
     ["159", "50", "136"],
     ["349", "66", "240"],
     ["479", "01", "470"],
     ["148", "36", "240"],
     ["348", "52", "589"],
  ],
  "23/09/2024 to 29/09/2024": [
     ["445", "32", "246"],
     ["379", "98", "125"],
     ["377", "76", "169"],
     ["668", "01", "380"],
     ["117", "93", "166"],
     ["237", "25", "447"],
     ["350", "80", "488"],
  ],
  "30/09/2024 to 06/10/2024": [
     ["278", "76", "556"],
     ["128", "14", "149"],
     ["450", "98", "134"],
     ["400", "48", "477"],
     ["570", "22", "246"],
     ["135", "91", "146"],
     ["468", "80", "569"],
  ],
  "07/10/2024 to 13/10/2024": [
     ["377", "72", "660"],
     ["238", "34", "130"],
     ["446", "40", "235"],
     ["289", "96", "367"],
     ["170", "84", "590"],
     ["240", "65", "159"],
     ["155", "11", "669"],
  ],
  "14/10/2024 to 20/10/2024": [
     ["579", "17", "458"],
     ["469", "93", "148"],
     ["336", "23", "599"],
     ["460", "05", "140"],
     ["446", "44", "257"],
     ["337", "39", "360"],
     ["500", "56", "899"],
  ],
};

export const VEDAMORNING = {
  "30/12/2024 to 05/01/2025": [
     ["559", "92", "688"],
     ["180", "92", "200"],
     ["568", "97", "115"],
     ["490", "37", "160"],
     ["379", "94", "158"],
     ["235", "06", "899"],
     ["366", "50", "235"],
  ],
  "06/01/2025 to 12/01/2025": [
     ["999", "73", "670"],
     ["237", "29", "144"],
     ["369", "83", "256"],
     ["347", "49", "199"],
     ["599", "33", "247"],
     ["144", "97", "133"],
     ["580", "34", "400"],
  ],
  "13/01/2025 to 19/01/2025": [
     ["334", "06", "466"],
     ["469", "99", "225"],
     ["357", "59", "388"],
     ["228", "26", "169"],
     ["699", "48", "477"],
     ["456", "56", "466"],
     ["118", "09", "126"],
  ],
  "20/01/2025 to 26/01/2025": [
     ["248", "43", "689"],
     ["266", "43", "148"],
     ["227", "18", "189"],
     ["144", "91", "669"],
     ["222", "64", "680"],
     ["248", "44", "446"],
     ["246", "25", "500"],
  ],
  "27/01/2025 to 02/02/2025": [
     ["680", "47", "340"],
     ["239", "48", "800"],
     ["690", "57", "269"],
     ["578", "00", "145"],
     ["445", "37", "250"],
     ["238", "38", "468"],
     ["137", "12", "778"],
  ],
  "03/02/2025 to 09/02/2025": [
     ["800", "80", "226"],
     ["890", "70", "235"],
     ["588", "17", "700"],
     ["148", "31", "489"],
     ["259", "63", "157"],
     ["678", "14", "158"],
     ["577", "93", "238"],
  ],
  "10/02/2025 to 16/02/2025": [
     ["900", "90", "460"],
     ["166", "34", "239"],
     ["136", "05", "357"],
     ["223", "72", "237"],
     ["245", "19", "559"],
     ["480", "20", "389"],
     ["227", "14", "149"],
  ],
  "17/02/2025 to 23/02/2025": [
     ["122", "57", "566"],
     ["890", "75", "500"],
     ["344", "10", "000"],
     ["380", "15", "500"],
     ["390", "21", "579"],
     ["790", "63", "139"],
     ["347", "43", "580"],
  ],
  "24/02/2025 to 02/03/2025": [
     ["667", "96", "457"],
     ["688", "27", "278"],
     ["378", "88", "666"],
     ["444", "28", "116"],
     ["150", "64", "888"],
     ["169", "63", "445"],
     ["129", "26", "330"],
  ],
  "03/03/2025 to 09/03/2025": [
     ["347", "40", "000"],
     ["588", "12", "679"],
     ["390", "28", "378"],
     ["159", "56", "880"],
     ["110", "28", "440"],
     ["500", "52", "499"],
     ["330", "64", "699"],
  ],

  "10/03/2025 to 16/03/2025": [
     ["555", "59", "270"],
     ["149", "44", "356"],
     ["579", "19", "568"],
     ["449", "74", "455"],
     ["679", "22", "679"],
     ["889", "59", "117"],
     ["377", "70", "127"],
  ],
  "17/03/2025 to 23/03/2025": [
     ["447", "58", "350"],
     ["127", "05", "159"],
     ["339", "57", "223"],
     ["125", "81", "236"],
     ["367", "65", "357"],
     ["599", "31", "128"],
     ["137", "16", "349"],
  ],
  "24/03/2025 to 30/03/2025": [
     ["467", "76", "330"],
     ["236", "19", "126"],
     ["479", "05", "555"],
     ["668", "02", "345"],
     ["117", "97", "269"],
     ["550", "09", "360"],
     ["249", "54", "789"],
  ],
};

export const YUGMORNING = {
  "30/12/2024 to 05/01/2025": [
     ["559", "92", "688"],
     ["180", "92", "200"],
     ["568", "97", "115"],
     ["490", "37", "160"],
     ["379", "94", "158"],
     ["235", "06", "899"],
     ["366", "50", "235"],
  ],
  "06/01/2025 to 12/01/2025": [
     ["999", "73", "670"],
     ["237", "29", "144"],
     ["369", "83", "256"],
     ["347", "49", "199"],
     ["599", "33", "247"],
     ["144", "97", "133"],
     ["580", "34", "400"],
  ],
  "13/01/2025 to 19/01/2025": [
     ["334", "06", "466"],
     ["469", "99", "225"],
     ["357", "59", "388"],
     ["228", "26", "169"],
     ["699", "48", "477"],
     ["456", "56", "466"],
     ["118", "09", "126"],
  ],
  "20/01/2025 to 26/01/2025": [
     ["248", "43", "689"],
     ["266", "43", "148"],
     ["227", "18", "189"],
     ["144", "91", "669"],
     ["222", "64", "680"],
     ["248", "44", "446"],
     ["246", "25", "500"],
  ],
  "27/01/2025 to 02/02/2025": [
     ["680", "47", "340"],
     ["239", "48", "800"],
     ["690", "57", "269"],
     ["578", "00", "145"],
     ["445", "37", "250"],
     ["238", "38", "468"],
     ["137", "12", "778"],
  ],
  "03/02/2025 to 09/02/2025": [
     ["800", "80", "226"],
     ["890", "70", "235"],
     ["588", "17", "700"],
     ["148", "31", "489"],
     ["259", "63", "157"],
     ["678", "14", "158"],
     ["577", "93", "238"],
  ],
  "10/02/2025 to 16/02/2025": [
     ["900", "90", "460"],
     ["166", "34", "239"],
     ["136", "05", "357"],
     ["223", "72", "237"],
     ["245", "19", "559"],
     ["480", "20", "389"],
     ["227", "14", "149"],
  ],
  "17/02/2025 to 23/02/2025": [
     ["122", "57", "566"],
     ["890", "75", "500"],
     ["344", "10", "000"],
     ["380", "15", "500"],
     ["390", "21", "579"],
     ["790", "63", "139"],
     ["347", "43", "580"],
  ],
  "24/02/2025 to 02/03/2025": [
     ["667", "96", "457"],
     ["688", "27", "278"],
     ["378", "88", "666"],
     ["444", "28", "116"],
     ["150", "64", "888"],
     ["169", "63", "445"],
     ["129", "26", "330"],
  ],
  "03/03/2025 to 09/03/2025": [
     ["347", "40", "000"],
     ["588", "12", "679"],
     ["390", "28", "378"],
     ["159", "56", "880"],
     ["110", "28", "440"],
     ["500", "52", "499"],
     ["330", "64", "699"],
  ],
  "10/03/2025 to 16/03/2025": [
     ["124", "78", "233"],
     ["277", "65", "177"],
     ["479", "02", "200"],
     ["356", "45", "889"],
     ["800", "86", "457"],
     ["445", "38", "288"],
     ["489", "13", "256"],
  ],
  "17/03/2025 to 23/03/2025": [
     ["139", "32", "147"],
     ["368", "75", "140"],
     ["200", "23", "689"],
     ["122", "57", "160"],
     ["160", "73", "779"],
     ["580", "31", "669"],
     ["440", "86", "240"],
  ],
  "24/03/2025 to 30/03/2025": [
     ["149", "40", "569"],
     ["188", "77", "115"],
     ["579", "13", "111"],
     ["134", "84", "446"],
     ["447", "51", "236"],
     ["157", "31", "678"],
     ["550", "07", "340"],
  ],
};
export const DHARMMORNING = {
  "30/12/2025 to 05/01/2025": [
     ["589", "20", "190"],
     ["114", "65", "140"],
     ["290", "13", "689"],
     ["450", "97", "340"],
     ["450", "98", "189"],
     ["349", "68", "567"],
     ["130", "46", "367"],
  ],

  "06/01/2025 to 12/01/2025": [
     ["330", "61", "245"],
     ["330", "65", "177"],
     ["579", "15", "258"],
     ["499", "21", "380"],
     ["112", "42", "390"],
     ["789", "46", "169"],
     ["358", "67", "557"],
  ],
  "13/01/2025 to 19/01/2025": [
     ["228", "26", "268"],
     ["190", "04", "455"],
     ["480", "28", "558"],
     ["778", "29", "559"],
     ["244", "03", "337"],
     ["678", "16", "277"],
     ["167", "46", "358"],
  ],
  "20/01/2025 to 26/01/2025": [
     ["157", "32", "688"],
     ["666", "84", "770"],
     ["270", "90", "000"],
     ["589", "21", "146"],
     ["278", "77", "368"],
     ["233", "83", "229"],
     ["599", "31", "560"],
  ],
  "26/01/2025 to 01/02/2025": [
     ["344", "13", "580"],
     ["468", "84", "347"],
     ["568", "99", "360"],
     ["228", "29", "225"],
     ["899", "68", "369"],
     ["190", "04", "112"],
     ["568", "92", "336"],
  ],
  "02/02/2025 to 08/02/2025": [
     ["888", "47", "368"],
     ["280", "06", "240"],
     ["228", "23", "599"],
     ["369", "88", "350"],
     ["590", "44", "149"],
     ["568", "90", "578"],
     ["566", "70", "578"],
  ],
  "09/02/2025 to 15/02/2025": [
     ["116", "85", "500"],
     ["112", "43", "139"],
     ["345", "27", "458"],
     ["469", "98", "990"],
     ["270", "96", "457"],
     ["188", "79", "360"],
     ["670", "37", "179"],
  ],
  "16/02/2025 to 22/02/2025": [
     ["277", "63", "120"],
     ["228", "28", "350"],
     ["660", "27", "179"],
     ["222", "60", "488"],
     ["290", "10", "334"],
     ["159", "59", "379"],
     ["445", "38", "567"],
  ],
  "23/02/2025 to 01/03/2025": [
     ["333", "91", "470"],
     ["138", "23", "355"],
     ["258", "58", "990"],
     ["368", "79", "289"],
     ["790", "65", "339"],
     ["456", "52", "345"],
     ["235", "03", "120"],
  ],
  "02/03/2025 to 08/03/2025": [
     ["700", "71", "560"],
     ["128", "16", "880"],
     ["200", "20", "569"],
     ["400", "41", "128"],
     ["666", "89", "568"],
     ["149", "45", "258"],
     ["567", "86", "240"],
  ],
  "09/03/2025 to 15/03/2025": [
     ["158", "47", "269"],
     ["269", "76", "240"],
     ["177", "50", "488"],
     ["268", "66", "259"],
     ["233", "88", "567"],
     ["335", "11", "380"],
     ["356", "42", "589"],
  ],
  "16/03/2025 to 22/03/2025": [
     ["277", "63", "120"],
     ["228", "28", "350"],
     ["660", "27", "179"],
     ["222", "60", "488"],
     ["290", "10", "334"],
     ["159", "59", "379"],
     ["445", "38", "567"],
  ],
  "23/03/2025 to 30/03/2025": [
     ["238", "36", "259"],
     ["799", "50", "550"],
     ["990", "89", "333"],
     ["278", "73", "139"],
     ["336", "28", "459"],
     ["290", "11", "380"],
     ["357", "52", "237"],
  ],
};

export const VEDADAY = {
  "30/12/2024 to 05/01/2025": [
     ["255", "21", "227"],
     ["128", "19", "450"],
     ["137", "13", "166"],
     ["299", "09", "559"],
     ["169", "62", "688"],
     ["145", "07", "890"],
     ["446", "40", "280"],
  ],
  "06/01/2025 to 12/01/2025": [
     ["678", "17", "250"],
     ["390", "29", "388"],
     ["399", "17", "368"],
     ["377", "75", "366"],
     ["799", "50", "389"],
     ["259", "62", "129"],
     ["499", "22", "156"],
  ],
  "13/01/2025 to 19/01/2025": [
     ["688", "23", "355"],
     ["555", "55", "799"],
     ["566", "72", "200"],
     ["468", "87", "458"],
     ["689", "35", "249"],
     ["467", "71", "236"],
     ["234", "90", "127"],
  ],
  "20/01/2025 to 26/01/2025": [
     ["227", "11", "128"],
     ["125", "83", "139"],
     ["450", "99", "180"],
     ["566", "78", "224"],
     ["223", "78", "666"],
     ["157", "34", "167"],
     ["270", "93", "247"],
  ],
  "27/01/2025 to 02/02/2025": [
     ["223", "76", "114"],
     ["889", "57", "188"],
     ["477", "89", "117"],
     ["560", "10", "118"],
     ["259", "68", "567"],
     ["678", "14", "220"],
     ["150", "66", "899"],
  ],
  "03/02/2025 to 09/02/2025": [
     ["168", "53", "788"],
     ["269", "75", "500"],
     ["900", "91", "137"],
     ["120", "32", "246"],
     ["469", "99", "180"],
     ["778", "20", "226"],
     ["350", "82", "138"],
  ],
  "10/02/2025 to 16/02/2025": [
     ["111", "39", "333"],
     ["245", "10", "280"],
     ["447", "53", "120"],
     ["788", "32", "138"],
     ["346", "39", "289"],
     ["238", "37", "890"],
     ["478", "95", "159"],
  ],
  "17/02/2025 to 23/02/2025": [
     ["557", "72", "200"],
     ["888", "46", "114"],
     ["790", "62", "660"],
     ["470", "10", "136"],
     ["460", "01", "588"],
     ["138", "23", "355"],
     ["400", "46", "268"],
  ],
  "24/02/2025 to 02/03/2025": [
     ["257", "43", "670"],
     ["339", "56", "123"],
     ["268", "65", "168"],
     ["240", "61", "227"],
     ["356", "45", "500"],
     ["268", "61", "560"],
     ["220", "45", "258"],
  ],
  "03/03/2025 to 09/03/2025": [
     ["257", "46", "880"],
     ["259", "69", "478"],
     ["127", "05", "249"],
     ["167", "42", "589"],
     ["490", "39", "667"],
     ["445", "39", "144"],
     ["330", "69", "577"],
  ],
  "10/03/2025 to 16/03/2025": [
     ["158", "48", "369"],
     ["800", "87", "179"],
     ["346", "38", "134"],
     ["450", "95", "447"],
     ["277", "64", "888"],
     ["348", "56", "880"],
     ["122", "58", "189"],
  ],
  "17/03/2025 to 23/03/2025": [
     ["288", "84", "699"],
     ["599", "30", "190"],
     ["144", "95", "122"],
     ["557", "73", "148"],
     ["556", "63", "139"],
     ["447", "59", "117"],
     ["555", "57", "467"],
  ],
  "24/03/2025 to 30/03/2025": [
     ["670", "31", "489"],
     ["335", "17", "467"],
     ["115", "70", "334"],
     ["666", "82", "255"],
     ["444", "21", "579"],
     ["455", "43", "238"],
     ["770", "40", "118"],
  ],
};
export const YUGDAY = {
  "30/12/2024 to 05/01/2025": [
     ["133", "70", "370"],
     ["368", "76", "178"],
     ["189", "87", "133"],
     ["889", "58", "666"],
     ["227", "13", "580"],
     ["190", "09", "270"],
     ["350", "87", "124"],
  ],

  "30/12/2024 to 05/01/2025": [
     ["133", "70", "370"],
     ["368", "76", "178"],
     ["189", "87", "133"],
     ["889", "58", "666"],
     ["227", "13", "580"],
     ["190", "09", "270"],
     ["350", "87", "124"],
  ],
  "06/01/2025 to 12/01/2025": [
     ["257", "46", "880"],
     ["259", "69", "478"],
     ["127", "05", "249"],
     ["167", "42", "589"],
     ["490", "39", "667"],
     ["445", "39", "144"],
     ["330", "69", "577"],
  ],
  "13/01/2025 to 19/01/2025": [
     ["158", "48", "369"],
     ["800", "87", "179"],
     ["346", "38", "134"],
     ["450", "95", "447"],
     ["277", "64", "888"],
     ["348", "56", "880"],
     ["122", "58", "189"],
  ],
  "20/01/2025 to 26/01/2025": [
     ["288", "84", "699"],
     ["599", "30", "190"],
     ["144", "95", "122"],
     ["557", "73", "148"],
     ["556", "63", "139"],
     ["447", "59", "117"],
     ["555", "57", "467"],
  ],
  "27/01/2025 to 02/02/2025": [
     ["670", "31", "489"],
     ["335", "17", "467"],
     ["115", "70", "334"],
     ["666", "82", "255"],
     ["444", "21", "579"],
     ["455", "43", "238"],
     ["770", "40", "118"],
  ],
  "03/02/2025 to 09/02/2025": [
     ["269", "70", "299"],
     ["139", "35", "690"],
     ["359", "78", "567"],
     ["118", "08", "800"],
     ["349", "60", "226"],
     ["148", "31", "669"],
     ["480", "29", "199"],
  ],
  "10/02/2025 to 16/02/2025": [
     ["190", "05", "500"],
     ["455", "49", "667"],
     ["789", "47", "700"],
     ["446", "47", "269"],
     ["118", "09", "117"],
     ["139", "39", "180"],
     ["690", "51", "119"],
  ],
  "17/02/2025 to 23/02/2025": [
     ["467", "70", "145"],
     ["259", "61", "146"],
     ["299", "05", "230"],
     ["267", "55", "456"],
     ["220", "49", "270"],
     ["135", "95", "456"],
     ["399", "18", "369"],
  ],
  "24/02/2025 to 02/03/2025": [
     ["235", "03", "490"],
     ["133", "72", "255"],
     ["358", "65", "780"],
     ["478", "99", "135"],
     ["899", "64", "257"],
     ["880", "66", "556"],
     ["566", "74", "130"],
  ],
  "03/03/2025 to 09/03/2025": [
     ["457", "60", "569"],
     ["245", "14", "347"],
     ["135", "98", "378"],
     ["470", "17", "188"],
     ["679", "23", "139"],
     ["360", "90", "479"],
     ["160", "79", "126"],
  ],
  "10/03/2025 to 16/03/2025": [
     ["688", "20", "488"],
     ["159", "50", "569"],
     ["990", "81", "579"],
     ["338", "41", "155"],
     ["590", "49", "379"],
     ["127", "04", "347"],
     ["450", "91", "335"],
  ],
  "17/03/2025 to 23/03/2025": [
     ["269", "70", "235"],
     ["350", "87", "449"],
     ["577", "94", "158"],
     ["279", "82", "138"],
     ["270", "92", "570"],
     ["567", "87", "269"],
     ["229", "39", "126"],
  ],
  "24/03/2025 to 30/03/2025": [
     ["579", "13", "346"],
     ["199", "91", "588"],
     ["225", "91", "380"],
     ["156", "28", "134"],
     ["689", "39", "289"],
     ["457", "69", "568"],
     ["279", "82", "138"],
  ],
};
export const DHARMDAY = {
  "30/12/2024 to 05/01/2025": [
     ["225", "91", "380"],
     ["156", "28", "134"],
     ["149", "46", "790"],
     ["149", "40", "578"],
     ["338", "40", "299"],
     ["557", "74", "167"],
     ["289", "95", "348"],
  ],
  "06/01/2025 to 12/01/2025": [
     ["300", "38", "134"],
     ["388", "95", "339"],
     ["247", "38", "378"],
     ["499", "20", "118"],
     ["499", "21", "579"],
     ["125", "87", "377"],
     ["678", "16", "114"],
  ],
  "13/01/2025 to 19/01/2025": [
     ["149", "40", "127"],
     ["277", "63", "229"],
     ["450", "96", "457"],
     ["148", "38", "459"],
     ["399", "12", "255"],
     ["224", "81", "146"],
     ["377", "79", "478"],
  ],
  "20/01/2025 to 26/01/2025": [
     ["800", "80", "569"],
     ["369", "89", "126"],
     ["469", "99", "289"],
     ["290", "12", "336"],
     ["289", "94", "149"],
     ["379", "94", "130"],
     ["170", "84", "149"],
  ],
  "27/01/2025 to 02/02/2025": [
     ["479", "03", "238"],
     ["167", "41", "100"],
     ["668", "07", "250"],
     ["290", "16", "367"],
     ["199", "93", "157"],
     ["478", "96", "178"],
     ["370", "08", "125"],
  ],
  "03/02/2025 to 09/02/2025": [
     ["139", "31", "470"],
     ["368", "71", "579"],
     ["169", "63", "139"],
     ["390", "24", "257"],
     ["169", "64", "590"],
     ["389", "07", "566"],
     ["246", "27", "269"],
  ],
  "10/02/2025 to 16/02/2025": [
     ["256", "35", "159"],
     ["560", "10", "370"],
     ["189", "82", "589"],
     ["357", "51", "146"],
     ["259", "66", "150"],
     ["170", "80", "136"],
     ["400", "43", "355"],
  ],
  "17/02/2025 to 23/02/2025": [
     ["229", "32", "255"],
     ["558", "82", "237"],
     ["580", "32", "147"],
     ["246", "20", "235"],
     ["699", "45", "339"],
     ["123", "68", "459"],
     ["489", "19", "379"],
  ],
  "24/02/2025 to 02/03/2025": [
     ["269", "71", "137"],
     ["458", "75", "799"],
     ["368", "70", "578"],
     ["116", "80", "479"],
     ["233", "83", "599"],
     ["146", "12", "129"],
     ["679", "21", "155"],
  ],
  "03/03/2025 to 09/03/2025": [
     ["139", "37", "449"],
     ["890", "79", "469"],
     ["370", "00", "190"],
     ["680", "41", "678"],
     ["588", "11", "470"],
     ["388", "97", "449"],
     ["136", "02", "138"],
  ],
  "10/03/2025 to 16/03/2025": [
     ["159", "51", "245"],
     ["136", "03", "157"],
     ["379", "91", "489"],
     ["788", "31", "380"],
     ["270", "92", "345"],
     ["138", "22", "156"],
     ["256", "39", "135"],
  ],
  "17/03/2025 to 23/03/2025": [
     ["258", "59", "135"],
     ["349", "64", "257"],
     ["449", "71", "227"],
     ["240", "65", "168"],
     ["477", "82", "156"],
     ["330", "66", "178"],
     ["489", "17", "124"],
  ],
  "24/03/2025 to 30/03/2025": [
     ["500", "57", "458"],
     ["348", "58", "116"],
     ["580", "32", "147"],
     ["489", "17", "124"],
     ["449", "71", "227"],
     ["349", "64", "257"],
     ["138", "22", "156"],
  ],
};

export const VEDANIGHT = {
  "30/12/2024 to 05/01/2025": [
     ["156", "28", "134"],
     ["289", "95", "348"],
     ["149", "40", "578"],
     ["149", "46", "790"],
     ["338", "40", "299"],
     ["557", "74", "167"],
     ["225", "91", "380"],
  ],
  "06/01/2025 to 12/01/2025": [
     ["236", "15", "447"],
     ["580", "31", "335"],
     ["667", "92", "156"],
     ["188", "74", "149"],
     ["688", "29", "388"],
     ["117", "92", "345"],
     ["134", "82", "129"],
  ],
  "13/01/2025 to 19/01/2025": [
     ["160", "76", "367"],
     ["459", "82", "589"],
     ["700", "79", "289"],
     ["180", "96", "330"],
     ["337", "30", "280"],
     ["158", "43", "779"],
     ["460", "00", "479"],
  ],
  "20/01/2025 to 26/01/2025": [
     ["190", "07", "179"],
     ["177", "59", "135"],
     ["490", "37", "124"],
     ["126", "93", "599"],
     ["279", "80", "136"],
     ["580", "33", "689"],
     ["670", "38", "170"],
  ],
  "27/01/2025 to 02/02/2025": [
     ["236", "15", "447"],
     ["580", "31", "335"],
     ["667", "92", "156"],
     ["188", "74", "149"],
     ["688", "29", "388"],
     ["117", "92", "345"],
     ["134", "82", "129"],
  ],
  "03/02/2025 to 09/02/2025": [
     ["160", "76", "367"],
     ["459", "82", "589"],
     ["700", "79", "289"],
     ["180", "96", "330"],
     ["337", "30", "280"],
     ["158", "43", "779"],
     ["460", "0", "479"],
  ],
  "10/02/2025 to 16/02/2025": [
     ["146", "11", "344"],
     ["459", "80", "569"],
     ["126", "97", "278"],
     ["277", "61", "399"],
     ["158", "41", "678"],
     ["126", "90", "145"],
     ["160", "72", "345"],
  ],
  "17/02/2025 to 23/02/2025": [
     ["149", "43", "346"],
     ["157", "32", "129"],
     ["378", "85", "159"],
     ["478", "93", "157"],
     ["460", "09", "379"],
     ["700", "78", "260"],
     ["488", "03", "445"],
  ],
  "24/02/2025 to 02/03/2025": [
     ["360", "95", "889"],
     ["239", "45", "249"],
     ["280", "06", "349"],
     ["169", "61", "489"],
     ["247", "36", "790"],
     ["238", "36", "259"],
     ["459", "85", "168"],
  ],
  "03/03/2025 to 09/03/2025": [
     ["245", "15", "555"],
     ["235", "02", "138"],
     ["240", "69", "135"],
     ["279", "85", "177"],
     ["138", "20", "190"],
     ["356", "46", "259"],
     ["350", "81", "678"],
  ],
  "10/03/2025 to 16/03/2025": [
     ["446", "42", "589"],
     ["290", "14", "257"],
     ["268", "62", "499"],
     ["580", "32", "129"],
     ["280", "00", "479"],
     ["259", "68", "279"],
     ["457", "66", "222"],
  ],
  "17/03/2025 to 23/03/2025": [
     ["578", "08", "260"],
     ["277", "62", "255"],
     ["339", "56", "358"],
     ["112", "46", "349"],
     ["336", "29", "289"],
     ["259", "64", "239"],
     ["469", "92", "688"],
  ],
  "24/03/2025 to 30/03/2025": [
     ["680", "45", "122"],
     ["380", "19", "135"],
     ["348", "59", "478"],
     ["568", "98", "378"],
     ["247", "32", "589"],
     ["158", "45", "348"],
     ["167", "43", "490"],
  ],
};
export const YUGNIGHT = {
  "30/12/2024 to 05/01/2025": [
     ["148", "32", "138"],
     ["678", "17", "160"],
     ["569", "06", "114"],
     ["250", "78", "170"],
     ["556", "63", "256"],
     ["118", "00", "136"],
     ["190", "02", "156"],
  ],
  "06/01/2025 to 12/01/2025": [
     ["147", "25", "690"],
     ["179", "79", "135"],
     ["379", "90", "127"],
     ["236", "13", "580"],
     ["150", "60", "334"],
     ["126", "96", "880"],
     ["700", "78", "134"],
  ],
  "13/01/2025 to 19/01/2025": [
     ["110", "25", "366"],
     ["244", "01", "579"],
     ["250", "74", "347"],
     ["277", "63", "120"],
     ["258", "59", "180"],
     ["789", "42", "228"],
     ["699", "46", "457"],
  ],
  "20/01/2025 to 26/01/2025": [
     ["447", "50", "136"],
     ["247", "33", "355"],
     ["469", "96", "466"],
     ["129", "26", "358"],
     ["168", "50", "460"],
     ["500", "55", "230"],
     ["679", "29", "126"],
  ],
  "27/01/2025 to 02/02/2025": [
     ["580", "37", "467"],
     ["668", "00", "578"],
     ["147", "20", "389"],
     ["788", "35", "367"],
     ["330", "66", "123"],
     ["359", "72", "570"],
     ["366", "54", "149"],
  ],
  "03/02/2025 to 09/02/2025": [
     ["135", "90", "190"],
     ["124", "71", "128"],
     ["558", "86", "114"],
     ["455", "40", "226"],
     ["239", "44", "338"],
     ["346", "37", "250"],
     ["500", "56", "880"],
  ],
  "10/02/2025 to 16/02/2025": [
     ["140", "57", "890"],
     ["379", "90", "145"],
     ["139", "35", "159"],
     ["259", "62", "228"],
     ["446", "40", "235"],
     ["689", "31", "128"],
     ["145", "09", "144"],
  ],
  "17/02/2025 to 23/02/2025": [
     ["124", "70", "190"],
     ["248", "48", "170"],
     ["138", "22", "156"],
     ["240", "67", "269"],
     ["235", "09", "478"],
     ["550", "00", "280"],
     ["199", "99", "450"],
  ],
  "24/02/2025 to 02/03/2025": [
     ["278", "76", "367"],
     ["688", "28", "116"],
     ["780", "56", "268"],
     ["189", "80", "226"],
     ["579", "12", "138"],
     ["178", "60", "235"],
     ["690", "51", "678"],
  ],
  "03/03/2025 to 09/03/2025": [
     ["125", "89", "144"],
     ["257", "41", "344"],
     ["118", "06", "358"],
     ["117", "90", "244"],
     ["135", "91", "137"],
     ["799", "56", "240"],
     ["288", "88", "666"],
  ],
  "10/03/2025 to 16/03/2025": [
     ["110", "23", "490"],
     ["778", "29", "577"],
     ["567", "88", "125"],
     ["156", "25", "348"],
     ["459", "88", "170"],
     ["235", "07", "124"],
     ["299", "02", "480"],
  ],
  "17/03/2025 to 23/03/2025": [
     ["669", "19", "388"],
     ["478", "99", "117"],
     ["560", "15", "690"],
     ["379", "97", "160"],
     ["689", "30", "127"],
     ["890", "77", "160"],
     ["134", "86", "457"],
  ],
  "24/03/2025 to 30/03/2025": [
     ["560", "16", "349"],
     ["237", "27", "269"],
     ["348", "55", "230"],
     ["149", "47", "179"],
     ["689", "34", "248"],
     ["890", "78", "189"],
     ["228", "26", "268"]
  ]
};
export const DHARMNIGHT = {

  "30/12/2024 to 05/01/2025": [
     ["560", "16", "349"],
     ["237", "27", "269"],
     ["348", "55", "230"],
     ["149", "47", "179"],
     ["689", "34", "248"],
     ["890", "78", "189"],
     ["228", "26", "268"]
  ],
  "06/01/2025 to 12/01/2025": [
     ["268", "65", "267"],
     ["238", "31", "399"],
     ["147", "24", "680"],
     ["137", "16", "178"],
     ["567", "81", "335"],
     ["578", "06", "277"],
     ["478", "99", "289"]
  ],
  "13/01/2025 to 19/01/2025": [
     ["146", "12", "228"],
     ["167", "43", "148"],
     ["559", "90", "190"],
     ["159", "54", "239"],
     ["145", "07", "124"],
     ["134", "86", "114"],
     ["359", "71", "579"]
  ],
  "20/01/2025 to 26/01/2025": [
     ["130", "40", "127"],
     ["119", "15", "140"],
     ["166", "33", "238"],
     ["390", "28", "279"],
     ["240", "61", "236"],
     ["199", "93", "229"],
     ["668", "04", "590"]
  ],
  "27/01/2025 to 02/02/2025": [
     ["179", "73", "157"],
     ["135", "93", "599"],
     ["159", "57", "449"],
     ["125", "80", "136"],
     ["679", "28", "378"],
     ["558", "89", "180"],
     ["600", "62", "345"]
  ],
  "03/02/2025 to 09/02/2025": [
     ["479", "06", "457"],
     ["146", "19", "270"],
     ["139", "34", "149"],
     ["477", "84", "266"],
     ["178", "61", "380"],
     ["228", "20", "127"],
     ["490", "37", "890"]
  ],
  "10/02/2025 to 16/02/2025": [
     ["113", "50", "226"],
     ["248", "42", "129"],
     ["137", "15", "159"],
     ["379", "90", "136"],
     ["588", "10", "677"],
     ["689", "31", "236"],
     ["559", "95", "249"]
  ],
  "17/02/2025 to 23/02/2025": [
     ["246", "21", "344"],
     ["144", "91", "236"],
     ["330", "61", "119"],
     ["245", "19", "126"],
     ["135", "96", "457"],
     ["367", "64", "149"],
     ["570", "29", "360"]
  ],
  "24/02/2025 to 02/03/2025": [
     ["146", "12", "156"],
     ["466", "69", "117"],
     ["680", "43", "337"],
     ["279", "86", "457"],
     ["168", "51", "245"],
     ["660", "28", "800"],
     ["118", "08", "233"]
  ],
  "03/03/2025 to 09/04/2025": [
     ["490", "31", "579"],
     ["233", "85", "348"],
     ["390", "20", "479"],
     ["448", "60", "190"],
     ["130", "48", "558"],
     ["389", "07", "368"],
     ["499", "25", "168"]
  ],
  "20/01/2025 to 26/01/2025": [
     ["278", "76", "367"],
     ["688", "28", "116"],
     ["780", "56", "268"],
     ["189", "80", "226"],
     ["579", "12", "138"],
     ["178", "60", "235"],
     ["690", "51", "678"]
  ],
  "27/01/2025 to 02/02/2025": [
     ["124", "70", "190"],
     ["248", "48", "170"],
     ["138", "22", "156"],
     ["240", "67", "269"],
     ["235", "09", "478"],
     ["550", "00", "280"],
     ["199", "99", "450"]
  ],
  "03/02/2025 to 09/02/2025": [
     ["140", "57", "890"],
     ["379", "90", "145"],
     ["139", "35", "159"],
     ["259", "62", "228"],
     ["446", "40", "235"],
     ["689", "31", "128"],
     ["145", "09", "144"]
  ],
  "10/03/2025 to 16/03/2025": [
     ["268", "65", "267"],
     ["238", "31", "399"],
     ["147", "24", "680"],
     ["137", "16", "178"],
     ["567", "81", "335"],
     ["578", "06", "277"],
     ["478", "99", "289"]
  ],
  "17/03/2025 to 23/03/2025": [
     ["146", "12", "228"],
     ["167", "43", "148"],
     ["559", "90", "190"],
     ["159", "54", "239"],
     ["145", "07", "124"],
     ["134", "86", "114"],
     ["359", "71", "579"]
  ],
  "24/03/2025 to 30/03/2025": [
     ["130", "40", "127"],
     ["119", "15", "140"],
     ["166", "33", "238"],
     ["390", "28", "279"],
     ["240", "61", "236"],
     ["199", "93", "229"],
     ["668", "04", "590"]
  ],
};
